import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  JSON: { input: any; output: any; }
  LabelAndCode: { input: any; output: any; }
  LatLng: { input: any; output: any; }
  MongoSortQuery: { input: any; output: any; }
  ObjectId: { input: string; output: string; }
};

export type AccountData = {
  __typename?: 'AccountData';
  account?: Maybe<Scalars['String']['output']>;
  accountDigit?: Maybe<Scalars['String']['output']>;
  agency?: Maybe<Scalars['String']['output']>;
  agencyDigit?: Maybe<Scalars['String']['output']>;
  bank?: Maybe<Scalars['String']['output']>;
  bankId?: Maybe<Scalars['ObjectId']['output']>;
};

export type AddObjectListItemResponse = {
  __typename?: 'AddObjectListItemResponse';
  newItem: FormFieldV2;
  updates: Array<FieldUpdateResponseV2>;
};

export type Address = {
  __typename?: 'Address';
  cep?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  complement?: Maybe<Scalars['String']['output']>;
  neighborhood?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type AllianzSettings = {
  __typename?: 'AllianzSettings';
  coberturas: Array<FormInputOptions>;
  codigoCultivar: FormInputOptions;
  codigoNivelCobertura: FormInputOptions;
  corte?: Maybe<FormInputOptions>;
  cultura: FormInputOptions;
  culturaAnterior: FormInputOptions;
  custeioProvenienteCreditoRurual: FormInputOptions;
  custoEstimado?: Maybe<Scalars['Float']['output']>;
  formaPagamento: FormInputOptions;
  franquia: FormInputOptions;
  grupoCultivar: FormInputOptions;
  percentualComissao: Scalars['Float']['output'];
  percentualDesconto: Scalars['Float']['output'];
  percentualProdutividadeEstimada: FormInputOptions;
  quantidadeParcelas: Scalars['Float']['output'];
  realizadoControleFitosantitario: FormInputOptions;
  regulacaoSinistro: FormInputOptions;
  tecnicaPlantio: FormInputOptions;
  texturaSolo: FormInputOptions;
  tipoProduto: FormInputOptions;
  valorSaca?: Maybe<FormInputOptions>;
};

export enum BasicCoverageTypes {
  Custeio = 'custeio',
  Parametrico = 'parametrico',
  Produtividade = 'produtividade',
  RiscoNomeado = 'risco_nomeado'
}

export type CategoryDashboardCounters = {
  __typename?: 'CategoryDashboardCounters';
  count: Scalars['Int']['output'];
  statuses?: Maybe<Array<StatusDashboardCounters>>;
  value: Scalars['String']['output'];
};

export enum CivilStates {
  Divorced = 'divorced',
  Married = 'married',
  Other = 'other',
  Single = 'single',
  Widowed = 'widowed'
}

export type Claim = {
  __typename?: 'Claim';
  _id: Scalars['ObjectId']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  contestationLetterFile?: Maybe<File>;
  contestationLetterFileUploadDate?: Maybe<Scalars['Date']['output']>;
  contestationProtocolNumber?: Maybe<Scalars['Float']['output']>;
  coverages: Array<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  dateOfReanalysis?: Maybe<Scalars['Date']['output']>;
  documentId: Scalars['ObjectId']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  estimatedIndemnity?: Maybe<Scalars['Float']['output']>;
  events: Array<ClaimEvent>;
  externalId: Scalars['String']['output'];
  harvestEndDateLetterFile?: Maybe<File>;
  harvestEndDateSignedLetterFile?: Maybe<File>;
  harvestStartDateLetterFile?: Maybe<File>;
  harvestStartDateSignedLetterFile?: Maybe<File>;
  indemnityAmount?: Maybe<Scalars['Float']['output']>;
  indemnityPaymentDate?: Maybe<Scalars['Date']['output']>;
  lossEstimate: LossEstimate;
  name: Scalars['String']['output'];
  noticeDate: Scalars['Date']['output'];
  plots?: Maybe<Array<Scalars['String']['output']>>;
  protocolNumber?: Maybe<Scalars['String']['output']>;
  reportFile?: Maybe<File>;
  reportFileUploadDate?: Maybe<Scalars['Date']['output']>;
  startDate: Scalars['Date']['output'];
  status: ClaimStatus;
};

export enum ClaimEvent {
  ColdWinds = 'coldWinds',
  Drought = 'drought',
  Fire = 'fire',
  Frost = 'frost',
  Hail = 'hail',
  Inundation = 'inundation',
  Lightning = 'lightning',
  Rain = 'rain',
  TemperatureVariation = 'temperatureVariation',
  Waterspout = 'waterspout',
  Wind = 'wind'
}

export enum ClaimStatus {
  Approved = 'approved',
  Contested = 'contested',
  Open = 'open',
  Paid = 'paid',
  Pending = 'pending',
  Rejected = 'rejected'
}

export type ClaimsFiltersInput = {
  contactId: Scalars['String']['input'];
};

export type Contact = {
  __typename?: 'Contact';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  address?: Maybe<Address>;
  addressProofFile?: Maybe<File>;
  birthDate?: Maybe<Scalars['Date']['output']>;
  cities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  civilState?: Maybe<CivilStates>;
  comments?: Maybe<Scalars['String']['output']>;
  commission?: Maybe<Scalars['Float']['output']>;
  cpfCnpj?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cultureIds?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>;
  departmentRole?: Maybe<OrgDepartmentRoles>;
  documentFile?: Maybe<File>;
  email?: Maybe<Scalars['String']['output']>;
  emissionInstitution?: Maybe<Scalars['String']['output']>;
  emissionInstitutionId?: Maybe<Scalars['ObjectId']['output']>;
  expeditionDate?: Maybe<Scalars['Date']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  industry?: Maybe<OrgIndustries>;
  meetings?: Maybe<Array<Meeting>>;
  members?: Maybe<Array<Contact>>;
  membershipCount?: Maybe<OrgMembershipCount>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  operationalArea?: Maybe<OrgOperationalArea>;
  orgId?: Maybe<Scalars['ObjectId']['output']>;
  originatorId?: Maybe<Scalars['ObjectId']['output']>;
  parent?: Maybe<Contact>;
  parentId?: Maybe<Scalars['ObjectId']['output']>;
  parentRelation?: Maybe<Scalars['String']['output']>;
  profession?: Maybe<Scalars['String']['output']>;
  professionId?: Maybe<Scalars['ObjectId']['output']>;
  rating?: Maybe<RatingScale>;
  responsible?: Maybe<User>;
  responsibleId?: Maybe<Scalars['ObjectId']['output']>;
  rg?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  status?: Maybe<UserStatus>;
  subsidiariesCount?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<ContactTags>>;
  twilioConversationId?: Maybe<Scalars['ObjectId']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ObjectId']['output']>;
};

export enum ContactTags {
  Admin = 'admin',
  AllowedPerson = 'allowedPerson',
  Beneficiary = 'beneficiary',
  Consultant = 'consultant',
  Farmer = 'farmer',
  Inspector = 'inspector',
  Lead = 'lead',
  OrgAdmin = 'orgAdmin',
  OrgMember = 'orgMember',
  Organization = 'organization',
  PaymentResponsible = 'paymentResponsible'
}

export type ContactsFiltersInput = {
  parentId?: InputMaybe<Scalars['String']['input']>;
  responsibleId?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
  tags?: InputMaybe<ContactTags>;
};

export type ConversationUpdated = {
  __typename?: 'ConversationUpdated';
  conversationId: Scalars['String']['output'];
  newMsg: Scalars['Boolean']['output'];
};

export type ConversationsFilterInput = {
  onlySubscribeds: Scalars['Boolean']['input'];
};

export type CoverageEvent = {
  __typename?: 'CoverageEvent';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  name: Scalars['String']['output'];
};

export enum CoverageTags {
  Additional = 'additional',
  Basic = 'basic',
  Fire = 'fire',
  Frost = 'frost',
  Hail = 'hail',
  PhytosanitaryTreatment = 'phytosanitary_treatment',
  PlantLife = 'plant_life',
  ProductionLoss = 'production_loss',
  Wind = 'wind'
}

export type Coverages = {
  __typename?: 'Coverages';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  insuranceTypes?: Maybe<Array<Maybe<InsuranceType>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Crop = {
  __typename?: 'Crop';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  area?: Maybe<Scalars['Float']['output']>;
  compositionType?: Maybe<Scalars['LabelAndCode']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cropYear?: Maybe<Scalars['String']['output']>;
  culture?: Maybe<Culture>;
  cultureDetail?: Maybe<CultureDetail>;
  cultureDetailId?: Maybe<Scalars['ObjectId']['output']>;
  cultureId?: Maybe<Scalars['ObjectId']['output']>;
  cultureName?: Maybe<Scalars['String']['output']>;
  harvestEndDate?: Maybe<Scalars['Date']['output']>;
  harvestEndDateLetterFile?: Maybe<File>;
  harvestEndDateSignedLetterFile?: Maybe<File>;
  harvestStartDate?: Maybe<Scalars['Date']['output']>;
  harvestStartDateLetterFile?: Maybe<File>;
  harvestStartDateSignedLetterFile?: Maybe<File>;
  kmlFile?: Maybe<File>;
  manualCulture?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  plantDate?: Maybe<Scalars['Date']['output']>;
  plots?: Maybe<Array<Plot>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CropInsuranceQuestions = {
  __typename?: 'CropInsuranceQuestions';
  federalSubvention?: Maybe<Scalars['Boolean']['output']>;
  firstCrop?: Maybe<Scalars['Boolean']['output']>;
  isPlanted?: Maybe<Scalars['Boolean']['output']>;
  nightIrrigation?: Maybe<Scalars['Boolean']['output']>;
  organicCulture?: Maybe<Scalars['Boolean']['output']>;
  otherInsurances?: Maybe<Scalars['Boolean']['output']>;
  pronampBeneficiary?: Maybe<Scalars['Boolean']['output']>;
  recentIncident?: Maybe<Scalars['Boolean']['output']>;
  stateSubvention?: Maybe<Scalars['Boolean']['output']>;
  withSubvention?: Maybe<Scalars['Boolean']['output']>;
  zarcPolicy?: Maybe<Scalars['Boolean']['output']>;
};

export type Culture = {
  __typename?: 'Culture';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  allianzSettings?: Maybe<Array<IntegrationSettings>>;
  codMapfre?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  currentSackValue?: Maybe<Scalars['Float']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  insuranceType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CultureDetail = {
  __typename?: 'CultureDetail';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  codMapfre?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  culture?: Maybe<Culture>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum DashboardFunnelDateRange {
  Month = 'month',
  Week = 'week',
  Year = 'year'
}

export type DashboardFunnelValue = {
  __typename?: 'DashboardFunnelValue';
  category: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export enum DocumentClaimStatus {
  Closed = 'closed',
  Open = 'open'
}

export type DocumentEquipment = {
  __typename?: 'DocumentEquipment';
  equipment?: Maybe<Equipment>;
  equipmentId: Scalars['ObjectId']['output'];
  hasTheftCoverage?: Maybe<Scalars['Boolean']['output']>;
  isFinanced?: Maybe<Scalars['Boolean']['output']>;
  isLeased?: Maybe<Scalars['Boolean']['output']>;
  isNearWater?: Maybe<Scalars['Boolean']['output']>;
  isNewEquipment?: Maybe<Scalars['Boolean']['output']>;
  isRenewal?: Maybe<Scalars['Boolean']['output']>;
  marketValue?: Maybe<Scalars['Float']['output']>;
  previousProvider?: Maybe<PropostaProviders>;
  serialNumberMatch?: Maybe<Scalars['Boolean']['output']>;
};

export type DocumentReject = {
  __typename?: 'DocumentReject';
  other?: Maybe<Scalars['String']['output']>;
  rejectReason: DocumentRejectReason;
};

export enum DocumentRejectReason {
  ContactLost = 'contactLost',
  NotAvailable = 'notAvailable',
  Other = 'other',
  OutOfCoveragePeriod = 'outOfCoveragePeriod',
  PriceTooHigh = 'priceTooHigh'
}

export enum DocumentStages {
  Policy = 'policy',
  Proposal = 'proposal',
  Quotation = 'quotation',
  Simulation = 'simulation'
}

export enum DocumentStatus {
  Cancelled = 'cancelled',
  Done = 'done',
  Effective = 'effective',
  Incomplete = 'incomplete',
  NonEffective = 'nonEffective',
  Pending = 'pending',
  Rejected = 'rejected',
  Sent = 'sent',
  UnderAnalysis = 'underAnalysis'
}

export type DocumentsFilterInput = {
  anyContactId?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  claimStatus?: InputMaybe<Scalars['String']['input']>;
  cultureId?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['JSON']['input']>;
  insuranceTypeGroup?: InputMaybe<Scalars['String']['input']>;
  originatorId?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  responsibleId?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type Endorsement = {
  __typename?: 'Endorsement';
  _id: Scalars['ObjectId']['output'];
  answerDate?: Maybe<Scalars['Date']['output']>;
  consentFile?: Maybe<File>;
  description: Scalars['String']['output'];
  documentId: Scalars['ObjectId']['output'];
  endorsementFile?: Maybe<File>;
  externalId: Scalars['String']['output'];
  otherReason?: Maybe<Scalars['String']['output']>;
  reason: EndorsementReason;
  rejectionFile?: Maybe<File>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  status: EndorsementStatus;
};

export enum EndorsementReason {
  ChangeOfBankingAddress = 'changeOfBankingAddress',
  ChangeOfBeneficiary = 'changeOfBeneficiary',
  ChangeOfCarData = 'changeOfCARData',
  ChangeOfCulture = 'changeOfCulture',
  ChangeOfName = 'changeOfName',
  ChangeOfPhone = 'changeOfPhone',
  ChangeOfSoilType = 'changeOfSoilType',
  Other = 'other',
  PolicyCancellation = 'policyCancellation'
}

export enum EndorsementStatus {
  Approved = 'approved',
  Pending = 'pending',
  Rejected = 'rejected'
}

export type Equipment = {
  __typename?: 'Equipment';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  brandId: Scalars['ObjectId']['output'];
  manualBrand?: Maybe<Scalars['String']['output']>;
  manualType?: Maybe<Scalars['String']['output']>;
  manufactureYear: Scalars['Float']['output'];
  marketValue?: Maybe<Scalars['Float']['output']>;
  model: Scalars['String']['output'];
  name: Scalars['String']['output'];
  ownerId: Scalars['ObjectId']['output'];
  property?: Maybe<Property>;
  propertyId: Scalars['ObjectId']['output'];
  type?: Maybe<Scalars['String']['output']>;
  typeId: Scalars['ObjectId']['output'];
};

export type EquipmentBrand = {
  __typename?: 'EquipmentBrand';
  _id: Scalars['ObjectId']['output'];
  isGeneric?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type EquipmentType = {
  __typename?: 'EquipmentType';
  _id: Scalars['ObjectId']['output'];
  isGeneric?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export enum Errors {
  PrismaValidationError = 'prismaValidationError'
}

export type FieldUpdateResponse = {
  __typename?: 'FieldUpdateResponse';
  error?: Maybe<Scalars['String']['output']>;
  fieldPath: Scalars['String']['output'];
  invisible?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<Maybe<FormDataOptions>>>;
  required?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['JSON']['output']>;
};

export type FieldUpdateResponseV2 = {
  __typename?: 'FieldUpdateResponseV2';
  domain?: Maybe<Scalars['JSON']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  fieldPath: Scalars['String']['output'];
  invisible?: Maybe<Scalars['JSON']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Scalars['JSON']['output']>;
  required?: Maybe<Scalars['JSON']['output']>;
  value?: Maybe<Scalars['JSON']['output']>;
};

export type File = {
  __typename?: 'File';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  fileKey?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
};

export type ForestItem = {
  __typename?: 'ForestItem';
  area: Scalars['Float']['output'];
  harvestCycleDuration: Scalars['Float']['output'];
  management: ForestManagement;
  managementId: Scalars['ObjectId']['output'];
  plantYear?: Maybe<Scalars['Int']['output']>;
  property: Property;
  propertyId: Scalars['ObjectId']['output'];
  species: ForestSpecies;
  speciesId: Scalars['ObjectId']['output'];
};

export type ForestManagement = {
  __typename?: 'ForestManagement';
  name: Scalars['String']['output'];
};

export type ForestSpecies = {
  __typename?: 'ForestSpecies';
  name: Scalars['String']['output'];
};

export type FormDataOptions = {
  __typename?: 'FormDataOptions';
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
  warning?: Maybe<Scalars['String']['output']>;
};

export type FormFieldV2 = {
  __typename?: 'FormFieldV2';
  accept?: Maybe<Scalars['String']['output']>;
  allowAdd?: Maybe<Scalars['Boolean']['output']>;
  allowCopy?: Maybe<Scalars['Boolean']['output']>;
  allowDelete?: Maybe<Scalars['Boolean']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  divider?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['JSON']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  fieldPath: Scalars['String']['output'];
  fields?: Maybe<Array<FormFieldV2>>;
  group: Scalars['String']['output'];
  inputMask?: Maybe<Scalars['String']['output']>;
  inputProps?: Maybe<Scalars['JSON']['output']>;
  inputType: FormInputTypes;
  invisible?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  labelDisplay?: Maybe<LabelDisplay>;
  name: Scalars['String']['output'];
  options?: Maybe<Array<FormInputOptions>>;
  required?: Maybe<Scalars['Boolean']['output']>;
  saveAs?: Maybe<Scalars['String']['output']>;
  serviceName?: Maybe<Services>;
  subSection?: Maybe<Scalars['Boolean']['output']>;
  type: InputTypes;
  value?: Maybe<Scalars['JSON']['output']>;
  variant?: Maybe<InputVariant>;
};

export type FormInputOptions = {
  __typename?: 'FormInputOptions';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum FormInputTypes {
  Boolean = 'boolean',
  CityList = 'cityList',
  Date = 'date',
  Dropdown = 'dropdown',
  File = 'file',
  GeoLocation = 'geoLocation',
  LabelAndCode = 'labelAndCode',
  Many2many = 'many2many',
  Many2one = 'many2one',
  Monetary = 'monetary',
  MultiSelect = 'multiSelect',
  Number = 'number',
  Object = 'object',
  ObjectList = 'objectList',
  Polygon = 'polygon',
  Radio = 'radio',
  Select = 'select',
  TextArea = 'textArea',
  TextField = 'textField'
}

export type FormRequestResponse = {
  __typename?: 'FormRequestResponse';
  formId: Scalars['String']['output'];
  formResponseId: Scalars['String']['output'];
};

export type FormResponse = {
  __typename?: 'FormResponse';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
  formData?: Maybe<Scalars['JSON']['output']>;
  formState?: Maybe<Scalars['JSON']['output']>;
};

export enum FormResponseStatus {
  Editing = 'editing',
  Submited = 'submited'
}

export type FormSectionV2 = {
  __typename?: 'FormSectionV2';
  description?: Maybe<Scalars['String']['output']>;
  fields: Array<FormFieldV2>;
  id: Scalars['String']['output'];
  submitText?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type FormV2 = {
  __typename?: 'FormV2';
  id: Scalars['String']['output'];
  sections: Array<FormSectionV2>;
  title: Scalars['String']['output'];
};

export enum InputTypes {
  Many2many = 'Many2many',
  Many2one = 'Many2one',
  Boolean = 'boolean',
  Date = 'date',
  File = 'file',
  GeoLocation = 'geoLocation',
  LabelAndCode = 'labelAndCode',
  List = 'list',
  MultiSelect = 'multiSelect',
  Number = 'number',
  Object = 'object',
  Password = 'password',
  Polygon = 'polygon',
  Select = 'select',
  StringList = 'stringList',
  Text = 'text'
}

export enum InputVariant {
  Lg = 'lg',
  Standard = 'standard',
  Xs = 'xs'
}

export type Inspection = {
  __typename?: 'Inspection';
  _id: Scalars['ObjectId']['output'];
  claimIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  claims?: Maybe<Array<Maybe<Claim>>>;
  date: Scalars['Date']['output'];
  documentId: Scalars['ObjectId']['output'];
  inspector?: Maybe<Contact>;
  inspectorId: Scalars['ObjectId']['output'];
  observation?: Maybe<Scalars['String']['output']>;
  regulatoryAgency: Scalars['String']['output'];
  reportFile?: Maybe<File>;
  status: InspectionStatus;
  type: InspectionType;
};

export enum InspectionStatus {
  Done = 'done',
  Pending = 'pending'
}

export enum InspectionType {
  Final = 'final',
  Preliminary = 'preliminary'
}

export type InsuranceDocument = {
  __typename?: 'InsuranceDocument';
  _id: Scalars['ObjectId']['output'];
  allowedVisitPeople?: Maybe<Array<Contact>>;
  allowedVisitPeopleIds?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  archivedProposals?: Maybe<Array<Result>>;
  beneficiary?: Maybe<Contact>;
  beneficiaryId?: Maybe<Scalars['ObjectId']['output']>;
  claimResponsible?: Maybe<User>;
  claimResponsibleId?: Maybe<Scalars['ObjectId']['output']>;
  claimStatus?: Maybe<DocumentClaimStatus>;
  claims?: Maybe<Array<Claim>>;
  commercialResponsible?: Maybe<User>;
  commercialResponsibleId?: Maybe<Scalars['ObjectId']['output']>;
  contact?: Maybe<Contact>;
  contactId: Scalars['ObjectId']['output'];
  costNFFiles?: Maybe<Array<File>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  crop?: Maybe<Crop>;
  cropId?: Maybe<Scalars['ObjectId']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endorsements?: Maybe<Array<Endorsement>>;
  equipments?: Maybe<Array<DocumentEquipment>>;
  expirationDate?: Maybe<Scalars['Date']['output']>;
  failedSimulationResults?: Maybe<Array<Maybe<Result>>>;
  farmer?: Maybe<Contact>;
  farmerId: Scalars['ObjectId']['output'];
  forestItemIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  forestItems?: Maybe<Array<ForestItem>>;
  hasComplementaryData?: Maybe<Scalars['Boolean']['output']>;
  inspections?: Maybe<Array<Inspection>>;
  insuranceTypeGroup: InsuranceTypeGroupEnum;
  justificationMessage?: Maybe<Scalars['String']['output']>;
  kmlFile?: Maybe<File>;
  operationalResponsible?: Maybe<User>;
  operationalResponsibleId?: Maybe<Scalars['ObjectId']['output']>;
  originator?: Maybe<Contact>;
  originatorId?: Maybe<Scalars['ObjectId']['output']>;
  paymentData?: Maybe<PaymentData>;
  payments?: Maybe<Array<Payment>>;
  policy?: Maybe<Policy>;
  policyId?: Maybe<Scalars['ObjectId']['output']>;
  premium?: Maybe<Scalars['Float']['output']>;
  properties?: Maybe<Array<Property>>;
  proposalFile?: Maybe<File>;
  proposalResult?: Maybe<Result>;
  proposalResultId?: Maybe<Scalars['ObjectId']['output']>;
  provider?: Maybe<PropostaProviders>;
  questions?: Maybe<CropInsuranceQuestions>;
  quotationDate?: Maybe<Scalars['Date']['output']>;
  recommendedSimulationResultId?: Maybe<Scalars['ObjectId']['output']>;
  rejectReason?: Maybe<DocumentReject>;
  selectedResultIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  selectedSimulationResults?: Maybe<Array<Maybe<Result>>>;
  simulationResults?: Maybe<Array<Maybe<Result>>>;
  specialOperation?: Maybe<SpecialOperation>;
  specialOperationId?: Maybe<Scalars['ObjectId']['output']>;
  stage?: Maybe<DocumentStages>;
  status?: Maybe<DocumentStatus>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  validSimulationResults?: Maybe<Array<Maybe<Result>>>;
  visitPerson?: Maybe<Contact>;
  visitPersonId?: Maybe<Scalars['ObjectId']['output']>;
};

export type InsuranceGroup = {
  __typename?: 'InsuranceGroup';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  types?: Maybe<Array<Maybe<InsuranceType>>>;
};

export type InsuranceType = {
  __typename?: 'InsuranceType';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  group?: Maybe<InsuranceGroup>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum InsuranceTypeGroupEnum {
  Agricultural = 'agricultural',
  Forest = 'forest',
  Machinery = 'machinery'
}

export type IntegrationSettings = {
  __typename?: 'IntegrationSettings';
  _id: Scalars['ObjectId']['output'];
  allianz?: Maybe<AllianzSettings>;
  culture?: Maybe<Culture>;
  cultureId: Scalars['ObjectId']['output'];
  swiss?: Maybe<SwissSettings>;
};

export enum LabelDisplay {
  None = 'none',
  Subtitle = 'subtitle',
  Title = 'title'
}

export type Lead = {
  __typename?: 'Lead';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  address?: Maybe<Address>;
  area?: Maybe<Scalars['Float']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  commercialResponsibleId?: Maybe<Scalars['ObjectId']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cultureIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  cultures?: Maybe<Array<Culture>>;
  email?: Maybe<Scalars['String']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  meetings?: Maybe<Array<Meeting>>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<RatingScale>;
  status?: Maybe<LeadStatus>;
  technicalResponsibleId?: Maybe<Scalars['ObjectId']['output']>;
  type?: Maybe<LeadTypes>;
};

export type LeadFiltersInput = {
  rating?: InputMaybe<RatingScale>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<LeadStatus>;
  type?: InputMaybe<LeadTypes>;
};

export enum LeadStatus {
  Deal = 'deal',
  New = 'new',
  Pitch = 'pitch',
  Refused = 'refused',
  Scrutiny = 'scrutiny'
}

export enum LeadTypes {
  Customer = 'customer',
  Partner = 'partner'
}

export enum LossEstimate {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

export type Meeting = {
  __typename?: 'Meeting';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  attachment?: Maybe<Scalars['JSON']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  date: Scalars['Date']['output'];
  responsible?: Maybe<User>;
  responsibleId: Scalars['ObjectId']['output'];
  status: MeetingStatus;
  topic: MeetingTopics;
};

export enum MeetingStatus {
  Done = 'done',
  Scheduled = 'scheduled'
}

export enum MeetingTopics {
  Followup = 'followup',
  Intro = 'intro',
  Quotation = 'quotation'
}

export type MsgSeenUpdated = {
  __typename?: 'MsgSeenUpdated';
  userId: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addCommentToLead: Scalars['Boolean']['output'];
  addCommercialResponsibleToLead: Scalars['Boolean']['output'];
  addCourseToUser: Scalars['Boolean']['output'];
  addObjectListItem: AddObjectListItemResponse;
  addTechnicalResponsibleToLead: Scalars['Boolean']['output'];
  approveSimulationResult: Scalars['Boolean']['output'];
  archiveDocument: Scalars['Boolean']['output'];
  archiveProposal: Scalars['Boolean']['output'];
  cancelPayment: Scalars['Boolean']['output'];
  changeLeadStatus: Scalars['Boolean']['output'];
  copyObjectListItem: AddObjectListItemResponse;
  createFormResponse: FormResponse;
  createFormResponseV2: Scalars['ObjectId']['output'];
  createNote: Scalars['JSON']['output'];
  createPaymentCopy: Scalars['Boolean']['output'];
  deleteObjectListItem: Array<FieldUpdateResponseV2>;
  deleteSimulationResult: Scalars['Boolean']['output'];
  disableUser: Scalars['Boolean']['output'];
  enableUser: Scalars['Boolean']['output'];
  finishSimulation: Scalars['Boolean']['output'];
  getOrCreateContactByPhone: Contact;
  handleSignupApproval: Scalars['Boolean']['output'];
  handleSignupRejection: Scalars['Boolean']['output'];
  invalidateCacheByGroupKey: Scalars['Boolean']['output'];
  rateLead: Scalars['Boolean']['output'];
  recedeDocumentStageToSimulation: Scalars['Boolean']['output'];
  recommendSimulationResult: Scalars['Boolean']['output'];
  redoQuotations: Scalars['Boolean']['output'];
  refreshLastAccessAt: Scalars['Boolean']['output'];
  removeRecommendedSimulationResult: Scalars['Boolean']['output'];
  retrySimulationResult: Scalars['Boolean']['output'];
  selectResults: Scalars['Boolean']['output'];
  sendPolicy: Scalars['Boolean']['output'];
  sendProposal: Scalars['Boolean']['output'];
  sendQuotation: Scalars['Boolean']['output'];
  sendTransactionalEvent: Scalars['JSON']['output'];
  sendTwilioWAMessage: Scalars['Boolean']['output'];
  setClaimResponsibleToDocument: Scalars['Boolean']['output'];
  setCommercialResponsibleToDocument: Scalars['Boolean']['output'];
  setContactComments: Scalars['Boolean']['output'];
  setContactCommission: Scalars['Boolean']['output'];
  setContactCultures: Scalars['Boolean']['output'];
  setContactOriginator: Scalars['Boolean']['output'];
  setContactRating: Scalars['Boolean']['output'];
  setContactResponsible: Scalars['Boolean']['output'];
  setDocumentContact: Scalars['Boolean']['output'];
  setDocumentSpecialOperation: Scalars['Boolean']['output'];
  setIndemnityPaid?: Maybe<Scalars['Boolean']['output']>;
  setOperationalResponsibleToDocument: Scalars['Boolean']['output'];
  setPaymentDone: Scalars['Boolean']['output'];
  setQuotationComment: Scalars['Boolean']['output'];
  signUserTerms: Scalars['Boolean']['output'];
  submitFormResponse: Scalars['JSON']['output'];
  submitFormResponseV2: Scalars['JSON']['output'];
  toggleUserConversationSubscription: Scalars['Boolean']['output'];
  updateFormFieldV2: Array<FieldUpdateResponseV2>;
  upgradeUserToAdmin: Scalars['Boolean']['output'];
  upsertFormField: Array<Maybe<Scalars['JSON']['output']>>;
};


export type MutationAddCommentToLeadArgs = {
  comment: Scalars['String']['input'];
  leadId: Scalars['String']['input'];
};


export type MutationAddCommercialResponsibleToLeadArgs = {
  leadId: Scalars['String']['input'];
  responsibleId: Scalars['String']['input'];
};


export type MutationAddCourseToUserArgs = {
  finishedCourse: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAddObjectListItemArgs = {
  fieldPath: Scalars['String']['input'];
  formResponseId: Scalars['String']['input'];
};


export type MutationAddTechnicalResponsibleToLeadArgs = {
  leadId: Scalars['String']['input'];
  responsibleId: Scalars['String']['input'];
};


export type MutationApproveSimulationResultArgs = {
  docId: Scalars['String']['input'];
  resultId: Scalars['String']['input'];
  silent: Scalars['Boolean']['input'];
};


export type MutationArchiveDocumentArgs = {
  docId: Scalars['String']['input'];
};


export type MutationArchiveProposalArgs = {
  docId: Scalars['String']['input'];
};


export type MutationCancelPaymentArgs = {
  paymentId: Scalars['String']['input'];
};


export type MutationChangeLeadStatusArgs = {
  leadId: Scalars['String']['input'];
  status: LeadStatus;
};


export type MutationCopyObjectListItemArgs = {
  fieldPath: Scalars['String']['input'];
  formResponseId: Scalars['String']['input'];
};


export type MutationCreateFormResponseArgs = {
  formId: Scalars['String']['input'];
  metadata: Scalars['JSON']['input'];
};


export type MutationCreateFormResponseV2Args = {
  formId: Scalars['String']['input'];
  metadata: Scalars['JSON']['input'];
};


export type MutationCreateNoteArgs = {
  authorId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
  serviceName: Services;
  text: Scalars['String']['input'];
};


export type MutationCreatePaymentCopyArgs = {
  paymentId: Scalars['String']['input'];
};


export type MutationDeleteObjectListItemArgs = {
  fieldPath: Scalars['String']['input'];
  formResponseId: Scalars['String']['input'];
};


export type MutationDeleteSimulationResultArgs = {
  resultId: Scalars['String']['input'];
};


export type MutationDisableUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationEnableUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationFinishSimulationArgs = {
  docId: Scalars['String']['input'];
};


export type MutationGetOrCreateContactByPhoneArgs = {
  mobilePhone: Scalars['String']['input'];
};


export type MutationHandleSignupApprovalArgs = {
  contactId: Scalars['String']['input'];
};


export type MutationHandleSignupRejectionArgs = {
  contactId: Scalars['String']['input'];
  rejectReason: Scalars['String']['input'];
};


export type MutationInvalidateCacheByGroupKeyArgs = {
  groupKey: Scalars['String']['input'];
};


export type MutationRateLeadArgs = {
  leadId: Scalars['String']['input'];
  rating: RatingScale;
};


export type MutationRecedeDocumentStageToSimulationArgs = {
  docId: Scalars['String']['input'];
  docStatus: DocumentStatus;
};


export type MutationRecommendSimulationResultArgs = {
  docId: Scalars['String']['input'];
  resultId: Scalars['String']['input'];
};


export type MutationRedoQuotationsArgs = {
  docId: Scalars['String']['input'];
};


export type MutationRefreshLastAccessAtArgs = {
  userId: Scalars['String']['input'];
};


export type MutationRemoveRecommendedSimulationResultArgs = {
  docId: Scalars['String']['input'];
};


export type MutationRetrySimulationResultArgs = {
  resultId: Scalars['String']['input'];
};


export type MutationSelectResultsArgs = {
  docId: Scalars['String']['input'];
  resultsIds: Array<Scalars['String']['input']>;
};


export type MutationSendPolicyArgs = {
  docId: Scalars['String']['input'];
  silent: Scalars['Boolean']['input'];
};


export type MutationSendProposalArgs = {
  docId: Scalars['String']['input'];
  silent: Scalars['Boolean']['input'];
};


export type MutationSendQuotationArgs = {
  docId: Scalars['String']['input'];
  silent: Scalars['Boolean']['input'];
};


export type MutationSendTransactionalEventArgs = {
  docId: Scalars['String']['input'];
  event: TransactionalEvents;
};


export type MutationSendTwilioWaMessageArgs = {
  contactId: Scalars['String']['input'];
  content: Scalars['String']['input'];
  files: Array<TwilioMediaInput>;
};


export type MutationSetClaimResponsibleToDocumentArgs = {
  contactId?: InputMaybe<Scalars['String']['input']>;
  docId: Scalars['String']['input'];
};


export type MutationSetCommercialResponsibleToDocumentArgs = {
  contactId?: InputMaybe<Scalars['String']['input']>;
  docId: Scalars['String']['input'];
};


export type MutationSetContactCommentsArgs = {
  comments: Scalars['String']['input'];
  contactId: Scalars['String']['input'];
};


export type MutationSetContactCommissionArgs = {
  commission: Scalars['Float']['input'];
  contactId: Scalars['String']['input'];
};


export type MutationSetContactCulturesArgs = {
  contactId: Scalars['String']['input'];
  cultureIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};


export type MutationSetContactOriginatorArgs = {
  contactId: Scalars['String']['input'];
  originatorId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetContactRatingArgs = {
  contactId: Scalars['String']['input'];
  rating: RatingScale;
};


export type MutationSetContactResponsibleArgs = {
  contactId: Scalars['String']['input'];
  responsibleId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetDocumentContactArgs = {
  contactId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
};


export type MutationSetDocumentSpecialOperationArgs = {
  docId: Scalars['String']['input'];
  specialOperationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetIndemnityPaidArgs = {
  objectId: Scalars['String']['input'];
};


export type MutationSetOperationalResponsibleToDocumentArgs = {
  contactId?: InputMaybe<Scalars['String']['input']>;
  docId: Scalars['String']['input'];
};


export type MutationSetPaymentDoneArgs = {
  paymentId: Scalars['String']['input'];
};


export type MutationSetQuotationCommentArgs = {
  docId: Scalars['String']['input'];
  message: Scalars['String']['input'];
};


export type MutationSubmitFormResponseArgs = {
  formResponseId: Scalars['String']['input'];
};


export type MutationSubmitFormResponseV2Args = {
  formResponseId: Scalars['String']['input'];
};


export type MutationToggleUserConversationSubscriptionArgs = {
  contactId: Scalars['String']['input'];
  shouldAdd: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};


export type MutationUpdateFormFieldV2Args = {
  fieldPath: Scalars['String']['input'];
  formResponseId: Scalars['String']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationUpgradeUserToAdminArgs = {
  userId: Scalars['String']['input'];
};


export type MutationUpsertFormFieldArgs = {
  fieldPath: Scalars['String']['input'];
  formResponseId: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
};

export type Note = {
  __typename?: 'Note';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  authorId: User;
  createdAt?: Maybe<Scalars['Date']['output']>;
  documentId?: Maybe<Scalars['ObjectId']['output']>;
  serviceName?: Maybe<Services>;
  text?: Maybe<Scalars['String']['output']>;
};

export type Notification = {
  __typename?: 'Notification';
  author?: Maybe<User>;
  authorId?: Maybe<Scalars['ObjectId']['output']>;
  createdAt: Scalars['Date']['output'];
  isRead?: Maybe<Scalars['Boolean']['output']>;
  objectId: Scalars['ObjectId']['output'];
  originInfo: Scalars['String']['output'];
  serviceName: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type NotificationResponse = {
  __typename?: 'NotificationResponse';
  dateNotifications: Array<ObjectNotifications>;
  notificationDate: Scalars['Date']['output'];
};

export type ObjectNotifications = {
  __typename?: 'ObjectNotifications';
  groupNotifications: Array<Notification>;
  notificationGroup: Scalars['ObjectId']['output'];
};

export enum OrgDepartmentRoles {
  ExecutiveBoard = 'executiveBoard',
  Finance = 'finance'
}

export enum OrgIndustries {
  Agrochemical = 'agrochemical',
  Association = 'association',
  Cooperative = 'cooperative',
  Dealership = 'dealership',
  InputDistributor = 'inputDistributor',
  InsuranceBroker = 'insuranceBroker',
  Other = 'other',
  Union = 'union'
}

export enum OrgMembershipCount {
  From101To500 = 'from101To500',
  Over500 = 'over500',
  UpTo100 = 'upTo100'
}

export enum OrgOperationalArea {
  From101To500 = 'from101To500',
  Over500 = 'over500',
  UpTo100 = 'upTo100'
}

export type PartnersDashboardGroupData = {
  __typename?: 'PartnersDashboardGroupData';
  statusGroups: Array<PartnersDashboardGroupStatusData>;
  tag: ContactTags;
};

export type PartnersDashboardGroupStatusData = {
  __typename?: 'PartnersDashboardGroupStatusData';
  count: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type PartnersFiltersInput = {
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  responsibleId?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRoles>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
};

export type Payment = {
  __typename?: 'Payment';
  _id: Scalars['ObjectId']['output'];
  amount: Scalars['Float']['output'];
  billFile?: Maybe<File>;
  dateDue: Scalars['Date']['output'];
  documentId: Scalars['ObjectId']['output'];
  name: Scalars['String']['output'];
  provider: PropostaProviders;
  responsible?: Maybe<Contact>;
  responsibleId: Scalars['ObjectId']['output'];
  status: PaymentStatus;
  subventionType?: Maybe<SubventionType>;
};

export type PaymentData = {
  __typename?: 'PaymentData';
  accountData?: Maybe<AccountData>;
  installments?: Maybe<Scalars['Float']['output']>;
  method?: Maybe<PaymentMethods>;
  responsible?: Maybe<Contact>;
  responsibleId?: Maybe<Scalars['ObjectId']['output']>;
};

export enum PaymentMethods {
  Boleto = 'boleto',
  Debit = 'debit'
}

export enum PaymentStatus {
  Cancelled = 'cancelled',
  Done = 'done',
  Pending = 'pending'
}

export type PaymentsFiltersInput = {
  contactId: Scalars['String']['input'];
};

export type Plot = {
  __typename?: 'Plot';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  area?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cropYear?: Maybe<Scalars['String']['output']>;
  cultureDetail?: Maybe<CultureDetail>;
  cultureDetailId?: Maybe<Scalars['ObjectId']['output']>;
  irrigated?: Maybe<Scalars['Boolean']['output']>;
  lineSpacing?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  plantDate?: Maybe<Scalars['Date']['output']>;
  plantMethod?: Maybe<Scalars['String']['output']>;
  plantSpacing?: Maybe<Scalars['Float']['output']>;
  polygon?: Maybe<Array<Maybe<Scalars['LatLng']['output']>>>;
  property?: Maybe<Property>;
  seedType?: Maybe<Scalars['String']['output']>;
  soilType?: Maybe<Scalars['LabelAndCode']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type Policy = {
  __typename?: 'Policy';
  _id: Scalars['ObjectId']['output'];
  billsFile?: Maybe<File>;
  cancellationReason?: Maybe<PolicyCancellation>;
  documentId: Scalars['ObjectId']['output'];
  endDate: Scalars['Date']['output'];
  externalId: Scalars['String']['output'];
  farmerId: Scalars['ObjectId']['output'];
  insuranceTypeGroup: InsuranceTypeGroupEnum;
  policyFile: File;
  provider: PropostaProviders;
  startDate: Scalars['Date']['output'];
};

export type PolicyCancellation = {
  __typename?: 'PolicyCancellation';
  cancellationReason: PolicyCancellationReason;
  other?: Maybe<Scalars['String']['output']>;
};

export enum PolicyCancellationReason {
  Error = 'error',
  Other = 'other',
  Quitclaim = 'quitclaim'
}

export type Property = {
  __typename?: 'Property';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  accessInstructions?: Maybe<Scalars['String']['output']>;
  activity?: Maybe<Scalars['String']['output']>;
  activityId?: Maybe<Scalars['ObjectId']['output']>;
  address?: Maybe<Address>;
  carRegistration?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entranceLocation?: Maybe<Scalars['LatLng']['output']>;
  kmlFile?: Maybe<Scalars['String']['output']>;
  manualActivity?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Contact>;
  plots?: Maybe<Array<Maybe<Plot>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PropertyActivity = {
  __typename?: 'PropertyActivity';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  isGeneric?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum PropostaProviders {
  Agrobrasil = 'agrobrasil',
  Allianz = 'allianz',
  Btg = 'btg',
  Essor = 'essor',
  Fairfax = 'fairfax',
  Kovr = 'kovr',
  Mapfre = 'mapfre',
  Porto = 'porto',
  Sancor = 'sancor',
  Sombrero = 'sombrero',
  Sompo = 'sompo',
  Swiss = 'swiss',
  Tokyo = 'tokyo'
}

export type Query = {
  __typename?: 'Query';
  claims?: Maybe<Array<Claim>>;
  contact: Contact;
  contactBySlug?: Maybe<Contact>;
  contacts?: Maybe<Array<Contact>>;
  countContacts?: Maybe<Scalars['Int']['output']>;
  countDocuments?: Maybe<Scalars['Int']['output']>;
  countLeads?: Maybe<Scalars['Int']['output']>;
  countUsers?: Maybe<Scalars['Int']['output']>;
  culture?: Maybe<Culture>;
  cultures: Array<Culture>;
  document?: Maybe<InsuranceDocument>;
  documents: Array<InsuranceDocument>;
  getCancelPolicyOnDocumentFormResponse: FormRequestResponse;
  getComplementaryDataFormResponse: FormRequestResponse;
  getCreateClaimOnFormResponse: FormRequestResponse;
  getCreateEndorsementAnswerOnDocumentFormResponse: FormRequestResponse;
  getCreateEndorsementOnDocumentFormResponse: FormRequestResponse;
  getCreateInspectionOnFormResponse: FormRequestResponse;
  getCreateIntegrationSettingsFormResponse: FormRequestResponse;
  getCreateKmlFileUploadFormResponse: FormRequestResponse;
  getCreateMeetingOnObjectFormResponse: FormRequestResponse;
  getCreateObjectFormResponse: Scalars['String']['output'];
  getCreateOrgMembersFormResponse: FormRequestResponse;
  getCreatePaymentOnDocumentFormResponse: FormRequestResponse;
  getCreatePolicyOnDocumentFormResponse: FormRequestResponse;
  getCreateProposalOnDocumentFormResponse: FormRequestResponse;
  getCreateResultOnDocumentFormResponse: FormRequestResponse;
  getCreateSignedProposalOnFormResponse: FormRequestResponse;
  getDocumentRejectionFormResponse: FormRequestResponse;
  getDocumentsDashboardCounters?: Maybe<Array<CategoryDashboardCounters>>;
  getDocumentsDashboardFunnel?: Maybe<Array<DashboardFunnelValue>>;
  getEditBillsOnDocumentFormResponse: FormRequestResponse;
  getEditClaimOnFormResponse: FormRequestResponse;
  getEditConclusionLetterOnClaim: FormRequestResponse;
  getEditContactOnFormResponse: FormRequestResponse;
  getEditContestationLetterOnClaim: FormRequestResponse;
  getEditCropOnDocumentFormResponse: FormRequestResponse;
  getEditCultureFormResponse: FormRequestResponse;
  getEditEndorsementAnswerOnDocumentFormResponse: FormRequestResponse;
  getEditEndorsementOnDocumentFormResponse: FormRequestResponse;
  getEditEstimatedIndemnityOnClaim: FormRequestResponse;
  getEditFinancialResponsibleOnDocumentFormResponse: FormRequestResponse;
  getEditHarvestDatesLettersOnClaimFormResponse: FormRequestResponse;
  getEditInspectionOnFormResponse: FormRequestResponse;
  getEditIntegrationSettingsFormResponse: FormRequestResponse;
  getEditLeadOnFormResponse: FormRequestResponse;
  getEditMeetingOnObjectFormResponse: FormRequestResponse;
  getEditObjectFormResponse: Scalars['String']['output'];
  getEditPaymentDataOnDocumentFormResponse: FormRequestResponse;
  getEditPaymentOnDocumentFormResponse: FormRequestResponse;
  getEditPolicyOnDocumentFormResponse: FormRequestResponse;
  getEditPropertyOnDocumentFormResponse: FormRequestResponse;
  getEditProposalOnDocumentFormResponse: FormRequestResponse;
  getEditReportFileOnInspection: FormRequestResponse;
  getEditResultOnDocumentFormResponse: FormRequestResponse;
  getEditSignedProposalOnFormResponse: FormRequestResponse;
  getFormResponse?: Maybe<FormResponse>;
  getFormResponseV2?: Maybe<FormV2>;
  getMany2XOptions: Array<FormDataOptions>;
  getNfeUploadFormResponse: FormRequestResponse;
  getPartnersDashboardData: Array<PartnersDashboardGroupData>;
  getShareToken?: Maybe<Scalars['String']['output']>;
  getTwilioConversations: Array<TwilioConversation>;
  getTwilioMediaUrl: Scalars['String']['output'];
  getTwilioWAMessages: TwilioConversationData;
  inspection?: Maybe<Inspection>;
  integrationSetting: IntegrationSettings;
  integrationSettings: Array<IntegrationSettings>;
  lead?: Maybe<Lead>;
  leads?: Maybe<Array<Maybe<Lead>>>;
  modelTasks: Array<Task>;
  notes: Array<Note>;
  notifications: Array<NotificationResponse>;
  payments?: Maybe<Array<Payment>>;
  user?: Maybe<User>;
  users?: Maybe<Array<Maybe<User>>>;
};


export type QueryClaimsArgs = {
  filter: ClaimsFiltersInput;
};


export type QueryContactArgs = {
  contactId: Scalars['String']['input'];
};


export type QueryContactBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryContactsArgs = {
  filter: Array<Array<ContactsFiltersInput>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['MongoSortQuery']['input']>;
};


export type QueryCountContactsArgs = {
  filter: Array<InputMaybe<Array<InputMaybe<ContactsFiltersInput>>>>;
};


export type QueryCountDocumentsArgs = {
  filter: Array<InputMaybe<Array<InputMaybe<DocumentsFilterInput>>>>;
};


export type QueryCountLeadsArgs = {
  filter: Array<InputMaybe<Array<InputMaybe<LeadFiltersInput>>>>;
};


export type QueryCountUsersArgs = {
  filter: Array<InputMaybe<Array<InputMaybe<PartnersFiltersInput>>>>;
};


export type QueryCultureArgs = {
  cultureId: Scalars['String']['input'];
};


export type QueryDocumentArgs = {
  docId: Scalars['String']['input'];
};


export type QueryDocumentsArgs = {
  filter: Array<InputMaybe<Array<InputMaybe<DocumentsFilterInput>>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['MongoSortQuery']['input']>;
};


export type QueryGetCancelPolicyOnDocumentFormResponseArgs = {
  documentId: Scalars['String']['input'];
  objectId: Scalars['String']['input'];
};


export type QueryGetComplementaryDataFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetCreateClaimOnFormResponseArgs = {
  documentId: Scalars['String']['input'];
};


export type QueryGetCreateEndorsementAnswerOnDocumentFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetCreateEndorsementOnDocumentFormResponseArgs = {
  documentId: Scalars['String']['input'];
};


export type QueryGetCreateInspectionOnFormResponseArgs = {
  documentId: Scalars['String']['input'];
};


export type QueryGetCreateIntegrationSettingsFormResponseArgs = {
  cultureId?: InputMaybe<Scalars['String']['input']>;
  formId: Scalars['String']['input'];
};


export type QueryGetCreateKmlFileUploadFormResponseArgs = {
  documentId: Scalars['String']['input'];
};


export type QueryGetCreateMeetingOnObjectFormResponseArgs = {
  parentId: Scalars['String']['input'];
  serviceName: Services;
};


export type QueryGetCreateObjectFormResponseArgs = {
  formId: Scalars['String']['input'];
  payload: Scalars['JSON']['input'];
  service: Services;
};


export type QueryGetCreateOrgMembersFormResponseArgs = {
  orgId: Scalars['String']['input'];
};


export type QueryGetCreatePaymentOnDocumentFormResponseArgs = {
  documentId: Scalars['String']['input'];
};


export type QueryGetCreatePolicyOnDocumentFormResponseArgs = {
  documentId: Scalars['String']['input'];
};


export type QueryGetCreateProposalOnDocumentFormResponseArgs = {
  documentId: Scalars['String']['input'];
};


export type QueryGetCreateResultOnDocumentFormResponseArgs = {
  documentId: Scalars['String']['input'];
};


export type QueryGetCreateSignedProposalOnFormResponseArgs = {
  proposalResultId: Scalars['String']['input'];
};


export type QueryGetDocumentRejectionFormResponseArgs = {
  documentId: Scalars['String']['input'];
};


export type QueryGetDocumentsDashboardCountersArgs = {
  filter: Array<InputMaybe<Array<InputMaybe<DocumentsFilterInput>>>>;
};


export type QueryGetDocumentsDashboardFunnelArgs = {
  endDate: Scalars['Date']['input'];
  filter: Array<InputMaybe<Array<InputMaybe<DocumentsFilterInput>>>>;
  startDate: Scalars['Date']['input'];
};


export type QueryGetEditBillsOnDocumentFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditClaimOnFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditConclusionLetterOnClaimArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditContactOnFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditContestationLetterOnClaimArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditCropOnDocumentFormResponseArgs = {
  documentId: Scalars['String']['input'];
  objectId: Scalars['String']['input'];
};


export type QueryGetEditCultureFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditEndorsementAnswerOnDocumentFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditEndorsementOnDocumentFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditEstimatedIndemnityOnClaimArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditFinancialResponsibleOnDocumentFormResponseArgs = {
  documentId: Scalars['String']['input'];
  objectId: Scalars['String']['input'];
};


export type QueryGetEditHarvestDatesLettersOnClaimFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditInspectionOnFormResponseArgs = {
  documentId: Scalars['String']['input'];
  objectId: Scalars['String']['input'];
};


export type QueryGetEditIntegrationSettingsFormResponseArgs = {
  formId: Scalars['String']['input'];
  listIndex?: InputMaybe<Scalars['Float']['input']>;
  objectId: Scalars['String']['input'];
};


export type QueryGetEditLeadOnFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditMeetingOnObjectFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditObjectFormResponseArgs = {
  formId: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  objectId: Scalars['String']['input'];
  service: Services;
};


export type QueryGetEditPaymentDataOnDocumentFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditPaymentOnDocumentFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditPolicyOnDocumentFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditPropertyOnDocumentFormResponseArgs = {
  documentId: Scalars['String']['input'];
  objectId: Scalars['String']['input'];
};


export type QueryGetEditProposalOnDocumentFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditReportFileOnInspectionArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditResultOnDocumentFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditSignedProposalOnFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetFormResponseArgs = {
  formResponseId: Scalars['String']['input'];
};


export type QueryGetFormResponseV2Args = {
  formResponseId: Scalars['String']['input'];
};


export type QueryGetMany2XOptionsArgs = {
  currentValue?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  domain: Scalars['JSON']['input'];
  searchTerm: Scalars['String']['input'];
  serviceName: Services;
};


export type QueryGetNfeUploadFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetShareTokenArgs = {
  objectId: Scalars['String']['input'];
  service: Services;
};


export type QueryGetTwilioConversationsArgs = {
  filter: ConversationsFilterInput;
};


export type QueryGetTwilioMediaUrlArgs = {
  fileKey: Scalars['String']['input'];
};


export type QueryGetTwilioWaMessagesArgs = {
  contactId: Scalars['String']['input'];
};


export type QueryInspectionArgs = {
  inspectionId: Scalars['String']['input'];
};


export type QueryIntegrationSettingArgs = {
  settingId: Scalars['String']['input'];
};


export type QueryIntegrationSettingsArgs = {
  provider?: InputMaybe<PropostaProviders>;
};


export type QueryLeadArgs = {
  leadId: Scalars['String']['input'];
};


export type QueryLeadsArgs = {
  filter: Array<InputMaybe<Array<InputMaybe<LeadFiltersInput>>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['MongoSortQuery']['input']>;
};


export type QueryModelTasksArgs = {
  objectId?: InputMaybe<Scalars['String']['input']>;
  serviceName: Services;
};


export type QueryNotesArgs = {
  docId: Scalars['String']['input'];
  serviceName: Services;
};


export type QueryNotificationsArgs = {
  serviceName: Services;
};


export type QueryPaymentsArgs = {
  filter: PaymentsFiltersInput;
};


export type QueryUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryUsersArgs = {
  filter: Array<InputMaybe<Array<InputMaybe<PartnersFiltersInput>>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['MongoSortQuery']['input']>;
};

export enum RatingScale {
  Outstanding = 'outstanding',
  Poor = 'poor',
  Satisfactory = 'satisfactory',
  Unsatisfactory = 'unsatisfactory',
  VerySatisfactory = 'verySatisfactory'
}

export type Result = {
  __typename?: 'Result';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  amounts?: Maybe<ResultAmounts>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  basicCoverageType?: Maybe<BasicCoverageTypes>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  guaranteedProductivity?: Maybe<Scalars['Float']['output']>;
  insuranceTypeGroup?: Maybe<InsuranceTypeGroupEnum>;
  itens?: Maybe<Array<ResultItem>>;
  name?: Maybe<Scalars['String']['output']>;
  points?: Maybe<ResultPoints>;
  proposalFile?: Maybe<File>;
  proposalSketchMap?: Maybe<File>;
  provider?: Maybe<PropostaProviders>;
  referenceLocation?: Maybe<Scalars['String']['output']>;
  sackValue?: Maybe<Scalars['Float']['output']>;
  signedProposalFile?: Maybe<File>;
  status?: Maybe<ResultStatus>;
  tags?: Maybe<Array<Maybe<ResultTags>>>;
  type?: Maybe<ResultTypes>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ResultAmounts = {
  __typename?: 'ResultAmounts';
  federalSubvention?: Maybe<Scalars['Float']['output']>;
  finalPremium?: Maybe<Scalars['Float']['output']>;
  lmi?: Maybe<Scalars['Float']['output']>;
  maxPayments?: Maybe<Scalars['Int']['output']>;
  stateSubvention?: Maybe<Scalars['Float']['output']>;
  totalPremium?: Maybe<Scalars['Float']['output']>;
};

export type ResultCoverage = {
  __typename?: 'ResultCoverage';
  coverageEventIds: Array<Scalars['ObjectId']['output']>;
  coverageEvents?: Maybe<Array<CoverageEvent>>;
  coverageTags?: Maybe<CoverageTags>;
  lmi?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  premium?: Maybe<Scalars['Float']['output']>;
};

export type ResultItem = {
  __typename?: 'ResultItem';
  coverages: Array<ResultCoverage>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ResultPoints = {
  __typename?: 'ResultPoints';
  guaranteedProductivity?: Maybe<Scalars['Int']['output']>;
  sackValueDifference?: Maybe<Scalars['Int']['output']>;
  totalPoints?: Maybe<Scalars['Int']['output']>;
  totalPremium?: Maybe<Scalars['Int']['output']>;
};

export enum ResultStatus {
  Approved = 'approved',
  Deleted = 'deleted',
  Error = 'error',
  Pending = 'pending',
  Sent = 'sent'
}

export enum ResultTags {
  HighestProductivity = 'highestProductivity',
  HighestSackValue = 'highestSackValue',
  LowestCost = 'lowestCost'
}

export enum ResultTypes {
  Proposal = 'proposal',
  Quotation = 'quotation',
  Simulation = 'simulation'
}

export enum Services {
  Banks = 'banks',
  BridgeCommunications = 'bridgeCommunications',
  Calculations = 'calculations',
  Claims = 'claims',
  Contacts = 'contacts',
  CoverageEvents = 'coverageEvents',
  Crops = 'crops',
  Cultures = 'cultures',
  Documents = 'documents',
  Email = 'email',
  EmissionInstitutions = 'emissionInstitutions',
  Endorsements = 'endorsements',
  EquipmentBrands = 'equipmentBrands',
  EquipmentTypes = 'equipmentTypes',
  Equipments = 'equipments',
  ForestItems = 'forestItems',
  ForestManagements = 'forestManagements',
  ForestSpecies = 'forestSpecies',
  FormV2 = 'formV2',
  Forms = 'forms',
  Inspections = 'inspections',
  Leads = 'leads',
  Meetings = 'meetings',
  Notes = 'notes',
  Notifications = 'notifications',
  Payments = 'payments',
  Policies = 'policies',
  Professions = 'professions',
  Properties = 'properties',
  PropertyActivities = 'propertyActivities',
  Results = 'results',
  SpecialOperations = 'specialOperations',
  Tasks = 'tasks',
  TwilioConversations = 'twilioConversations',
  TwilioWaMessages = 'twilioWAMessages',
  Users = 'users'
}

export type SpecialOperation = {
  __typename?: 'SpecialOperation';
  _id: Scalars['ObjectId']['output'];
  name: Scalars['String']['output'];
};

export type StatusDashboardCounters = {
  __typename?: 'StatusDashboardCounters';
  count: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  conversationUpdated?: Maybe<ConversationUpdated>;
  msgSeenUpdated?: Maybe<MsgSeenUpdated>;
};

export enum SubscriptionEvents {
  ConversationUpdated = 'conversationUpdated',
  MsgSeenUpdated = 'msgSeenUpdated'
}

export enum SubventionType {
  Federal = 'federal',
  State = 'state'
}

export type SwissSettings = {
  __typename?: 'SwissSettings';
  plantDate?: Maybe<Scalars['Date']['output']>;
  productCode?: Maybe<Scalars['String']['output']>;
  soilTypeCode?: Maybe<Scalars['String']['output']>;
  stateSettings?: Maybe<Array<SwissStateSettings>>;
  systemCode?: Maybe<Scalars['String']['output']>;
  valRiscoNomeado?: Maybe<Scalars['Float']['output']>;
  valSaca?: Maybe<Scalars['Float']['output']>;
};

export type SwissStateSettings = {
  __typename?: 'SwissStateSettings';
  states?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  valCusteio: Scalars['Float']['output'];
};

export type Task = {
  __typename?: 'Task';
  dateDue: Scalars['Date']['output'];
  docId: Scalars['ObjectId']['output'];
  message: Scalars['String']['output'];
  modelName: Scalars['String']['output'];
  originInfo?: Maybe<Scalars['String']['output']>;
  responsible?: Maybe<User>;
  responsibleId?: Maybe<Scalars['ObjectId']['output']>;
};

export enum TransactionalEvents {
  AdminAssignedAsClaimResponsible = 'adminAssignedAsClaimResponsible',
  AdminAssignedAsCommercialResponsible = 'adminAssignedAsCommercialResponsible',
  AdminAssignedAsOperationalResponsible = 'adminAssignedAsOperationalResponsible',
  ApprovedQuotation = 'approvedQuotation',
  ApprovedRegister = 'approvedRegister',
  ComplementaryData = 'complementaryData',
  InvoicesForm = 'invoicesForm',
  KmlUploadForm = 'kmlUploadForm',
  OrgApproved = 'orgApproved',
  OrgInviteSent = 'orgInviteSent',
  PendingQuotation = 'pendingQuotation',
  QuotationResults = 'quotationResults',
  UploadedPolicy = 'uploadedPolicy',
  UploadedProposal = 'uploadedProposal'
}

export type TwilioConversation = {
  __typename?: 'TwilioConversation';
  contact: Contact;
  lastMsg: TwilioWaMessage;
  notSeenCount?: Maybe<Scalars['Int']['output']>;
};

export type TwilioConversationData = {
  __typename?: 'TwilioConversationData';
  contact: Contact;
  isSubscribed: Scalars['Boolean']['output'];
  messages: Array<TwilioWaMessage>;
};

export type TwilioMedia = {
  __typename?: 'TwilioMedia';
  externalId?: Maybe<Scalars['String']['output']>;
  fileKey: Scalars['String']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
};

export type TwilioMediaInput = {
  fileKey: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type TwilioWaMessage = {
  __typename?: 'TwilioWAMessage';
  _id: Scalars['ObjectId']['output'];
  content?: Maybe<Scalars['String']['output']>;
  conversationId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  medias?: Maybe<Array<TwilioMedia>>;
  sentAt?: Maybe<Scalars['Date']['output']>;
  status: TwilioWaMsgStatus;
  templateName?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export enum TwilioWaMsgStatus {
  Delivered = 'delivered',
  Enqueued = 'enqueued',
  Failed = 'failed',
  Pending = 'pending',
  Read = 'read',
  Sent = 'sent'
}

export type User = {
  __typename?: 'User';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  contact?: Maybe<Contact>;
  contactId?: Maybe<Scalars['ObjectId']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  documents?: Maybe<Array<InsuranceDocument>>;
  email?: Maybe<Scalars['String']['output']>;
  finishedCourse?: Maybe<Scalars['Boolean']['output']>;
  indicators?: Maybe<Array<UserIndicator>>;
  lastAccessAt?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nextCallDate?: Maybe<Scalars['Date']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  profession?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UserRoles>;
  signedDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<UserStatus>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type UserIndicator = {
  __typename?: 'UserIndicator';
  _id?: Maybe<Scalars['String']['output']>;
  totalArea?: Maybe<Scalars['Float']['output']>;
  totalCommission?: Maybe<Scalars['Float']['output']>;
  totalPremium?: Maybe<Scalars['Float']['output']>;
};

export enum UserRating {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

export enum UserRoles {
  Admin = 'admin',
  Consultant = 'consultant',
  OrgAdmin = 'orgAdmin',
  OrgMember = 'orgMember'
}

export enum UserStatus {
  Active = 'active',
  Approved = 'approved',
  Registered = 'registered',
  Rejected = 'rejected'
}

export type SetIndemnityPaidMutationVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type SetIndemnityPaidMutation = { __typename?: 'Mutation', setIndemnityPaid?: boolean | null };

export type GetOrCreateContactByPhoneMutationVariables = Exact<{
  mobilePhone: Scalars['String']['input'];
}>;


export type GetOrCreateContactByPhoneMutation = { __typename?: 'Mutation', getOrCreateContactByPhone: { __typename?: 'Contact', _id?: string | null } };

export type SetContactCommentsMutationVariables = Exact<{
  contactId: Scalars['String']['input'];
  comments: Scalars['String']['input'];
}>;


export type SetContactCommentsMutation = { __typename?: 'Mutation', setContactComments: boolean };

export type SetContactCulturesMutationVariables = Exact<{
  contactId: Scalars['String']['input'];
  cultureIds?: InputMaybe<Array<Scalars['ObjectId']['input']> | Scalars['ObjectId']['input']>;
}>;


export type SetContactCulturesMutation = { __typename?: 'Mutation', setContactCultures: boolean };

export type SetContactRatingMutationVariables = Exact<{
  contactId: Scalars['String']['input'];
  rating: RatingScale;
}>;


export type SetContactRatingMutation = { __typename?: 'Mutation', setContactRating: boolean };

export type SetContactResponsibleMutationVariables = Exact<{
  contactId: Scalars['String']['input'];
  responsibleId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetContactResponsibleMutation = { __typename?: 'Mutation', setContactResponsible: boolean };

export type SetContactCommissionMutationVariables = Exact<{
  contactId: Scalars['String']['input'];
  commission: Scalars['Float']['input'];
}>;


export type SetContactCommissionMutation = { __typename?: 'Mutation', setContactCommission: boolean };

export type HandleSignupApprovalMutationVariables = Exact<{
  contactId: Scalars['String']['input'];
}>;


export type HandleSignupApprovalMutation = { __typename?: 'Mutation', handleSignupApproval: boolean };

export type HandleSignupRejectionMutationVariables = Exact<{
  contactId: Scalars['String']['input'];
  rejectReason: Scalars['String']['input'];
}>;


export type HandleSignupRejectionMutation = { __typename?: 'Mutation', handleSignupRejection: boolean };

export type SetContactOriginatorMutationVariables = Exact<{
  contactId: Scalars['String']['input'];
  originatorId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetContactOriginatorMutation = { __typename?: 'Mutation', setContactOriginator: boolean };

export type SelectResultsMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  resultsIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SelectResultsMutation = { __typename?: 'Mutation', selectResults: boolean };

export type SetQuotationCommentMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  message: Scalars['String']['input'];
}>;


export type SetQuotationCommentMutation = { __typename?: 'Mutation', setQuotationComment: boolean };

export type ApproveSimulationResultMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  resultId: Scalars['String']['input'];
  silent: Scalars['Boolean']['input'];
}>;


export type ApproveSimulationResultMutation = { __typename?: 'Mutation', approveSimulationResult: boolean };

export type RecedeDocumentStageMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  docStatus: DocumentStatus;
}>;


export type RecedeDocumentStageMutation = { __typename?: 'Mutation', recedeDocumentStageToSimulation: boolean };

export type SetCommercialResponsibleMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  responsibleId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetCommercialResponsibleMutation = { __typename?: 'Mutation', setCommercialResponsibleToDocument: boolean };

export type SetOperationalResponsibleMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  responsibleId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetOperationalResponsibleMutation = { __typename?: 'Mutation', setOperationalResponsibleToDocument: boolean };

export type SetClaimResponsibleMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  responsibleId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetClaimResponsibleMutation = { __typename?: 'Mutation', setClaimResponsibleToDocument: boolean };

export type SetDocumentSpecialOperationMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  specialOperationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetDocumentSpecialOperationMutation = { __typename?: 'Mutation', setDocumentSpecialOperation: boolean };

export type ArchiveDocumentMutationVariables = Exact<{
  docId: Scalars['String']['input'];
}>;


export type ArchiveDocumentMutation = { __typename?: 'Mutation', archiveDocument: boolean };

export type FinishSimulationMutationVariables = Exact<{
  docId: Scalars['String']['input'];
}>;


export type FinishSimulationMutation = { __typename?: 'Mutation', finishSimulation: boolean };

export type RedoQuotationsMutationVariables = Exact<{
  docId: Scalars['String']['input'];
}>;


export type RedoQuotationsMutation = { __typename?: 'Mutation', redoQuotations: boolean };

export type DeleteSimulationResultMutationVariables = Exact<{
  resultId: Scalars['String']['input'];
}>;


export type DeleteSimulationResultMutation = { __typename?: 'Mutation', deleteSimulationResult: boolean };

export type SetPaymentDoneMutationVariables = Exact<{
  paymentId: Scalars['String']['input'];
}>;


export type SetPaymentDoneMutation = { __typename?: 'Mutation', setPaymentDone: boolean };

export type SendQuotationMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  silent: Scalars['Boolean']['input'];
}>;


export type SendQuotationMutation = { __typename?: 'Mutation', sendQuotation: boolean };

export type SendProposalMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  silent: Scalars['Boolean']['input'];
}>;


export type SendProposalMutation = { __typename?: 'Mutation', sendProposal: boolean };

export type SendPolicyMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  silent: Scalars['Boolean']['input'];
}>;


export type SendPolicyMutation = { __typename?: 'Mutation', sendPolicy: boolean };

export type ArchiveProposalMutationVariables = Exact<{
  docId: Scalars['String']['input'];
}>;


export type ArchiveProposalMutation = { __typename?: 'Mutation', archiveProposal: boolean };

export type CancelPaymentMutationVariables = Exact<{
  paymentId: Scalars['String']['input'];
}>;


export type CancelPaymentMutation = { __typename?: 'Mutation', cancelPayment: boolean };

export type RecommendSimulationResultMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  resultId: Scalars['String']['input'];
}>;


export type RecommendSimulationResultMutation = { __typename?: 'Mutation', recommendSimulationResult: boolean };

export type RemoveRecommendedSimulationResultMutationVariables = Exact<{
  docId: Scalars['String']['input'];
}>;


export type RemoveRecommendedSimulationResultMutation = { __typename?: 'Mutation', removeRecommendedSimulationResult: boolean };

export type SetDocumentContactMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  contactId: Scalars['String']['input'];
}>;


export type SetDocumentContactMutation = { __typename?: 'Mutation', setDocumentContact: boolean };

export type CreatePaymentCopyMutationVariables = Exact<{
  paymentId: Scalars['String']['input'];
}>;


export type CreatePaymentCopyMutation = { __typename?: 'Mutation', createPaymentCopy: boolean };

export type CreateFormResponseMutationVariables = Exact<{
  formId: Scalars['String']['input'];
  metadata: Scalars['JSON']['input'];
}>;


export type CreateFormResponseMutation = { __typename?: 'Mutation', createFormResponse: { __typename?: 'FormResponse', _id?: string | null } };

export type UpsertFormFieldMutationVariables = Exact<{
  formResponseId: Scalars['String']['input'];
  fieldPath: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
}>;


export type UpsertFormFieldMutation = { __typename?: 'Mutation', upsertFormField: Array<any | null> };

export type SubmitFormResponseMutationVariables = Exact<{
  formResponseId: Scalars['String']['input'];
}>;


export type SubmitFormResponseMutation = { __typename?: 'Mutation', submitFormResponse: any };

export type SendTransactionalEventMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  event: TransactionalEvents;
}>;


export type SendTransactionalEventMutation = { __typename?: 'Mutation', sendTransactionalEvent: any };

export type CreateFormResponseV2MutationVariables = Exact<{
  formId: Scalars['String']['input'];
  metadata: Scalars['JSON']['input'];
}>;


export type CreateFormResponseV2Mutation = { __typename?: 'Mutation', createFormResponseV2: string };

export type UpdateFormFieldV2MutationVariables = Exact<{
  formResponseId: Scalars['String']['input'];
  fieldPath: Scalars['String']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type UpdateFormFieldV2Mutation = { __typename?: 'Mutation', updateFormFieldV2: Array<{ __typename?: 'FieldUpdateResponseV2', fieldPath: string, value?: any | null, error?: string | null, required?: any | null, invisible?: any | null, label?: string | null, options?: any | null, domain?: any | null }> };

export type AddObjectListItemMutationVariables = Exact<{
  formResponseId: Scalars['String']['input'];
  fieldPath: Scalars['String']['input'];
}>;


export type AddObjectListItemMutation = { __typename?: 'Mutation', addObjectListItem: { __typename?: 'AddObjectListItemResponse', updates: Array<{ __typename?: 'FieldUpdateResponseV2', fieldPath: string, value?: any | null, error?: string | null, required?: any | null, invisible?: any | null, label?: string | null, options?: any | null, domain?: any | null }>, newItem: { __typename?: 'FormFieldV2', name: string, type: InputTypes, required?: boolean | null, value?: any | null, error?: string | null, fieldPath: string, saveAs?: string | null, domain?: any | null, serviceName?: Services | null, accept?: string | null, subSection?: boolean | null, disabled?: boolean | null, invisible?: boolean | null, divider?: string | null, label: string, labelDisplay?: LabelDisplay | null, inputType: FormInputTypes, inputMask?: string | null, variant?: InputVariant | null, inputProps?: any | null, group: string, allowAdd?: boolean | null, allowDelete?: boolean | null, allowCopy?: boolean | null, fields?: Array<{ __typename?: 'FormFieldV2', name: string, type: InputTypes, required?: boolean | null, value?: any | null, error?: string | null, fieldPath: string, saveAs?: string | null, domain?: any | null, serviceName?: Services | null, accept?: string | null, subSection?: boolean | null, disabled?: boolean | null, invisible?: boolean | null, divider?: string | null, label: string, labelDisplay?: LabelDisplay | null, inputType: FormInputTypes, inputMask?: string | null, variant?: InputVariant | null, inputProps?: any | null, group: string, allowAdd?: boolean | null, allowDelete?: boolean | null, allowCopy?: boolean | null, fields?: Array<{ __typename?: 'FormFieldV2', name: string, type: InputTypes, required?: boolean | null, value?: any | null, error?: string | null, fieldPath: string, saveAs?: string | null, domain?: any | null, serviceName?: Services | null, accept?: string | null, subSection?: boolean | null, disabled?: boolean | null, invisible?: boolean | null, divider?: string | null, label: string, labelDisplay?: LabelDisplay | null, inputType: FormInputTypes, inputMask?: string | null, variant?: InputVariant | null, inputProps?: any | null, group: string, allowAdd?: boolean | null, allowDelete?: boolean | null, allowCopy?: boolean | null, fields?: Array<{ __typename?: 'FormFieldV2', name: string, type: InputTypes, required?: boolean | null, value?: any | null, error?: string | null, fieldPath: string, saveAs?: string | null, domain?: any | null, serviceName?: Services | null, accept?: string | null, subSection?: boolean | null, disabled?: boolean | null, invisible?: boolean | null, divider?: string | null, label: string, labelDisplay?: LabelDisplay | null, inputType: FormInputTypes, inputMask?: string | null, variant?: InputVariant | null, inputProps?: any | null, group: string, allowAdd?: boolean | null, allowDelete?: boolean | null, allowCopy?: boolean | null, options?: Array<{ __typename?: 'FormInputOptions', value: string, label: string }> | null }> | null, options?: Array<{ __typename?: 'FormInputOptions', value: string, label: string }> | null }> | null, options?: Array<{ __typename?: 'FormInputOptions', value: string, label: string }> | null }> | null, options?: Array<{ __typename?: 'FormInputOptions', value: string, label: string }> | null } } };

export type CopyObjectListItemMutationVariables = Exact<{
  formResponseId: Scalars['String']['input'];
  fieldPath: Scalars['String']['input'];
}>;


export type CopyObjectListItemMutation = { __typename?: 'Mutation', copyObjectListItem: { __typename?: 'AddObjectListItemResponse', updates: Array<{ __typename?: 'FieldUpdateResponseV2', fieldPath: string, value?: any | null, error?: string | null, required?: any | null, invisible?: any | null, label?: string | null, options?: any | null, domain?: any | null }>, newItem: { __typename?: 'FormFieldV2', name: string, type: InputTypes, required?: boolean | null, value?: any | null, error?: string | null, fieldPath: string, saveAs?: string | null, domain?: any | null, serviceName?: Services | null, accept?: string | null, subSection?: boolean | null, disabled?: boolean | null, invisible?: boolean | null, divider?: string | null, label: string, labelDisplay?: LabelDisplay | null, inputType: FormInputTypes, inputMask?: string | null, variant?: InputVariant | null, inputProps?: any | null, group: string, allowAdd?: boolean | null, allowDelete?: boolean | null, allowCopy?: boolean | null, fields?: Array<{ __typename?: 'FormFieldV2', name: string, type: InputTypes, required?: boolean | null, value?: any | null, error?: string | null, fieldPath: string, saveAs?: string | null, domain?: any | null, serviceName?: Services | null, accept?: string | null, subSection?: boolean | null, disabled?: boolean | null, invisible?: boolean | null, divider?: string | null, label: string, labelDisplay?: LabelDisplay | null, inputType: FormInputTypes, inputMask?: string | null, variant?: InputVariant | null, inputProps?: any | null, group: string, allowAdd?: boolean | null, allowDelete?: boolean | null, allowCopy?: boolean | null, fields?: Array<{ __typename?: 'FormFieldV2', name: string, type: InputTypes, required?: boolean | null, value?: any | null, error?: string | null, fieldPath: string, saveAs?: string | null, domain?: any | null, serviceName?: Services | null, accept?: string | null, subSection?: boolean | null, disabled?: boolean | null, invisible?: boolean | null, divider?: string | null, label: string, labelDisplay?: LabelDisplay | null, inputType: FormInputTypes, inputMask?: string | null, variant?: InputVariant | null, inputProps?: any | null, group: string, allowAdd?: boolean | null, allowDelete?: boolean | null, allowCopy?: boolean | null, fields?: Array<{ __typename?: 'FormFieldV2', name: string, type: InputTypes, required?: boolean | null, value?: any | null, error?: string | null, fieldPath: string, saveAs?: string | null, domain?: any | null, serviceName?: Services | null, accept?: string | null, subSection?: boolean | null, disabled?: boolean | null, invisible?: boolean | null, divider?: string | null, label: string, labelDisplay?: LabelDisplay | null, inputType: FormInputTypes, inputMask?: string | null, variant?: InputVariant | null, inputProps?: any | null, group: string, allowAdd?: boolean | null, allowDelete?: boolean | null, allowCopy?: boolean | null, options?: Array<{ __typename?: 'FormInputOptions', value: string, label: string }> | null }> | null, options?: Array<{ __typename?: 'FormInputOptions', value: string, label: string }> | null }> | null, options?: Array<{ __typename?: 'FormInputOptions', value: string, label: string }> | null }> | null, options?: Array<{ __typename?: 'FormInputOptions', value: string, label: string }> | null } } };

export type DeleteObjectListItemMutationVariables = Exact<{
  formResponseId: Scalars['String']['input'];
  fieldPath: Scalars['String']['input'];
}>;


export type DeleteObjectListItemMutation = { __typename?: 'Mutation', deleteObjectListItem: Array<{ __typename?: 'FieldUpdateResponseV2', fieldPath: string, value?: any | null, error?: string | null, required?: any | null, invisible?: any | null, label?: string | null, options?: any | null, domain?: any | null }> };

export type SubmitFormResponseV2MutationVariables = Exact<{
  formResponseId: Scalars['String']['input'];
}>;


export type SubmitFormResponseV2Mutation = { __typename?: 'Mutation', submitFormResponseV2: any };

export type AddCommercialResponsibleLeadMutationVariables = Exact<{
  leadId: Scalars['String']['input'];
  responsibleId: Scalars['String']['input'];
}>;


export type AddCommercialResponsibleLeadMutation = { __typename?: 'Mutation', addCommercialResponsibleToLead: boolean };

export type AddTechnicalResponsibleLeadMutationVariables = Exact<{
  leadId: Scalars['String']['input'];
  responsibleId: Scalars['String']['input'];
}>;


export type AddTechnicalResponsibleLeadMutation = { __typename?: 'Mutation', addTechnicalResponsibleToLead: boolean };

export type ChangeLeadStatusMutationVariables = Exact<{
  leadId: Scalars['String']['input'];
  status: LeadStatus;
}>;


export type ChangeLeadStatusMutation = { __typename?: 'Mutation', changeLeadStatus: boolean };

export type RateLeadMutationVariables = Exact<{
  leadId: Scalars['String']['input'];
  rating: RatingScale;
}>;


export type RateLeadMutation = { __typename?: 'Mutation', rateLead: boolean };

export type AddCommentToLeadMutationVariables = Exact<{
  leadId: Scalars['String']['input'];
  comment: Scalars['String']['input'];
}>;


export type AddCommentToLeadMutation = { __typename?: 'Mutation', addCommentToLead: boolean };

export type CreateNoteMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  authorId: Scalars['String']['input'];
  serviceName: Services;
  text: Scalars['String']['input'];
}>;


export type CreateNoteMutation = { __typename?: 'Mutation', createNote: any };

export type RetrySimulationResultMutationVariables = Exact<{
  resultId: Scalars['String']['input'];
}>;


export type RetrySimulationResultMutation = { __typename?: 'Mutation', retrySimulationResult: boolean };

export type SendTwilioWaMessageMutationVariables = Exact<{
  contactId: Scalars['String']['input'];
  content: Scalars['String']['input'];
  files: Array<TwilioMediaInput> | TwilioMediaInput;
}>;


export type SendTwilioWaMessageMutation = { __typename?: 'Mutation', sendTwilioWAMessage: boolean };

export type ToggleUserConversationSubscriptionMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  contactId: Scalars['String']['input'];
  shouldAdd: Scalars['Boolean']['input'];
}>;


export type ToggleUserConversationSubscriptionMutation = { __typename?: 'Mutation', toggleUserConversationSubscription: boolean };

export type AddCourseToUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  finishedCourse: Scalars['Boolean']['input'];
}>;


export type AddCourseToUserMutation = { __typename?: 'Mutation', addCourseToUser: boolean };

export type RefreshLastAccessAtMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type RefreshLastAccessAtMutation = { __typename?: 'Mutation', refreshLastAccessAt: boolean };

export type SignUserTermsMutationVariables = Exact<{ [key: string]: never; }>;


export type SignUserTermsMutation = { __typename?: 'Mutation', signUserTerms: boolean };

export type EnableUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type EnableUserMutation = { __typename?: 'Mutation', enableUser: boolean };

export type DisableUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type DisableUserMutation = { __typename?: 'Mutation', disableUser: boolean };

export type UpgradeUserToAdminMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type UpgradeUserToAdminMutation = { __typename?: 'Mutation', upgradeUserToAdmin: boolean };

export type GetCreateClaimOnFormResponseQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type GetCreateClaimOnFormResponseQuery = { __typename?: 'Query', getCreateClaimOnFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditClaimOnFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditClaimOnFormResponseQuery = { __typename?: 'Query', getEditClaimOnFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditConclusionLetterOnClaimQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditConclusionLetterOnClaimQuery = { __typename?: 'Query', getEditConclusionLetterOnClaim: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditEstimatedIndemnityOnClaimQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditEstimatedIndemnityOnClaimQuery = { __typename?: 'Query', getEditEstimatedIndemnityOnClaim: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditContestationLetterOnClaimQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditContestationLetterOnClaimQuery = { __typename?: 'Query', getEditContestationLetterOnClaim: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditHarvestDatesLettersOnClaimFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditHarvestDatesLettersOnClaimFormResponseQuery = { __typename?: 'Query', getEditHarvestDatesLettersOnClaimFormResponse: { __typename?: 'FormRequestResponse', formResponseId: string, formId: string } };

export type ListClaimsQueryVariables = Exact<{
  filter: ClaimsFiltersInput;
}>;


export type ListClaimsQuery = { __typename?: 'Query', claims?: Array<{ __typename?: 'Claim', _id: string, documentId: string, externalId: string, noticeDate: any, events: Array<ClaimEvent>, status: ClaimStatus }> | null };

export type BaseContactFieldsFragment = { __typename?: 'Contact', _id?: string | null, name?: string | null, email?: string | null, cpfCnpj?: string | null, mobilePhone?: string | null, tags?: Array<ContactTags> | null };

export type GetContactQueryVariables = Exact<{
  contactId: Scalars['String']['input'];
}>;


export type GetContactQuery = { __typename?: 'Query', contact: { __typename?: 'Contact', rg?: string | null, emissionInstitutionId?: string | null, expeditionDate?: any | null, civilState?: CivilStates | null, birthDate?: any | null, gender?: string | null, professionId?: string | null, comments?: string | null, cultureIds?: Array<string | null> | null, rating?: RatingScale | null, originatorId?: string | null, createdAt?: any | null, industry?: OrgIndustries | null, subsidiariesCount?: number | null, cities?: Array<string | null> | null, operationalArea?: OrgOperationalArea | null, membershipCount?: OrgMembershipCount | null, departmentRole?: OrgDepartmentRoles | null, orgId?: string | null, status?: UserStatus | null, responsibleId?: string | null, commission?: number | null, _id?: string | null, name?: string | null, email?: string | null, cpfCnpj?: string | null, mobilePhone?: string | null, tags?: Array<ContactTags> | null, meetings?: Array<{ __typename?: 'Meeting', _id?: string | null, status: MeetingStatus, responsibleId: string, date: any, topic: MeetingTopics, comment?: string | null, attachment?: any | null, responsible?: { __typename?: 'User', name?: string | null } | null }> | null, address?: { __typename?: 'Address', city?: string | null, state?: string | null, street?: string | null, number?: string | null, complement?: string | null, cep?: string | null } | null, parent?: { __typename?: 'Contact', _id?: string | null, name?: string | null, email?: string | null, cpfCnpj?: string | null, mobilePhone?: string | null, tags?: Array<ContactTags> | null } | null, responsible?: { __typename?: 'User', _id?: string | null, name?: string | null } | null, user?: { __typename?: 'User', _id?: string | null, role?: UserRoles | null, status?: UserStatus | null, signedDate?: any | null, createdAt?: any | null, disabled?: boolean | null, name?: string | null, email?: string | null, phone?: string | null, profession?: string | null, finishedCourse?: boolean | null, contactId?: string | null, lastAccessAt?: any | null } | null, members?: Array<{ __typename?: 'Contact', departmentRole?: OrgDepartmentRoles | null, _id?: string | null, name?: string | null, email?: string | null, cpfCnpj?: string | null, mobilePhone?: string | null, tags?: Array<ContactTags> | null }> | null } };

export type GetContactBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetContactBySlugQuery = { __typename?: 'Query', contactBySlug?: { __typename?: 'Contact', _id?: string | null } | null };

export type ListContactsQueryVariables = Exact<{
  filter: Array<Array<ContactsFiltersInput> | ContactsFiltersInput> | Array<ContactsFiltersInput> | ContactsFiltersInput;
  sort?: InputMaybe<Scalars['MongoSortQuery']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListContactsQuery = { __typename?: 'Query', contacts?: Array<{ __typename?: 'Contact', createdAt?: any | null, status?: UserStatus | null, _id?: string | null, name?: string | null, email?: string | null, cpfCnpj?: string | null, mobilePhone?: string | null, tags?: Array<ContactTags> | null, address?: { __typename?: 'Address', state?: string | null } | null, responsible?: { __typename?: 'User', name?: string | null } | null, user?: { __typename?: 'User', disabled?: boolean | null } | null }> | null };

export type CountContactsQueryVariables = Exact<{
  filter: Array<InputMaybe<Array<InputMaybe<ContactsFiltersInput>> | InputMaybe<ContactsFiltersInput>>> | InputMaybe<Array<InputMaybe<ContactsFiltersInput>> | InputMaybe<ContactsFiltersInput>>;
}>;


export type CountContactsQuery = { __typename?: 'Query', countContacts?: number | null };

export type GetEditFinancialResponsibleOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
}>;


export type GetEditFinancialResponsibleOnDocumentFormResponseQuery = { __typename?: 'Query', getEditFinancialResponsibleOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditContactOnFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditContactOnFormResponseQuery = { __typename?: 'Query', getEditContactOnFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetCreateOrgMembersFormResponseQueryVariables = Exact<{
  orgId: Scalars['String']['input'];
}>;


export type GetCreateOrgMembersFormResponseQuery = { __typename?: 'Query', getCreateOrgMembersFormResponse: { __typename?: 'FormRequestResponse', formResponseId: string, formId: string } };

export type GetOrgWithMembersQueryVariables = Exact<{
  contactId: Scalars['String']['input'];
}>;


export type GetOrgWithMembersQuery = { __typename?: 'Query', contact: { __typename?: 'Contact', name?: string | null, slug?: string | null, industry?: OrgIndustries | null, cities?: Array<string | null> | null, subsidiariesCount?: number | null, operationalArea?: OrgOperationalArea | null, membershipCount?: OrgMembershipCount | null, members?: Array<{ __typename?: 'Contact', _id?: string | null, name?: string | null, email?: string | null, mobilePhone?: string | null, departmentRole?: OrgDepartmentRoles | null }> | null } };

export type GetPartnersDashboardDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPartnersDashboardDataQuery = { __typename?: 'Query', getPartnersDashboardData: Array<{ __typename?: 'PartnersDashboardGroupData', tag: ContactTags, statusGroups: Array<{ __typename?: 'PartnersDashboardGroupStatusData', status: string, count: number }> }> };

export type GetEditCropOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
}>;


export type GetEditCropOnDocumentFormResponseQuery = { __typename?: 'Query', getEditCropOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetCreateKmlFileUploadFormResponseQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type GetCreateKmlFileUploadFormResponseQuery = { __typename?: 'Query', getCreateKmlFileUploadFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type CulturesQueryVariables = Exact<{ [key: string]: never; }>;


export type CulturesQuery = { __typename?: 'Query', cultures: Array<{ __typename?: 'Culture', _id?: string | null, name?: string | null, currentSackValue?: number | null, active?: boolean | null }> };

export type CultureQueryVariables = Exact<{
  cultureId: Scalars['String']['input'];
}>;


export type CultureQuery = { __typename?: 'Query', culture?: { __typename?: 'Culture', _id?: string | null, name?: string | null, currentSackValue?: number | null, active?: boolean | null, allianzSettings?: Array<{ __typename?: 'IntegrationSettings', _id: string, cultureId: string, allianz?: { __typename?: 'AllianzSettings', percentualComissao: number, custoEstimado?: number | null, percentualDesconto: number, quantidadeParcelas: number, cultura: { __typename?: 'FormInputOptions', label: string, value: string }, culturaAnterior: { __typename?: 'FormInputOptions', label: string, value: string }, tipoProduto: { __typename?: 'FormInputOptions', label: string, value: string }, tecnicaPlantio: { __typename?: 'FormInputOptions', label: string, value: string }, custeioProvenienteCreditoRurual: { __typename?: 'FormInputOptions', label: string, value: string }, codigoNivelCobertura: { __typename?: 'FormInputOptions', label: string, value: string }, percentualProdutividadeEstimada: { __typename?: 'FormInputOptions', label: string, value: string }, valorSaca?: { __typename?: 'FormInputOptions', label: string, value: string } | null, regulacaoSinistro: { __typename?: 'FormInputOptions', label: string, value: string }, texturaSolo: { __typename?: 'FormInputOptions', label: string, value: string }, realizadoControleFitosantitario: { __typename?: 'FormInputOptions', label: string, value: string }, grupoCultivar: { __typename?: 'FormInputOptions', label: string, value: string }, codigoCultivar: { __typename?: 'FormInputOptions', label: string, value: string }, corte?: { __typename?: 'FormInputOptions', label: string, value: string } | null, franquia: { __typename?: 'FormInputOptions', label: string, value: string }, coberturas: Array<{ __typename?: 'FormInputOptions', label: string, value: string }>, formaPagamento: { __typename?: 'FormInputOptions', label: string, value: string } } | null }> | null } | null };

export type GetEditCultureFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditCultureFormResponseQuery = { __typename?: 'Query', getEditCultureFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type ForestItemFieldsFragment = { __typename?: 'ForestItem', area: number, harvestCycleDuration: number, speciesId: string, managementId: string, propertyId: string, plantYear?: number | null, species: { __typename?: 'ForestSpecies', name: string }, management: { __typename?: 'ForestManagement', name: string }, property: { __typename?: 'Property', displayName?: string | null } };

export type ListDocumentsQueryVariables = Exact<{
  filter: Array<InputMaybe<Array<InputMaybe<DocumentsFilterInput>> | InputMaybe<DocumentsFilterInput>>> | InputMaybe<Array<InputMaybe<DocumentsFilterInput>> | InputMaybe<DocumentsFilterInput>>;
  sort?: InputMaybe<Scalars['MongoSortQuery']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListDocumentsQuery = { __typename?: 'Query', documents: Array<{ __typename?: 'InsuranceDocument', _id: string, stage?: DocumentStages | null, status?: DocumentStatus | null, updatedAt?: any | null, createdAt?: any | null, claimStatus?: DocumentClaimStatus | null, premium?: number | null, commercialResponsibleId?: string | null, description?: string | null, provider?: PropostaProviders | null, operationalResponsibleId?: string | null, originatorId?: string | null, insuranceTypeGroup: InsuranceTypeGroupEnum, forestItems?: Array<{ __typename?: 'ForestItem', area: number }> | null, commercialResponsible?: { __typename?: 'User', name?: string | null } | null, operationalResponsible?: { __typename?: 'User', name?: string | null } | null, claimResponsible?: { __typename?: 'User', name?: string | null } | null, originator?: { __typename?: 'Contact', name?: string | null } | null, farmer?: { __typename?: 'Contact', name?: string | null } | null, crop?: { __typename?: 'Crop', cultureName?: string | null, area?: number | null, culture?: { __typename?: 'Culture', name?: string | null } | null } | null, properties?: Array<{ __typename?: 'Property', displayName?: string | null, address?: { __typename?: 'Address', city?: string | null, state?: string | null } | null }> | null }> };

export type CountDocumentsQueryVariables = Exact<{
  filter: Array<InputMaybe<Array<InputMaybe<DocumentsFilterInput>> | InputMaybe<DocumentsFilterInput>>> | InputMaybe<Array<InputMaybe<DocumentsFilterInput>> | InputMaybe<DocumentsFilterInput>>;
}>;


export type CountDocumentsQuery = { __typename?: 'Query', countDocuments?: number | null };

export type GetComplementaryDataFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetComplementaryDataFormResponseQuery = { __typename?: 'Query', getComplementaryDataFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetNfeUploadFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetNfeUploadFormResponseQuery = { __typename?: 'Query', getNfeUploadFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditPaymentDataOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditPaymentDataOnDocumentFormResponseQuery = { __typename?: 'Query', getEditPaymentDataOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetDocumentRejectionFormResponseQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type GetDocumentRejectionFormResponseQuery = { __typename?: 'Query', getDocumentRejectionFormResponse: { __typename?: 'FormRequestResponse', formResponseId: string, formId: string } };

export type GetDocumentsDashboardCountersQueryVariables = Exact<{
  filter: Array<InputMaybe<Array<InputMaybe<DocumentsFilterInput>> | InputMaybe<DocumentsFilterInput>>> | InputMaybe<Array<InputMaybe<DocumentsFilterInput>> | InputMaybe<DocumentsFilterInput>>;
}>;


export type GetDocumentsDashboardCountersQuery = { __typename?: 'Query', getDocumentsDashboardCounters?: Array<{ __typename?: 'CategoryDashboardCounters', count: number, value: string, statuses?: Array<{ __typename?: 'StatusDashboardCounters', count: number, value: string }> | null }> | null };

export type GetDocumentsDashboardFunnelQueryVariables = Exact<{
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
  filter: Array<InputMaybe<Array<InputMaybe<DocumentsFilterInput>> | InputMaybe<DocumentsFilterInput>>> | InputMaybe<Array<InputMaybe<DocumentsFilterInput>> | InputMaybe<DocumentsFilterInput>>;
}>;


export type GetDocumentsDashboardFunnelQuery = { __typename?: 'Query', getDocumentsDashboardFunnel?: Array<{ __typename?: 'DashboardFunnelValue', category: string, value: number }> | null };

export type GetDocumentDetailsQueryVariables = Exact<{
  docId: Scalars['String']['input'];
}>;


export type GetDocumentDetailsQuery = { __typename?: 'Query', document?: { __typename?: 'InsuranceDocument', _id: string, createdAt?: any | null, updatedAt?: any | null, stage?: DocumentStages | null, status?: DocumentStatus | null, provider?: PropostaProviders | null, selectedResultIds?: Array<string> | null, recommendedSimulationResultId?: string | null, justificationMessage?: string | null, insuranceTypeGroup: InsuranceTypeGroupEnum, commercialResponsibleId?: string | null, operationalResponsibleId?: string | null, claimResponsibleId?: string | null, originatorId?: string | null, specialOperationId?: string | null, premium?: number | null, archived?: boolean | null, proposalResultId?: string | null, contactId: string, description?: string | null, claimStatus?: DocumentClaimStatus | null, rejectReason?: { __typename?: 'DocumentReject', other?: string | null, rejectReason: DocumentRejectReason } | null, forestItems?: Array<{ __typename?: 'ForestItem', area: number, harvestCycleDuration: number, speciesId: string, managementId: string, propertyId: string, plantYear?: number | null, species: { __typename?: 'ForestSpecies', name: string }, management: { __typename?: 'ForestManagement', name: string }, property: { __typename?: 'Property', displayName?: string | null } }> | null, visitPerson?: { __typename?: 'Contact', name?: string | null } | null, costNFFiles?: Array<{ __typename?: 'File', fileName?: string | null, fileKey?: string | null }> | null, kmlFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, crop?: { __typename?: 'Crop', _id?: string | null, area?: number | null, cultureName?: string | null, harvestStartDate?: any | null, harvestEndDate?: any | null, cultureId?: string | null, plantDate?: any | null, manualCulture?: string | null, compositionType?: any | null, cropYear?: string | null, culture?: { __typename?: 'Culture', name?: string | null } | null, cultureDetail?: { __typename?: 'CultureDetail', name?: string | null } | null, kmlFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, plots?: Array<{ __typename?: 'Plot', name?: string | null, area?: number | null, plantDate?: any | null, plantMethod?: string | null, soilType?: any | null, irrigated?: boolean | null, cropYear?: string | null, plantSpacing?: number | null, lineSpacing?: number | null, seedType?: string | null, polygon?: Array<any | null> | null, cultureDetail?: { __typename?: 'CultureDetail', name?: string | null } | null }> | null } | null, farmer?: { __typename?: 'Contact', _id?: string | null, name?: string | null, cpfCnpj?: string | null, mobilePhone?: string | null, email?: string | null, rg?: string | null, emissionInstitution?: string | null, expeditionDate?: any | null, civilState?: CivilStates | null, gender?: string | null, birthDate?: any | null, profession?: string | null, documentFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, addressProofFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, address?: { __typename?: 'Address', city?: string | null, state?: string | null, street?: string | null, number?: string | null, complement?: string | null, cep?: string | null, neighborhood?: string | null } | null } | null, properties?: Array<{ __typename?: 'Property', _id?: string | null, accessInstructions?: string | null, entranceLocation?: any | null, displayName?: string | null, name?: string | null, carRegistration?: string | null, address?: { __typename?: 'Address', city?: string | null, state?: string | null, street?: string | null, number?: string | null, complement?: string | null, cep?: string | null } | null, plots?: Array<{ __typename?: 'Plot', name?: string | null, area?: number | null, plantDate?: any | null, plantMethod?: string | null, soilType?: any | null, irrigated?: boolean | null, cropYear?: string | null, plantSpacing?: number | null, lineSpacing?: number | null, cultureDetail?: { __typename?: 'CultureDetail', name?: string | null } | null } | null> | null }> | null, equipments?: Array<{ __typename?: 'DocumentEquipment', isRenewal?: boolean | null, previousProvider?: PropostaProviders | null, marketValue?: number | null, isNewEquipment?: boolean | null, isFinanced?: boolean | null, isLeased?: boolean | null, isNearWater?: boolean | null, serialNumberMatch?: boolean | null, hasTheftCoverage?: boolean | null, equipment?: { __typename?: 'Equipment', _id?: string | null, name: string, type?: string | null, brand?: string | null, model: string, manufactureYear: number, marketValue?: number | null, property?: { __typename?: 'Property', displayName?: string | null } | null } | null }> | null, failedSimulationResults?: Array<{ __typename?: 'Result', _id?: string | null, error?: string | null, provider?: PropostaProviders | null, basicCoverageType?: BasicCoverageTypes | null } | null> | null, validSimulationResults?: Array<{ __typename?: 'Result', _id?: string | null, status?: ResultStatus | null, provider?: PropostaProviders | null, basicCoverageType?: BasicCoverageTypes | null, guaranteedProductivity?: number | null, sackValue?: number | null, tags?: Array<ResultTags | null> | null, referenceLocation?: string | null, points?: { __typename?: 'ResultPoints', totalPremium?: number | null, sackValueDifference?: number | null, guaranteedProductivity?: number | null, totalPoints?: number | null } | null, itens?: Array<{ __typename?: 'ResultItem', name?: string | null, coverages: Array<{ __typename?: 'ResultCoverage', name?: string | null, lmi?: number | null, premium?: number | null, coverageEvents?: Array<{ __typename?: 'CoverageEvent', _id?: string | null, name: string }> | null }> }> | null, amounts?: { __typename?: 'ResultAmounts', lmi?: number | null, totalPremium?: number | null, stateSubvention?: number | null, federalSubvention?: number | null, finalPremium?: number | null, maxPayments?: number | null } | null } | null> | null, simulationResults?: Array<{ __typename?: 'Result', _id?: string | null, externalId?: string | null, status?: ResultStatus | null, error?: string | null, name?: string | null, provider?: PropostaProviders | null, basicCoverageType?: BasicCoverageTypes | null, guaranteedProductivity?: number | null, sackValue?: number | null, referenceLocation?: string | null, itens?: Array<{ __typename?: 'ResultItem', name?: string | null, coverages: Array<{ __typename?: 'ResultCoverage', name?: string | null, lmi?: number | null, premium?: number | null, coverageEvents?: Array<{ __typename?: 'CoverageEvent', _id?: string | null, name: string }> | null }> }> | null, amounts?: { __typename?: 'ResultAmounts', lmi?: number | null, totalPremium?: number | null, stateSubvention?: number | null, federalSubvention?: number | null, finalPremium?: number | null, maxPayments?: number | null } | null } | null> | null, selectedSimulationResults?: Array<{ __typename?: 'Result', _id?: string | null, name?: string | null, provider?: PropostaProviders | null, status?: ResultStatus | null, basicCoverageType?: BasicCoverageTypes | null, guaranteedProductivity?: number | null, sackValue?: number | null, tags?: Array<ResultTags | null> | null, referenceLocation?: string | null, amounts?: { __typename?: 'ResultAmounts', lmi?: number | null, totalPremium?: number | null, maxPayments?: number | null, stateSubvention?: number | null, federalSubvention?: number | null, finalPremium?: number | null } | null, itens?: Array<{ __typename?: 'ResultItem', name?: string | null, coverages: Array<{ __typename?: 'ResultCoverage', name?: string | null, lmi?: number | null, premium?: number | null, coverageEvents?: Array<{ __typename?: 'CoverageEvent', _id?: string | null, name: string }> | null }> }> | null } | null> | null, proposalResult?: { __typename?: 'Result', _id?: string | null, externalId?: string | null, name?: string | null, provider?: PropostaProviders | null, basicCoverageType?: BasicCoverageTypes | null, guaranteedProductivity?: number | null, proposalFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, proposalSketchMap?: { __typename?: 'File', _id?: string | null, fileName?: string | null, fileKey?: string | null } | null, signedProposalFile?: { __typename?: 'File', _id?: string | null, fileName?: string | null, fileKey?: string | null } | null, amounts?: { __typename?: 'ResultAmounts', lmi?: number | null, totalPremium?: number | null, maxPayments?: number | null, stateSubvention?: number | null, federalSubvention?: number | null, finalPremium?: number | null } | null, itens?: Array<{ __typename?: 'ResultItem', name?: string | null, coverages: Array<{ __typename?: 'ResultCoverage', name?: string | null, lmi?: number | null, premium?: number | null, coverageEvents?: Array<{ __typename?: 'CoverageEvent', _id?: string | null, name: string }> | null }> }> | null } | null, beneficiary?: { __typename?: 'Contact', _id?: string | null, name?: string | null, cpfCnpj?: string | null, mobilePhone?: string | null, email?: string | null, rg?: string | null, emissionInstitution?: string | null, expeditionDate?: any | null, civilState?: CivilStates | null, gender?: string | null, birthDate?: any | null, profession?: string | null, documentFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, addressProofFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, address?: { __typename?: 'Address', city?: string | null, state?: string | null, street?: string | null, number?: string | null, complement?: string | null, cep?: string | null } | null } | null, allowedVisitPeople?: Array<{ __typename?: 'Contact', name?: string | null, cpfCnpj?: string | null, mobilePhone?: string | null, email?: string | null }> | null, policy?: { __typename?: 'Policy', _id: string, endDate: any, startDate: any, externalId: string, billsFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, policyFile: { __typename?: 'File', fileName?: string | null, fileKey?: string | null }, cancellationReason?: { __typename?: 'PolicyCancellation', other?: string | null, cancellationReason: PolicyCancellationReason } | null } | null, paymentData?: { __typename?: 'PaymentData', method?: PaymentMethods | null, responsibleId?: string | null, installments?: number | null, accountData?: { __typename?: 'AccountData', bank?: string | null, agency?: string | null, agencyDigit?: string | null, account?: string | null, accountDigit?: string | null } | null, responsible?: { __typename?: 'Contact', _id?: string | null, name?: string | null, cpfCnpj?: string | null, mobilePhone?: string | null, email?: string | null, rg?: string | null, emissionInstitution?: string | null, expeditionDate?: any | null, civilState?: CivilStates | null, gender?: string | null, birthDate?: any | null, profession?: string | null, documentFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, addressProofFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, address?: { __typename?: 'Address', city?: string | null, state?: string | null, street?: string | null, number?: string | null, complement?: string | null, cep?: string | null } | null } | null } | null, payments?: Array<{ __typename?: 'Payment', _id: string, responsibleId: string, provider: PropostaProviders, name: string, dateDue: any, amount: number, status: PaymentStatus, subventionType?: SubventionType | null, billFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null }> | null, archivedProposals?: Array<{ __typename?: 'Result', _id?: string | null, externalId?: string | null, provider?: PropostaProviders | null, basicCoverageType?: BasicCoverageTypes | null, type?: ResultTypes | null, insuranceTypeGroup?: InsuranceTypeGroupEnum | null, guaranteedProductivity?: number | null }> | null, claims?: Array<{ __typename?: 'Claim', _id: string, name: string, externalId: string, status: ClaimStatus, events: Array<ClaimEvent>, plots?: Array<string> | null, coverages: Array<string>, startDate: any, endDate?: any | null, lossEstimate: LossEstimate, comment?: string | null, createdAt: any, protocolNumber?: string | null, noticeDate: any, indemnityAmount?: number | null, indemnityPaymentDate?: any | null, estimatedIndemnity?: number | null, contestationProtocolNumber?: number | null, dateOfReanalysis?: any | null, reportFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, contestationLetterFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, harvestStartDateLetterFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, harvestEndDateLetterFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, harvestStartDateSignedLetterFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, harvestEndDateSignedLetterFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null }> | null, inspections?: Array<{ __typename?: 'Inspection', _id: string, documentId: string, status: InspectionStatus, type: InspectionType, date: any, regulatoryAgency: string, observation?: string | null, claims?: Array<{ __typename?: 'Claim', name: string } | null> | null, inspector?: { __typename?: 'Contact', name?: string | null, mobilePhone?: string | null } | null, reportFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null }> | null, endorsements?: Array<{ __typename?: 'Endorsement', _id: string, documentId: string, status: EndorsementStatus, reason: EndorsementReason, otherReason?: string | null, description: string, externalId: string, rejectionReason?: string | null, answerDate?: any | null, consentFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, endorsementFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, rejectionFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null }> | null } | null };

export type GetDirectDocumentDetailsQueryVariables = Exact<{
  docId: Scalars['String']['input'];
}>;


export type GetDirectDocumentDetailsQuery = { __typename?: 'Query', document?: { __typename?: 'InsuranceDocument', _id: string, stage?: DocumentStages | null, status?: DocumentStatus | null, justificationMessage?: string | null, recommendedSimulationResultId?: string | null, insuranceTypeGroup: InsuranceTypeGroupEnum, premium?: number | null, createdAt?: any | null, description?: string | null, forestItemIds?: Array<string> | null, specialOperationId?: string | null, equipments?: Array<{ __typename?: 'DocumentEquipment', equipment?: { __typename?: 'Equipment', _id?: string | null } | null }> | null, crop?: { __typename?: 'Crop', area?: number | null, cultureName?: string | null, manualCulture?: string | null, culture?: { __typename?: 'Culture', name?: string | null } | null, cultureDetail?: { __typename?: 'CultureDetail', name?: string | null } | null } | null, farmer?: { __typename?: 'Contact', name?: string | null, cpfCnpj?: string | null } | null, properties?: Array<{ __typename?: 'Property', name?: string | null, plots?: Array<{ __typename?: 'Plot', name?: string | null, area?: number | null, plantDate?: any | null, plantMethod?: string | null, soilType?: any | null, irrigated?: boolean | null, cropYear?: string | null, plantSpacing?: number | null, lineSpacing?: number | null, cultureDetail?: { __typename?: 'CultureDetail', name?: string | null } | null } | null> | null, address?: { __typename?: 'Address', city?: string | null, state?: string | null } | null }> | null, forestItems?: Array<{ __typename?: 'ForestItem', area: number, harvestCycleDuration: number, speciesId: string, managementId: string, propertyId: string, plantYear?: number | null, species: { __typename?: 'ForestSpecies', name: string }, management: { __typename?: 'ForestManagement', name: string }, property: { __typename?: 'Property', displayName?: string | null } }> | null, selectedSimulationResults?: Array<{ __typename?: 'Result', _id?: string | null, name?: string | null, provider?: PropostaProviders | null, status?: ResultStatus | null, basicCoverageType?: BasicCoverageTypes | null, guaranteedProductivity?: number | null, sackValue?: number | null, tags?: Array<ResultTags | null> | null, referenceLocation?: string | null, points?: { __typename?: 'ResultPoints', totalPremium?: number | null, sackValueDifference?: number | null, guaranteedProductivity?: number | null, totalPoints?: number | null } | null, amounts?: { __typename?: 'ResultAmounts', lmi?: number | null, totalPremium?: number | null, maxPayments?: number | null, stateSubvention?: number | null, federalSubvention?: number | null, finalPremium?: number | null } | null, itens?: Array<{ __typename?: 'ResultItem', name?: string | null, coverages: Array<{ __typename?: 'ResultCoverage', name?: string | null, lmi?: number | null, premium?: number | null, coverageEvents?: Array<{ __typename?: 'CoverageEvent', _id?: string | null, name: string }> | null }> }> | null } | null> | null, simulationResults?: Array<{ __typename?: 'Result', _id?: string | null, name?: string | null, provider?: PropostaProviders | null, status?: ResultStatus | null, basicCoverageType?: BasicCoverageTypes | null, guaranteedProductivity?: number | null, referenceLocation?: string | null, amounts?: { __typename?: 'ResultAmounts', lmi?: number | null, totalPremium?: number | null, maxPayments?: number | null, stateSubvention?: number | null, federalSubvention?: number | null, finalPremium?: number | null } | null, itens?: Array<{ __typename?: 'ResultItem', name?: string | null, coverages: Array<{ __typename?: 'ResultCoverage', name?: string | null, lmi?: number | null, premium?: number | null, coverageEvents?: Array<{ __typename?: 'CoverageEvent', _id?: string | null, name: string }> | null }> }> | null } | null> | null } | null };

export type ListContactDocumentsQueryVariables = Exact<{
  filter: Array<InputMaybe<Array<InputMaybe<DocumentsFilterInput>> | InputMaybe<DocumentsFilterInput>>> | InputMaybe<Array<InputMaybe<DocumentsFilterInput>> | InputMaybe<DocumentsFilterInput>>;
  sort?: InputMaybe<Scalars['MongoSortQuery']['input']>;
}>;


export type ListContactDocumentsQuery = { __typename?: 'Query', documents: Array<{ __typename?: 'InsuranceDocument', _id: string, farmerId: string, updatedAt?: any | null, contactId: string, beneficiaryId?: string | null, visitPersonId?: string | null, allowedVisitPeopleIds?: Array<string | null> | null, description?: string | null, paymentData?: { __typename?: 'PaymentData', responsibleId?: string | null } | null, crop?: { __typename?: 'Crop', cultureName?: string | null, area?: number | null } | null, properties?: Array<{ __typename?: 'Property', displayName?: string | null }> | null, forestItems?: Array<{ __typename?: 'ForestItem', area: number }> | null }> };

export type GetCreateEndorsementOnDocumentFormResponseQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type GetCreateEndorsementOnDocumentFormResponseQuery = { __typename?: 'Query', getCreateEndorsementOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formResponseId: string, formId: string } };

export type GetEditEndorsementOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditEndorsementOnDocumentFormResponseQuery = { __typename?: 'Query', getEditEndorsementOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formResponseId: string, formId: string } };

export type GetCreateEndorsementAnswerOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetCreateEndorsementAnswerOnDocumentFormResponseQuery = { __typename?: 'Query', getCreateEndorsementAnswerOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formResponseId: string, formId: string } };

export type GetEditEndorsementAnswerOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditEndorsementAnswerOnDocumentFormResponseQuery = { __typename?: 'Query', getEditEndorsementAnswerOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formResponseId: string, formId: string } };

export type GetFormResponseQueryVariables = Exact<{
  formResponseId: Scalars['String']['input'];
}>;


export type GetFormResponseQuery = { __typename?: 'Query', getFormResponse?: { __typename?: 'FormResponse', formData?: any | null, formState?: any | null, errors?: any | null } | null };

export type GetCreateObjectFormResponseQueryVariables = Exact<{
  service: Services;
  formId: Scalars['String']['input'];
  payload: Scalars['JSON']['input'];
}>;


export type GetCreateObjectFormResponseQuery = { __typename?: 'Query', getCreateObjectFormResponse: string };

export type GetEditObjectFormResponseQueryVariables = Exact<{
  service: Services;
  formId: Scalars['String']['input'];
  objectId: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetEditObjectFormResponseQuery = { __typename?: 'Query', getEditObjectFormResponse: string };

export type GetShareTokenQueryVariables = Exact<{
  service: Services;
  objectId: Scalars['String']['input'];
}>;


export type GetShareTokenQuery = { __typename?: 'Query', getShareToken?: string | null };

export type GetMany2XOptionsQueryVariables = Exact<{
  serviceName: Services;
  domain: Scalars['JSON']['input'];
  searchTerm: Scalars['String']['input'];
  currentValue?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetMany2XOptionsQuery = { __typename?: 'Query', getMany2XOptions: Array<{ __typename?: 'FormDataOptions', label?: string | null, value: string }> };

export type FieldDetailsFragment = { __typename?: 'FormFieldV2', name: string, type: InputTypes, required?: boolean | null, value?: any | null, error?: string | null, fieldPath: string, saveAs?: string | null, domain?: any | null, serviceName?: Services | null, accept?: string | null, subSection?: boolean | null, disabled?: boolean | null, invisible?: boolean | null, divider?: string | null, label: string, labelDisplay?: LabelDisplay | null, inputType: FormInputTypes, inputMask?: string | null, variant?: InputVariant | null, inputProps?: any | null, group: string, allowAdd?: boolean | null, allowDelete?: boolean | null, allowCopy?: boolean | null, options?: Array<{ __typename?: 'FormInputOptions', value: string, label: string }> | null };

export type GetFormResponseV2QueryVariables = Exact<{
  formResponseId: Scalars['String']['input'];
}>;


export type GetFormResponseV2Query = { __typename?: 'Query', getFormResponseV2?: { __typename?: 'FormV2', id: string, title: string, sections: Array<{ __typename?: 'FormSectionV2', id: string, title: string, subtitle?: string | null, description?: string | null, submitText?: string | null, fields: Array<{ __typename?: 'FormFieldV2', name: string, type: InputTypes, required?: boolean | null, value?: any | null, error?: string | null, fieldPath: string, saveAs?: string | null, domain?: any | null, serviceName?: Services | null, accept?: string | null, subSection?: boolean | null, disabled?: boolean | null, invisible?: boolean | null, divider?: string | null, label: string, labelDisplay?: LabelDisplay | null, inputType: FormInputTypes, inputMask?: string | null, variant?: InputVariant | null, inputProps?: any | null, group: string, allowAdd?: boolean | null, allowDelete?: boolean | null, allowCopy?: boolean | null, fields?: Array<{ __typename?: 'FormFieldV2', name: string, type: InputTypes, required?: boolean | null, value?: any | null, error?: string | null, fieldPath: string, saveAs?: string | null, domain?: any | null, serviceName?: Services | null, accept?: string | null, subSection?: boolean | null, disabled?: boolean | null, invisible?: boolean | null, divider?: string | null, label: string, labelDisplay?: LabelDisplay | null, inputType: FormInputTypes, inputMask?: string | null, variant?: InputVariant | null, inputProps?: any | null, group: string, allowAdd?: boolean | null, allowDelete?: boolean | null, allowCopy?: boolean | null, fields?: Array<{ __typename?: 'FormFieldV2', name: string, type: InputTypes, required?: boolean | null, value?: any | null, error?: string | null, fieldPath: string, saveAs?: string | null, domain?: any | null, serviceName?: Services | null, accept?: string | null, subSection?: boolean | null, disabled?: boolean | null, invisible?: boolean | null, divider?: string | null, label: string, labelDisplay?: LabelDisplay | null, inputType: FormInputTypes, inputMask?: string | null, variant?: InputVariant | null, inputProps?: any | null, group: string, allowAdd?: boolean | null, allowDelete?: boolean | null, allowCopy?: boolean | null, fields?: Array<{ __typename?: 'FormFieldV2', name: string, type: InputTypes, required?: boolean | null, value?: any | null, error?: string | null, fieldPath: string, saveAs?: string | null, domain?: any | null, serviceName?: Services | null, accept?: string | null, subSection?: boolean | null, disabled?: boolean | null, invisible?: boolean | null, divider?: string | null, label: string, labelDisplay?: LabelDisplay | null, inputType: FormInputTypes, inputMask?: string | null, variant?: InputVariant | null, inputProps?: any | null, group: string, allowAdd?: boolean | null, allowDelete?: boolean | null, allowCopy?: boolean | null, fields?: Array<{ __typename?: 'FormFieldV2', name: string, type: InputTypes, required?: boolean | null, value?: any | null, error?: string | null, fieldPath: string, saveAs?: string | null, domain?: any | null, serviceName?: Services | null, accept?: string | null, subSection?: boolean | null, disabled?: boolean | null, invisible?: boolean | null, divider?: string | null, label: string, labelDisplay?: LabelDisplay | null, inputType: FormInputTypes, inputMask?: string | null, variant?: InputVariant | null, inputProps?: any | null, group: string, allowAdd?: boolean | null, allowDelete?: boolean | null, allowCopy?: boolean | null, options?: Array<{ __typename?: 'FormInputOptions', value: string, label: string }> | null }> | null, options?: Array<{ __typename?: 'FormInputOptions', value: string, label: string }> | null }> | null, options?: Array<{ __typename?: 'FormInputOptions', value: string, label: string }> | null }> | null, options?: Array<{ __typename?: 'FormInputOptions', value: string, label: string }> | null }> | null, options?: Array<{ __typename?: 'FormInputOptions', value: string, label: string }> | null }> }> } | null };

export type GetCreateInspectionOnFormResponseQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type GetCreateInspectionOnFormResponseQuery = { __typename?: 'Query', getCreateInspectionOnFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditInspectionOnFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
}>;


export type GetEditInspectionOnFormResponseQuery = { __typename?: 'Query', getEditInspectionOnFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditReportFileOnInspectionQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditReportFileOnInspectionQuery = { __typename?: 'Query', getEditReportFileOnInspection: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetSwissIntegrationSettingsQueryVariables = Exact<{
  provider: PropostaProviders;
}>;


export type GetSwissIntegrationSettingsQuery = { __typename?: 'Query', integrationSettings: Array<{ __typename?: 'IntegrationSettings', _id: string, culture?: { __typename?: 'Culture', name?: string | null } | null, swiss?: { __typename?: 'SwissSettings', productCode?: string | null, systemCode?: string | null, soilTypeCode?: string | null, valRiscoNomeado?: number | null, valSaca?: number | null, plantDate?: any | null } | null }> };

export type GetSwissStateIntegrationSettingsQueryVariables = Exact<{
  settingId: Scalars['String']['input'];
}>;


export type GetSwissStateIntegrationSettingsQuery = { __typename?: 'Query', integrationSetting: { __typename?: 'IntegrationSettings', _id: string, swiss?: { __typename?: 'SwissSettings', stateSettings?: Array<{ __typename?: 'SwissStateSettings', states?: Array<string | null> | null, valCusteio: number }> | null } | null } };

export type GetCreateIntegrationSettingsFormResponseQueryVariables = Exact<{
  formId: Scalars['String']['input'];
  cultureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCreateIntegrationSettingsFormResponseQuery = { __typename?: 'Query', getCreateIntegrationSettingsFormResponse: { __typename?: 'FormRequestResponse', formResponseId: string, formId: string } };

export type GetEditIntegrationSettingsFormResponseQueryVariables = Exact<{
  formId: Scalars['String']['input'];
  objectId: Scalars['String']['input'];
  listIndex?: InputMaybe<Scalars['Float']['input']>;
}>;


export type GetEditIntegrationSettingsFormResponseQuery = { __typename?: 'Query', getEditIntegrationSettingsFormResponse: { __typename?: 'FormRequestResponse', formResponseId: string, formId: string } };

export type ListLeadsQueryVariables = Exact<{
  filter: Array<InputMaybe<Array<InputMaybe<LeadFiltersInput>> | InputMaybe<LeadFiltersInput>>> | InputMaybe<Array<InputMaybe<LeadFiltersInput>> | InputMaybe<LeadFiltersInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListLeadsQuery = { __typename?: 'Query', leads?: Array<{ __typename?: 'Lead', _id?: string | null, area?: number | null, type?: LeadTypes | null, status?: LeadStatus | null, name?: string | null, createdAt?: any | null, rating?: RatingScale | null, address?: { __typename?: 'Address', city?: string | null, state?: string | null, cep?: string | null } | null, cultures?: Array<{ __typename?: 'Culture', _id?: string | null, name?: string | null }> | null } | null> | null };

export type CountLeadsQueryVariables = Exact<{
  filter: Array<InputMaybe<Array<InputMaybe<LeadFiltersInput>> | InputMaybe<LeadFiltersInput>>> | InputMaybe<Array<InputMaybe<LeadFiltersInput>> | InputMaybe<LeadFiltersInput>>;
}>;


export type CountLeadsQuery = { __typename?: 'Query', countLeads?: number | null };

export type GetLeadDetailsQueryVariables = Exact<{
  leadId: Scalars['String']['input'];
}>;


export type GetLeadDetailsQuery = { __typename?: 'Query', lead?: { __typename?: 'Lead', _id?: string | null, type?: LeadTypes | null, status?: LeadStatus | null, name?: string | null, area?: number | null, comments?: string | null, createdAt?: any | null, email?: string | null, linkedin?: string | null, phone?: string | null, rating?: RatingScale | null, commercialResponsibleId?: string | null, technicalResponsibleId?: string | null, address?: { __typename?: 'Address', city?: string | null, state?: string | null, street?: string | null } | null, cultures?: Array<{ __typename?: 'Culture', _id?: string | null, name?: string | null }> | null, meetings?: Array<{ __typename?: 'Meeting', _id?: string | null, status: MeetingStatus, date: any, topic: MeetingTopics, comment?: string | null, attachment?: any | null, responsible?: { __typename?: 'User', contact?: { __typename?: 'Contact', name?: string | null } | null } | null }> | null } | null };

export type GetEditLeadOnFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditLeadOnFormResponseQuery = { __typename?: 'Query', getEditLeadOnFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetCreateMeetingOnObjectFormResponseQueryVariables = Exact<{
  parentId: Scalars['String']['input'];
  serviceName: Services;
}>;


export type GetCreateMeetingOnObjectFormResponseQuery = { __typename?: 'Query', getCreateMeetingOnObjectFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditMeetingOnObjectFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditMeetingOnObjectFormResponseQuery = { __typename?: 'Query', getEditMeetingOnObjectFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type NotesQueryVariables = Exact<{
  docId: Scalars['String']['input'];
  serviceName: Services;
}>;


export type NotesQuery = { __typename?: 'Query', notes: Array<{ __typename?: 'Note', text?: string | null, createdAt?: any | null, serviceName?: Services | null, authorId: { __typename?: 'User', name?: string | null } }> };

export type NotificationsQueryVariables = Exact<{
  serviceName: Services;
}>;


export type NotificationsQuery = { __typename?: 'Query', notifications: Array<{ __typename?: 'NotificationResponse', notificationDate: any, dateNotifications: Array<{ __typename?: 'ObjectNotifications', notificationGroup: string, groupNotifications: Array<{ __typename?: 'Notification', objectId: string, serviceName: string, createdAt: any, text: string, originInfo: string, author?: { __typename?: 'User', name?: string | null } | null }> }> }> };

export type GetCreatePaymentOnDocumentFormResponseQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type GetCreatePaymentOnDocumentFormResponseQuery = { __typename?: 'Query', getCreatePaymentOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditPaymentOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditPaymentOnDocumentFormResponseQuery = { __typename?: 'Query', getEditPaymentOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type ListPaymentsQueryVariables = Exact<{
  filter: PaymentsFiltersInput;
}>;


export type ListPaymentsQuery = { __typename?: 'Query', payments?: Array<{ __typename?: 'Payment', _id: string, documentId: string, name: string, amount: number, dateDue: any, status: PaymentStatus }> | null };

export type GetCreatePolicyOnDocumentFormResponseQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type GetCreatePolicyOnDocumentFormResponseQuery = { __typename?: 'Query', getCreatePolicyOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditPolicyOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditPolicyOnDocumentFormResponseQuery = { __typename?: 'Query', getEditPolicyOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditBillsOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditBillsOnDocumentFormResponseQuery = { __typename?: 'Query', getEditBillsOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetCancelPolicyOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
}>;


export type GetCancelPolicyOnDocumentFormResponseQuery = { __typename?: 'Query', getCancelPolicyOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditPropertyOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
}>;


export type GetEditPropertyOnDocumentFormResponseQuery = { __typename?: 'Query', getEditPropertyOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetCreateProposalOnDocumentFormResponseQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type GetCreateProposalOnDocumentFormResponseQuery = { __typename?: 'Query', getCreateProposalOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetCreateResultOnDocumentFormResponseQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type GetCreateResultOnDocumentFormResponseQuery = { __typename?: 'Query', getCreateResultOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditProposalOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditProposalOnDocumentFormResponseQuery = { __typename?: 'Query', getEditProposalOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditResultOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditResultOnDocumentFormResponseQuery = { __typename?: 'Query', getEditResultOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetCreateSignedProposalOnFormResponseQueryVariables = Exact<{
  proposalResultId: Scalars['String']['input'];
}>;


export type GetCreateSignedProposalOnFormResponseQuery = { __typename?: 'Query', getCreateSignedProposalOnFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditSignedProposalOnFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditSignedProposalOnFormResponseQuery = { __typename?: 'Query', getEditSignedProposalOnFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type ModelTasksQueryVariables = Exact<{
  serviceName: Services;
  objectId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ModelTasksQuery = { __typename?: 'Query', modelTasks: Array<{ __typename?: 'Task', modelName: string, message: string, docId: string, dateDue: any, originInfo?: string | null, responsible?: { __typename?: 'User', name?: string | null } | null }> };

export type GetTwilioWaMessagesQueryVariables = Exact<{
  contactId: Scalars['String']['input'];
}>;


export type GetTwilioWaMessagesQuery = { __typename?: 'Query', getTwilioWAMessages: { __typename?: 'TwilioConversationData', isSubscribed: boolean, messages: Array<{ __typename?: 'TwilioWAMessage', content?: string | null, sentAt?: any | null, createdAt: any, type: string, conversationId: string, templateName?: string | null, _id: string, status: TwilioWaMsgStatus, medias?: Array<{ __typename?: 'TwilioMedia', fileName?: string | null, fileKey: string, externalId?: string | null }> | null }>, contact: { __typename?: 'Contact', _id?: string | null, name?: string | null, mobilePhone?: string | null, twilioConversationId?: string | null, tags?: Array<ContactTags> | null } } };

export type GetTwilioMediaUrlQueryVariables = Exact<{
  fileKey: Scalars['String']['input'];
}>;


export type GetTwilioMediaUrlQuery = { __typename?: 'Query', getTwilioMediaUrl: string };

export type GetTwilioConversationsQueryVariables = Exact<{
  filter: ConversationsFilterInput;
}>;


export type GetTwilioConversationsQuery = { __typename?: 'Query', getTwilioConversations: Array<{ __typename?: 'TwilioConversation', notSeenCount?: number | null, lastMsg: { __typename?: 'TwilioWAMessage', content?: string | null, sentAt?: any | null, medias?: Array<{ __typename?: 'TwilioMedia', externalId?: string | null, fileName?: string | null }> | null }, contact: { __typename?: 'Contact', _id?: string | null, name?: string | null, mobilePhone?: string | null } }> };

export type CountUsersQueryVariables = Exact<{
  filter: Array<InputMaybe<Array<InputMaybe<PartnersFiltersInput>> | InputMaybe<PartnersFiltersInput>>> | InputMaybe<Array<InputMaybe<PartnersFiltersInput>> | InputMaybe<PartnersFiltersInput>>;
}>;


export type CountUsersQuery = { __typename?: 'Query', countUsers?: number | null };

export type GetUserIndicatorsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetUserIndicatorsQuery = { __typename?: 'Query', user?: { __typename?: 'User', indicators?: Array<{ __typename?: 'UserIndicator', _id?: string | null, totalArea?: number | null, totalPremium?: number | null, totalCommission?: number | null }> | null } | null };

export type OnConversationUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnConversationUpdatedSubscription = { __typename?: 'Subscription', conversationUpdated?: { __typename?: 'ConversationUpdated', conversationId: string, newMsg: boolean } | null };

export type OnMsgSeenUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnMsgSeenUpdatedSubscription = { __typename?: 'Subscription', msgSeenUpdated?: { __typename?: 'MsgSeenUpdated', userId: string } | null };

export const BaseContactFieldsFragmentDoc = gql`
    fragment BaseContactFields on Contact {
  _id
  name
  email
  cpfCnpj
  mobilePhone
  tags
}
    `;
export const ForestItemFieldsFragmentDoc = gql`
    fragment ForestItemFields on ForestItem {
  area
  harvestCycleDuration
  speciesId
  species {
    name
  }
  managementId
  management {
    name
  }
  propertyId
  property {
    displayName
  }
  plantYear
}
    `;
export const FieldDetailsFragmentDoc = gql`
    fragment FieldDetails on FormFieldV2 {
  name
  type
  required
  value
  error
  fieldPath
  options {
    value
    label
  }
  saveAs
  domain
  serviceName
  accept
  subSection
  disabled
  invisible
  divider
  label
  labelDisplay
  inputType
  inputMask
  variant
  inputProps
  group
  allowAdd
  allowDelete
  allowCopy
}
    `;
export const SetIndemnityPaidDocument = gql`
    mutation SetIndemnityPaid($objectId: String!) {
  setIndemnityPaid(objectId: $objectId)
}
    `;
export type SetIndemnityPaidMutationFn = Apollo.MutationFunction<SetIndemnityPaidMutation, SetIndemnityPaidMutationVariables>;

/**
 * __useSetIndemnityPaidMutation__
 *
 * To run a mutation, you first call `useSetIndemnityPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetIndemnityPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setIndemnityPaidMutation, { data, loading, error }] = useSetIndemnityPaidMutation({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useSetIndemnityPaidMutation(baseOptions?: Apollo.MutationHookOptions<SetIndemnityPaidMutation, SetIndemnityPaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetIndemnityPaidMutation, SetIndemnityPaidMutationVariables>(SetIndemnityPaidDocument, options);
      }
export type SetIndemnityPaidMutationHookResult = ReturnType<typeof useSetIndemnityPaidMutation>;
export type SetIndemnityPaidMutationResult = Apollo.MutationResult<SetIndemnityPaidMutation>;
export type SetIndemnityPaidMutationOptions = Apollo.BaseMutationOptions<SetIndemnityPaidMutation, SetIndemnityPaidMutationVariables>;
export const GetOrCreateContactByPhoneDocument = gql`
    mutation GetOrCreateContactByPhone($mobilePhone: String!) {
  getOrCreateContactByPhone(mobilePhone: $mobilePhone) {
    _id
  }
}
    `;
export type GetOrCreateContactByPhoneMutationFn = Apollo.MutationFunction<GetOrCreateContactByPhoneMutation, GetOrCreateContactByPhoneMutationVariables>;

/**
 * __useGetOrCreateContactByPhoneMutation__
 *
 * To run a mutation, you first call `useGetOrCreateContactByPhoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetOrCreateContactByPhoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getOrCreateContactByPhoneMutation, { data, loading, error }] = useGetOrCreateContactByPhoneMutation({
 *   variables: {
 *      mobilePhone: // value for 'mobilePhone'
 *   },
 * });
 */
export function useGetOrCreateContactByPhoneMutation(baseOptions?: Apollo.MutationHookOptions<GetOrCreateContactByPhoneMutation, GetOrCreateContactByPhoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetOrCreateContactByPhoneMutation, GetOrCreateContactByPhoneMutationVariables>(GetOrCreateContactByPhoneDocument, options);
      }
export type GetOrCreateContactByPhoneMutationHookResult = ReturnType<typeof useGetOrCreateContactByPhoneMutation>;
export type GetOrCreateContactByPhoneMutationResult = Apollo.MutationResult<GetOrCreateContactByPhoneMutation>;
export type GetOrCreateContactByPhoneMutationOptions = Apollo.BaseMutationOptions<GetOrCreateContactByPhoneMutation, GetOrCreateContactByPhoneMutationVariables>;
export const SetContactCommentsDocument = gql`
    mutation SetContactComments($contactId: String!, $comments: String!) {
  setContactComments(contactId: $contactId, comments: $comments)
}
    `;
export type SetContactCommentsMutationFn = Apollo.MutationFunction<SetContactCommentsMutation, SetContactCommentsMutationVariables>;

/**
 * __useSetContactCommentsMutation__
 *
 * To run a mutation, you first call `useSetContactCommentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetContactCommentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setContactCommentsMutation, { data, loading, error }] = useSetContactCommentsMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      comments: // value for 'comments'
 *   },
 * });
 */
export function useSetContactCommentsMutation(baseOptions?: Apollo.MutationHookOptions<SetContactCommentsMutation, SetContactCommentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetContactCommentsMutation, SetContactCommentsMutationVariables>(SetContactCommentsDocument, options);
      }
export type SetContactCommentsMutationHookResult = ReturnType<typeof useSetContactCommentsMutation>;
export type SetContactCommentsMutationResult = Apollo.MutationResult<SetContactCommentsMutation>;
export type SetContactCommentsMutationOptions = Apollo.BaseMutationOptions<SetContactCommentsMutation, SetContactCommentsMutationVariables>;
export const SetContactCulturesDocument = gql`
    mutation SetContactCultures($contactId: String!, $cultureIds: [ObjectId!]) {
  setContactCultures(contactId: $contactId, cultureIds: $cultureIds)
}
    `;
export type SetContactCulturesMutationFn = Apollo.MutationFunction<SetContactCulturesMutation, SetContactCulturesMutationVariables>;

/**
 * __useSetContactCulturesMutation__
 *
 * To run a mutation, you first call `useSetContactCulturesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetContactCulturesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setContactCulturesMutation, { data, loading, error }] = useSetContactCulturesMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      cultureIds: // value for 'cultureIds'
 *   },
 * });
 */
export function useSetContactCulturesMutation(baseOptions?: Apollo.MutationHookOptions<SetContactCulturesMutation, SetContactCulturesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetContactCulturesMutation, SetContactCulturesMutationVariables>(SetContactCulturesDocument, options);
      }
export type SetContactCulturesMutationHookResult = ReturnType<typeof useSetContactCulturesMutation>;
export type SetContactCulturesMutationResult = Apollo.MutationResult<SetContactCulturesMutation>;
export type SetContactCulturesMutationOptions = Apollo.BaseMutationOptions<SetContactCulturesMutation, SetContactCulturesMutationVariables>;
export const SetContactRatingDocument = gql`
    mutation SetContactRating($contactId: String!, $rating: RatingScale!) {
  setContactRating(contactId: $contactId, rating: $rating)
}
    `;
export type SetContactRatingMutationFn = Apollo.MutationFunction<SetContactRatingMutation, SetContactRatingMutationVariables>;

/**
 * __useSetContactRatingMutation__
 *
 * To run a mutation, you first call `useSetContactRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetContactRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setContactRatingMutation, { data, loading, error }] = useSetContactRatingMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      rating: // value for 'rating'
 *   },
 * });
 */
export function useSetContactRatingMutation(baseOptions?: Apollo.MutationHookOptions<SetContactRatingMutation, SetContactRatingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetContactRatingMutation, SetContactRatingMutationVariables>(SetContactRatingDocument, options);
      }
export type SetContactRatingMutationHookResult = ReturnType<typeof useSetContactRatingMutation>;
export type SetContactRatingMutationResult = Apollo.MutationResult<SetContactRatingMutation>;
export type SetContactRatingMutationOptions = Apollo.BaseMutationOptions<SetContactRatingMutation, SetContactRatingMutationVariables>;
export const SetContactResponsibleDocument = gql`
    mutation setContactResponsible($contactId: String!, $responsibleId: String) {
  setContactResponsible(contactId: $contactId, responsibleId: $responsibleId)
}
    `;
export type SetContactResponsibleMutationFn = Apollo.MutationFunction<SetContactResponsibleMutation, SetContactResponsibleMutationVariables>;

/**
 * __useSetContactResponsibleMutation__
 *
 * To run a mutation, you first call `useSetContactResponsibleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetContactResponsibleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setContactResponsibleMutation, { data, loading, error }] = useSetContactResponsibleMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      responsibleId: // value for 'responsibleId'
 *   },
 * });
 */
export function useSetContactResponsibleMutation(baseOptions?: Apollo.MutationHookOptions<SetContactResponsibleMutation, SetContactResponsibleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetContactResponsibleMutation, SetContactResponsibleMutationVariables>(SetContactResponsibleDocument, options);
      }
export type SetContactResponsibleMutationHookResult = ReturnType<typeof useSetContactResponsibleMutation>;
export type SetContactResponsibleMutationResult = Apollo.MutationResult<SetContactResponsibleMutation>;
export type SetContactResponsibleMutationOptions = Apollo.BaseMutationOptions<SetContactResponsibleMutation, SetContactResponsibleMutationVariables>;
export const SetContactCommissionDocument = gql`
    mutation SetContactCommission($contactId: String!, $commission: Float!) {
  setContactCommission(contactId: $contactId, commission: $commission)
}
    `;
export type SetContactCommissionMutationFn = Apollo.MutationFunction<SetContactCommissionMutation, SetContactCommissionMutationVariables>;

/**
 * __useSetContactCommissionMutation__
 *
 * To run a mutation, you first call `useSetContactCommissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetContactCommissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setContactCommissionMutation, { data, loading, error }] = useSetContactCommissionMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      commission: // value for 'commission'
 *   },
 * });
 */
export function useSetContactCommissionMutation(baseOptions?: Apollo.MutationHookOptions<SetContactCommissionMutation, SetContactCommissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetContactCommissionMutation, SetContactCommissionMutationVariables>(SetContactCommissionDocument, options);
      }
export type SetContactCommissionMutationHookResult = ReturnType<typeof useSetContactCommissionMutation>;
export type SetContactCommissionMutationResult = Apollo.MutationResult<SetContactCommissionMutation>;
export type SetContactCommissionMutationOptions = Apollo.BaseMutationOptions<SetContactCommissionMutation, SetContactCommissionMutationVariables>;
export const HandleSignupApprovalDocument = gql`
    mutation HandleSignupApproval($contactId: String!) {
  handleSignupApproval(contactId: $contactId)
}
    `;
export type HandleSignupApprovalMutationFn = Apollo.MutationFunction<HandleSignupApprovalMutation, HandleSignupApprovalMutationVariables>;

/**
 * __useHandleSignupApprovalMutation__
 *
 * To run a mutation, you first call `useHandleSignupApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHandleSignupApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [handleSignupApprovalMutation, { data, loading, error }] = useHandleSignupApprovalMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useHandleSignupApprovalMutation(baseOptions?: Apollo.MutationHookOptions<HandleSignupApprovalMutation, HandleSignupApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HandleSignupApprovalMutation, HandleSignupApprovalMutationVariables>(HandleSignupApprovalDocument, options);
      }
export type HandleSignupApprovalMutationHookResult = ReturnType<typeof useHandleSignupApprovalMutation>;
export type HandleSignupApprovalMutationResult = Apollo.MutationResult<HandleSignupApprovalMutation>;
export type HandleSignupApprovalMutationOptions = Apollo.BaseMutationOptions<HandleSignupApprovalMutation, HandleSignupApprovalMutationVariables>;
export const HandleSignupRejectionDocument = gql`
    mutation HandleSignupRejection($contactId: String!, $rejectReason: String!) {
  handleSignupRejection(contactId: $contactId, rejectReason: $rejectReason)
}
    `;
export type HandleSignupRejectionMutationFn = Apollo.MutationFunction<HandleSignupRejectionMutation, HandleSignupRejectionMutationVariables>;

/**
 * __useHandleSignupRejectionMutation__
 *
 * To run a mutation, you first call `useHandleSignupRejectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHandleSignupRejectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [handleSignupRejectionMutation, { data, loading, error }] = useHandleSignupRejectionMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      rejectReason: // value for 'rejectReason'
 *   },
 * });
 */
export function useHandleSignupRejectionMutation(baseOptions?: Apollo.MutationHookOptions<HandleSignupRejectionMutation, HandleSignupRejectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HandleSignupRejectionMutation, HandleSignupRejectionMutationVariables>(HandleSignupRejectionDocument, options);
      }
export type HandleSignupRejectionMutationHookResult = ReturnType<typeof useHandleSignupRejectionMutation>;
export type HandleSignupRejectionMutationResult = Apollo.MutationResult<HandleSignupRejectionMutation>;
export type HandleSignupRejectionMutationOptions = Apollo.BaseMutationOptions<HandleSignupRejectionMutation, HandleSignupRejectionMutationVariables>;
export const SetContactOriginatorDocument = gql`
    mutation SetContactOriginator($contactId: String!, $originatorId: String) {
  setContactOriginator(contactId: $contactId, originatorId: $originatorId)
}
    `;
export type SetContactOriginatorMutationFn = Apollo.MutationFunction<SetContactOriginatorMutation, SetContactOriginatorMutationVariables>;

/**
 * __useSetContactOriginatorMutation__
 *
 * To run a mutation, you first call `useSetContactOriginatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetContactOriginatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setContactOriginatorMutation, { data, loading, error }] = useSetContactOriginatorMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      originatorId: // value for 'originatorId'
 *   },
 * });
 */
export function useSetContactOriginatorMutation(baseOptions?: Apollo.MutationHookOptions<SetContactOriginatorMutation, SetContactOriginatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetContactOriginatorMutation, SetContactOriginatorMutationVariables>(SetContactOriginatorDocument, options);
      }
export type SetContactOriginatorMutationHookResult = ReturnType<typeof useSetContactOriginatorMutation>;
export type SetContactOriginatorMutationResult = Apollo.MutationResult<SetContactOriginatorMutation>;
export type SetContactOriginatorMutationOptions = Apollo.BaseMutationOptions<SetContactOriginatorMutation, SetContactOriginatorMutationVariables>;
export const SelectResultsDocument = gql`
    mutation SelectResults($docId: String!, $resultsIds: [String!]!) {
  selectResults(docId: $docId, resultsIds: $resultsIds)
}
    `;
export type SelectResultsMutationFn = Apollo.MutationFunction<SelectResultsMutation, SelectResultsMutationVariables>;

/**
 * __useSelectResultsMutation__
 *
 * To run a mutation, you first call `useSelectResultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectResultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectResultsMutation, { data, loading, error }] = useSelectResultsMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      resultsIds: // value for 'resultsIds'
 *   },
 * });
 */
export function useSelectResultsMutation(baseOptions?: Apollo.MutationHookOptions<SelectResultsMutation, SelectResultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelectResultsMutation, SelectResultsMutationVariables>(SelectResultsDocument, options);
      }
export type SelectResultsMutationHookResult = ReturnType<typeof useSelectResultsMutation>;
export type SelectResultsMutationResult = Apollo.MutationResult<SelectResultsMutation>;
export type SelectResultsMutationOptions = Apollo.BaseMutationOptions<SelectResultsMutation, SelectResultsMutationVariables>;
export const SetQuotationCommentDocument = gql`
    mutation SetQuotationComment($docId: String!, $message: String!) {
  setQuotationComment(docId: $docId, message: $message)
}
    `;
export type SetQuotationCommentMutationFn = Apollo.MutationFunction<SetQuotationCommentMutation, SetQuotationCommentMutationVariables>;

/**
 * __useSetQuotationCommentMutation__
 *
 * To run a mutation, you first call `useSetQuotationCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetQuotationCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setQuotationCommentMutation, { data, loading, error }] = useSetQuotationCommentMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSetQuotationCommentMutation(baseOptions?: Apollo.MutationHookOptions<SetQuotationCommentMutation, SetQuotationCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetQuotationCommentMutation, SetQuotationCommentMutationVariables>(SetQuotationCommentDocument, options);
      }
export type SetQuotationCommentMutationHookResult = ReturnType<typeof useSetQuotationCommentMutation>;
export type SetQuotationCommentMutationResult = Apollo.MutationResult<SetQuotationCommentMutation>;
export type SetQuotationCommentMutationOptions = Apollo.BaseMutationOptions<SetQuotationCommentMutation, SetQuotationCommentMutationVariables>;
export const ApproveSimulationResultDocument = gql`
    mutation ApproveSimulationResult($docId: String!, $resultId: String!, $silent: Boolean!) {
  approveSimulationResult(docId: $docId, resultId: $resultId, silent: $silent)
}
    `;
export type ApproveSimulationResultMutationFn = Apollo.MutationFunction<ApproveSimulationResultMutation, ApproveSimulationResultMutationVariables>;

/**
 * __useApproveSimulationResultMutation__
 *
 * To run a mutation, you first call `useApproveSimulationResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveSimulationResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveSimulationResultMutation, { data, loading, error }] = useApproveSimulationResultMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      resultId: // value for 'resultId'
 *      silent: // value for 'silent'
 *   },
 * });
 */
export function useApproveSimulationResultMutation(baseOptions?: Apollo.MutationHookOptions<ApproveSimulationResultMutation, ApproveSimulationResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveSimulationResultMutation, ApproveSimulationResultMutationVariables>(ApproveSimulationResultDocument, options);
      }
export type ApproveSimulationResultMutationHookResult = ReturnType<typeof useApproveSimulationResultMutation>;
export type ApproveSimulationResultMutationResult = Apollo.MutationResult<ApproveSimulationResultMutation>;
export type ApproveSimulationResultMutationOptions = Apollo.BaseMutationOptions<ApproveSimulationResultMutation, ApproveSimulationResultMutationVariables>;
export const RecedeDocumentStageDocument = gql`
    mutation RecedeDocumentStage($docId: String!, $docStatus: DocumentStatus!) {
  recedeDocumentStageToSimulation(docId: $docId, docStatus: $docStatus)
}
    `;
export type RecedeDocumentStageMutationFn = Apollo.MutationFunction<RecedeDocumentStageMutation, RecedeDocumentStageMutationVariables>;

/**
 * __useRecedeDocumentStageMutation__
 *
 * To run a mutation, you first call `useRecedeDocumentStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecedeDocumentStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recedeDocumentStageMutation, { data, loading, error }] = useRecedeDocumentStageMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      docStatus: // value for 'docStatus'
 *   },
 * });
 */
export function useRecedeDocumentStageMutation(baseOptions?: Apollo.MutationHookOptions<RecedeDocumentStageMutation, RecedeDocumentStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecedeDocumentStageMutation, RecedeDocumentStageMutationVariables>(RecedeDocumentStageDocument, options);
      }
export type RecedeDocumentStageMutationHookResult = ReturnType<typeof useRecedeDocumentStageMutation>;
export type RecedeDocumentStageMutationResult = Apollo.MutationResult<RecedeDocumentStageMutation>;
export type RecedeDocumentStageMutationOptions = Apollo.BaseMutationOptions<RecedeDocumentStageMutation, RecedeDocumentStageMutationVariables>;
export const SetCommercialResponsibleDocument = gql`
    mutation setCommercialResponsible($docId: String!, $responsibleId: String) {
  setCommercialResponsibleToDocument(docId: $docId, contactId: $responsibleId)
}
    `;
export type SetCommercialResponsibleMutationFn = Apollo.MutationFunction<SetCommercialResponsibleMutation, SetCommercialResponsibleMutationVariables>;

/**
 * __useSetCommercialResponsibleMutation__
 *
 * To run a mutation, you first call `useSetCommercialResponsibleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCommercialResponsibleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCommercialResponsibleMutation, { data, loading, error }] = useSetCommercialResponsibleMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      responsibleId: // value for 'responsibleId'
 *   },
 * });
 */
export function useSetCommercialResponsibleMutation(baseOptions?: Apollo.MutationHookOptions<SetCommercialResponsibleMutation, SetCommercialResponsibleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCommercialResponsibleMutation, SetCommercialResponsibleMutationVariables>(SetCommercialResponsibleDocument, options);
      }
export type SetCommercialResponsibleMutationHookResult = ReturnType<typeof useSetCommercialResponsibleMutation>;
export type SetCommercialResponsibleMutationResult = Apollo.MutationResult<SetCommercialResponsibleMutation>;
export type SetCommercialResponsibleMutationOptions = Apollo.BaseMutationOptions<SetCommercialResponsibleMutation, SetCommercialResponsibleMutationVariables>;
export const SetOperationalResponsibleDocument = gql`
    mutation setOperationalResponsible($docId: String!, $responsibleId: String) {
  setOperationalResponsibleToDocument(docId: $docId, contactId: $responsibleId)
}
    `;
export type SetOperationalResponsibleMutationFn = Apollo.MutationFunction<SetOperationalResponsibleMutation, SetOperationalResponsibleMutationVariables>;

/**
 * __useSetOperationalResponsibleMutation__
 *
 * To run a mutation, you first call `useSetOperationalResponsibleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOperationalResponsibleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOperationalResponsibleMutation, { data, loading, error }] = useSetOperationalResponsibleMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      responsibleId: // value for 'responsibleId'
 *   },
 * });
 */
export function useSetOperationalResponsibleMutation(baseOptions?: Apollo.MutationHookOptions<SetOperationalResponsibleMutation, SetOperationalResponsibleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetOperationalResponsibleMutation, SetOperationalResponsibleMutationVariables>(SetOperationalResponsibleDocument, options);
      }
export type SetOperationalResponsibleMutationHookResult = ReturnType<typeof useSetOperationalResponsibleMutation>;
export type SetOperationalResponsibleMutationResult = Apollo.MutationResult<SetOperationalResponsibleMutation>;
export type SetOperationalResponsibleMutationOptions = Apollo.BaseMutationOptions<SetOperationalResponsibleMutation, SetOperationalResponsibleMutationVariables>;
export const SetClaimResponsibleDocument = gql`
    mutation setClaimResponsible($docId: String!, $responsibleId: String) {
  setClaimResponsibleToDocument(docId: $docId, contactId: $responsibleId)
}
    `;
export type SetClaimResponsibleMutationFn = Apollo.MutationFunction<SetClaimResponsibleMutation, SetClaimResponsibleMutationVariables>;

/**
 * __useSetClaimResponsibleMutation__
 *
 * To run a mutation, you first call `useSetClaimResponsibleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetClaimResponsibleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setClaimResponsibleMutation, { data, loading, error }] = useSetClaimResponsibleMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      responsibleId: // value for 'responsibleId'
 *   },
 * });
 */
export function useSetClaimResponsibleMutation(baseOptions?: Apollo.MutationHookOptions<SetClaimResponsibleMutation, SetClaimResponsibleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetClaimResponsibleMutation, SetClaimResponsibleMutationVariables>(SetClaimResponsibleDocument, options);
      }
export type SetClaimResponsibleMutationHookResult = ReturnType<typeof useSetClaimResponsibleMutation>;
export type SetClaimResponsibleMutationResult = Apollo.MutationResult<SetClaimResponsibleMutation>;
export type SetClaimResponsibleMutationOptions = Apollo.BaseMutationOptions<SetClaimResponsibleMutation, SetClaimResponsibleMutationVariables>;
export const SetDocumentSpecialOperationDocument = gql`
    mutation SetDocumentSpecialOperation($docId: String!, $specialOperationId: String) {
  setDocumentSpecialOperation(
    docId: $docId
    specialOperationId: $specialOperationId
  )
}
    `;
export type SetDocumentSpecialOperationMutationFn = Apollo.MutationFunction<SetDocumentSpecialOperationMutation, SetDocumentSpecialOperationMutationVariables>;

/**
 * __useSetDocumentSpecialOperationMutation__
 *
 * To run a mutation, you first call `useSetDocumentSpecialOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDocumentSpecialOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDocumentSpecialOperationMutation, { data, loading, error }] = useSetDocumentSpecialOperationMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      specialOperationId: // value for 'specialOperationId'
 *   },
 * });
 */
export function useSetDocumentSpecialOperationMutation(baseOptions?: Apollo.MutationHookOptions<SetDocumentSpecialOperationMutation, SetDocumentSpecialOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDocumentSpecialOperationMutation, SetDocumentSpecialOperationMutationVariables>(SetDocumentSpecialOperationDocument, options);
      }
export type SetDocumentSpecialOperationMutationHookResult = ReturnType<typeof useSetDocumentSpecialOperationMutation>;
export type SetDocumentSpecialOperationMutationResult = Apollo.MutationResult<SetDocumentSpecialOperationMutation>;
export type SetDocumentSpecialOperationMutationOptions = Apollo.BaseMutationOptions<SetDocumentSpecialOperationMutation, SetDocumentSpecialOperationMutationVariables>;
export const ArchiveDocumentDocument = gql`
    mutation archiveDocument($docId: String!) {
  archiveDocument(docId: $docId)
}
    `;
export type ArchiveDocumentMutationFn = Apollo.MutationFunction<ArchiveDocumentMutation, ArchiveDocumentMutationVariables>;

/**
 * __useArchiveDocumentMutation__
 *
 * To run a mutation, you first call `useArchiveDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveDocumentMutation, { data, loading, error }] = useArchiveDocumentMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useArchiveDocumentMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveDocumentMutation, ArchiveDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveDocumentMutation, ArchiveDocumentMutationVariables>(ArchiveDocumentDocument, options);
      }
export type ArchiveDocumentMutationHookResult = ReturnType<typeof useArchiveDocumentMutation>;
export type ArchiveDocumentMutationResult = Apollo.MutationResult<ArchiveDocumentMutation>;
export type ArchiveDocumentMutationOptions = Apollo.BaseMutationOptions<ArchiveDocumentMutation, ArchiveDocumentMutationVariables>;
export const FinishSimulationDocument = gql`
    mutation finishSimulation($docId: String!) {
  finishSimulation(docId: $docId)
}
    `;
export type FinishSimulationMutationFn = Apollo.MutationFunction<FinishSimulationMutation, FinishSimulationMutationVariables>;

/**
 * __useFinishSimulationMutation__
 *
 * To run a mutation, you first call `useFinishSimulationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishSimulationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishSimulationMutation, { data, loading, error }] = useFinishSimulationMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useFinishSimulationMutation(baseOptions?: Apollo.MutationHookOptions<FinishSimulationMutation, FinishSimulationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishSimulationMutation, FinishSimulationMutationVariables>(FinishSimulationDocument, options);
      }
export type FinishSimulationMutationHookResult = ReturnType<typeof useFinishSimulationMutation>;
export type FinishSimulationMutationResult = Apollo.MutationResult<FinishSimulationMutation>;
export type FinishSimulationMutationOptions = Apollo.BaseMutationOptions<FinishSimulationMutation, FinishSimulationMutationVariables>;
export const RedoQuotationsDocument = gql`
    mutation RedoQuotations($docId: String!) {
  redoQuotations(docId: $docId)
}
    `;
export type RedoQuotationsMutationFn = Apollo.MutationFunction<RedoQuotationsMutation, RedoQuotationsMutationVariables>;

/**
 * __useRedoQuotationsMutation__
 *
 * To run a mutation, you first call `useRedoQuotationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedoQuotationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redoQuotationsMutation, { data, loading, error }] = useRedoQuotationsMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useRedoQuotationsMutation(baseOptions?: Apollo.MutationHookOptions<RedoQuotationsMutation, RedoQuotationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedoQuotationsMutation, RedoQuotationsMutationVariables>(RedoQuotationsDocument, options);
      }
export type RedoQuotationsMutationHookResult = ReturnType<typeof useRedoQuotationsMutation>;
export type RedoQuotationsMutationResult = Apollo.MutationResult<RedoQuotationsMutation>;
export type RedoQuotationsMutationOptions = Apollo.BaseMutationOptions<RedoQuotationsMutation, RedoQuotationsMutationVariables>;
export const DeleteSimulationResultDocument = gql`
    mutation DeleteSimulationResult($resultId: String!) {
  deleteSimulationResult(resultId: $resultId)
}
    `;
export type DeleteSimulationResultMutationFn = Apollo.MutationFunction<DeleteSimulationResultMutation, DeleteSimulationResultMutationVariables>;

/**
 * __useDeleteSimulationResultMutation__
 *
 * To run a mutation, you first call `useDeleteSimulationResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSimulationResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSimulationResultMutation, { data, loading, error }] = useDeleteSimulationResultMutation({
 *   variables: {
 *      resultId: // value for 'resultId'
 *   },
 * });
 */
export function useDeleteSimulationResultMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSimulationResultMutation, DeleteSimulationResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSimulationResultMutation, DeleteSimulationResultMutationVariables>(DeleteSimulationResultDocument, options);
      }
export type DeleteSimulationResultMutationHookResult = ReturnType<typeof useDeleteSimulationResultMutation>;
export type DeleteSimulationResultMutationResult = Apollo.MutationResult<DeleteSimulationResultMutation>;
export type DeleteSimulationResultMutationOptions = Apollo.BaseMutationOptions<DeleteSimulationResultMutation, DeleteSimulationResultMutationVariables>;
export const SetPaymentDoneDocument = gql`
    mutation SetPaymentDone($paymentId: String!) {
  setPaymentDone(paymentId: $paymentId)
}
    `;
export type SetPaymentDoneMutationFn = Apollo.MutationFunction<SetPaymentDoneMutation, SetPaymentDoneMutationVariables>;

/**
 * __useSetPaymentDoneMutation__
 *
 * To run a mutation, you first call `useSetPaymentDoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPaymentDoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPaymentDoneMutation, { data, loading, error }] = useSetPaymentDoneMutation({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useSetPaymentDoneMutation(baseOptions?: Apollo.MutationHookOptions<SetPaymentDoneMutation, SetPaymentDoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPaymentDoneMutation, SetPaymentDoneMutationVariables>(SetPaymentDoneDocument, options);
      }
export type SetPaymentDoneMutationHookResult = ReturnType<typeof useSetPaymentDoneMutation>;
export type SetPaymentDoneMutationResult = Apollo.MutationResult<SetPaymentDoneMutation>;
export type SetPaymentDoneMutationOptions = Apollo.BaseMutationOptions<SetPaymentDoneMutation, SetPaymentDoneMutationVariables>;
export const SendQuotationDocument = gql`
    mutation SendQuotation($docId: String!, $silent: Boolean!) {
  sendQuotation(docId: $docId, silent: $silent)
}
    `;
export type SendQuotationMutationFn = Apollo.MutationFunction<SendQuotationMutation, SendQuotationMutationVariables>;

/**
 * __useSendQuotationMutation__
 *
 * To run a mutation, you first call `useSendQuotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendQuotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendQuotationMutation, { data, loading, error }] = useSendQuotationMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      silent: // value for 'silent'
 *   },
 * });
 */
export function useSendQuotationMutation(baseOptions?: Apollo.MutationHookOptions<SendQuotationMutation, SendQuotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendQuotationMutation, SendQuotationMutationVariables>(SendQuotationDocument, options);
      }
export type SendQuotationMutationHookResult = ReturnType<typeof useSendQuotationMutation>;
export type SendQuotationMutationResult = Apollo.MutationResult<SendQuotationMutation>;
export type SendQuotationMutationOptions = Apollo.BaseMutationOptions<SendQuotationMutation, SendQuotationMutationVariables>;
export const SendProposalDocument = gql`
    mutation SendProposal($docId: String!, $silent: Boolean!) {
  sendProposal(docId: $docId, silent: $silent)
}
    `;
export type SendProposalMutationFn = Apollo.MutationFunction<SendProposalMutation, SendProposalMutationVariables>;

/**
 * __useSendProposalMutation__
 *
 * To run a mutation, you first call `useSendProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendProposalMutation, { data, loading, error }] = useSendProposalMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      silent: // value for 'silent'
 *   },
 * });
 */
export function useSendProposalMutation(baseOptions?: Apollo.MutationHookOptions<SendProposalMutation, SendProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendProposalMutation, SendProposalMutationVariables>(SendProposalDocument, options);
      }
export type SendProposalMutationHookResult = ReturnType<typeof useSendProposalMutation>;
export type SendProposalMutationResult = Apollo.MutationResult<SendProposalMutation>;
export type SendProposalMutationOptions = Apollo.BaseMutationOptions<SendProposalMutation, SendProposalMutationVariables>;
export const SendPolicyDocument = gql`
    mutation SendPolicy($docId: String!, $silent: Boolean!) {
  sendPolicy(docId: $docId, silent: $silent)
}
    `;
export type SendPolicyMutationFn = Apollo.MutationFunction<SendPolicyMutation, SendPolicyMutationVariables>;

/**
 * __useSendPolicyMutation__
 *
 * To run a mutation, you first call `useSendPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPolicyMutation, { data, loading, error }] = useSendPolicyMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      silent: // value for 'silent'
 *   },
 * });
 */
export function useSendPolicyMutation(baseOptions?: Apollo.MutationHookOptions<SendPolicyMutation, SendPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPolicyMutation, SendPolicyMutationVariables>(SendPolicyDocument, options);
      }
export type SendPolicyMutationHookResult = ReturnType<typeof useSendPolicyMutation>;
export type SendPolicyMutationResult = Apollo.MutationResult<SendPolicyMutation>;
export type SendPolicyMutationOptions = Apollo.BaseMutationOptions<SendPolicyMutation, SendPolicyMutationVariables>;
export const ArchiveProposalDocument = gql`
    mutation archiveProposal($docId: String!) {
  archiveProposal(docId: $docId)
}
    `;
export type ArchiveProposalMutationFn = Apollo.MutationFunction<ArchiveProposalMutation, ArchiveProposalMutationVariables>;

/**
 * __useArchiveProposalMutation__
 *
 * To run a mutation, you first call `useArchiveProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveProposalMutation, { data, loading, error }] = useArchiveProposalMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useArchiveProposalMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveProposalMutation, ArchiveProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveProposalMutation, ArchiveProposalMutationVariables>(ArchiveProposalDocument, options);
      }
export type ArchiveProposalMutationHookResult = ReturnType<typeof useArchiveProposalMutation>;
export type ArchiveProposalMutationResult = Apollo.MutationResult<ArchiveProposalMutation>;
export type ArchiveProposalMutationOptions = Apollo.BaseMutationOptions<ArchiveProposalMutation, ArchiveProposalMutationVariables>;
export const CancelPaymentDocument = gql`
    mutation CancelPayment($paymentId: String!) {
  cancelPayment(paymentId: $paymentId)
}
    `;
export type CancelPaymentMutationFn = Apollo.MutationFunction<CancelPaymentMutation, CancelPaymentMutationVariables>;

/**
 * __useCancelPaymentMutation__
 *
 * To run a mutation, you first call `useCancelPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPaymentMutation, { data, loading, error }] = useCancelPaymentMutation({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useCancelPaymentMutation(baseOptions?: Apollo.MutationHookOptions<CancelPaymentMutation, CancelPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelPaymentMutation, CancelPaymentMutationVariables>(CancelPaymentDocument, options);
      }
export type CancelPaymentMutationHookResult = ReturnType<typeof useCancelPaymentMutation>;
export type CancelPaymentMutationResult = Apollo.MutationResult<CancelPaymentMutation>;
export type CancelPaymentMutationOptions = Apollo.BaseMutationOptions<CancelPaymentMutation, CancelPaymentMutationVariables>;
export const RecommendSimulationResultDocument = gql`
    mutation RecommendSimulationResult($docId: String!, $resultId: String!) {
  recommendSimulationResult(docId: $docId, resultId: $resultId)
}
    `;
export type RecommendSimulationResultMutationFn = Apollo.MutationFunction<RecommendSimulationResultMutation, RecommendSimulationResultMutationVariables>;

/**
 * __useRecommendSimulationResultMutation__
 *
 * To run a mutation, you first call `useRecommendSimulationResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecommendSimulationResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recommendSimulationResultMutation, { data, loading, error }] = useRecommendSimulationResultMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      resultId: // value for 'resultId'
 *   },
 * });
 */
export function useRecommendSimulationResultMutation(baseOptions?: Apollo.MutationHookOptions<RecommendSimulationResultMutation, RecommendSimulationResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecommendSimulationResultMutation, RecommendSimulationResultMutationVariables>(RecommendSimulationResultDocument, options);
      }
export type RecommendSimulationResultMutationHookResult = ReturnType<typeof useRecommendSimulationResultMutation>;
export type RecommendSimulationResultMutationResult = Apollo.MutationResult<RecommendSimulationResultMutation>;
export type RecommendSimulationResultMutationOptions = Apollo.BaseMutationOptions<RecommendSimulationResultMutation, RecommendSimulationResultMutationVariables>;
export const RemoveRecommendedSimulationResultDocument = gql`
    mutation RemoveRecommendedSimulationResult($docId: String!) {
  removeRecommendedSimulationResult(docId: $docId)
}
    `;
export type RemoveRecommendedSimulationResultMutationFn = Apollo.MutationFunction<RemoveRecommendedSimulationResultMutation, RemoveRecommendedSimulationResultMutationVariables>;

/**
 * __useRemoveRecommendedSimulationResultMutation__
 *
 * To run a mutation, you first call `useRemoveRecommendedSimulationResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRecommendedSimulationResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRecommendedSimulationResultMutation, { data, loading, error }] = useRemoveRecommendedSimulationResultMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useRemoveRecommendedSimulationResultMutation(baseOptions?: Apollo.MutationHookOptions<RemoveRecommendedSimulationResultMutation, RemoveRecommendedSimulationResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveRecommendedSimulationResultMutation, RemoveRecommendedSimulationResultMutationVariables>(RemoveRecommendedSimulationResultDocument, options);
      }
export type RemoveRecommendedSimulationResultMutationHookResult = ReturnType<typeof useRemoveRecommendedSimulationResultMutation>;
export type RemoveRecommendedSimulationResultMutationResult = Apollo.MutationResult<RemoveRecommendedSimulationResultMutation>;
export type RemoveRecommendedSimulationResultMutationOptions = Apollo.BaseMutationOptions<RemoveRecommendedSimulationResultMutation, RemoveRecommendedSimulationResultMutationVariables>;
export const SetDocumentContactDocument = gql`
    mutation SetDocumentContact($docId: String!, $contactId: String!) {
  setDocumentContact(docId: $docId, contactId: $contactId)
}
    `;
export type SetDocumentContactMutationFn = Apollo.MutationFunction<SetDocumentContactMutation, SetDocumentContactMutationVariables>;

/**
 * __useSetDocumentContactMutation__
 *
 * To run a mutation, you first call `useSetDocumentContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDocumentContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDocumentContactMutation, { data, loading, error }] = useSetDocumentContactMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useSetDocumentContactMutation(baseOptions?: Apollo.MutationHookOptions<SetDocumentContactMutation, SetDocumentContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDocumentContactMutation, SetDocumentContactMutationVariables>(SetDocumentContactDocument, options);
      }
export type SetDocumentContactMutationHookResult = ReturnType<typeof useSetDocumentContactMutation>;
export type SetDocumentContactMutationResult = Apollo.MutationResult<SetDocumentContactMutation>;
export type SetDocumentContactMutationOptions = Apollo.BaseMutationOptions<SetDocumentContactMutation, SetDocumentContactMutationVariables>;
export const CreatePaymentCopyDocument = gql`
    mutation CreatePaymentCopy($paymentId: String!) {
  createPaymentCopy(paymentId: $paymentId)
}
    `;
export type CreatePaymentCopyMutationFn = Apollo.MutationFunction<CreatePaymentCopyMutation, CreatePaymentCopyMutationVariables>;

/**
 * __useCreatePaymentCopyMutation__
 *
 * To run a mutation, you first call `useCreatePaymentCopyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentCopyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentCopyMutation, { data, loading, error }] = useCreatePaymentCopyMutation({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useCreatePaymentCopyMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentCopyMutation, CreatePaymentCopyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentCopyMutation, CreatePaymentCopyMutationVariables>(CreatePaymentCopyDocument, options);
      }
export type CreatePaymentCopyMutationHookResult = ReturnType<typeof useCreatePaymentCopyMutation>;
export type CreatePaymentCopyMutationResult = Apollo.MutationResult<CreatePaymentCopyMutation>;
export type CreatePaymentCopyMutationOptions = Apollo.BaseMutationOptions<CreatePaymentCopyMutation, CreatePaymentCopyMutationVariables>;
export const CreateFormResponseDocument = gql`
    mutation CreateFormResponse($formId: String!, $metadata: JSON!) {
  createFormResponse(formId: $formId, metadata: $metadata) {
    _id
  }
}
    `;
export type CreateFormResponseMutationFn = Apollo.MutationFunction<CreateFormResponseMutation, CreateFormResponseMutationVariables>;

/**
 * __useCreateFormResponseMutation__
 *
 * To run a mutation, you first call `useCreateFormResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormResponseMutation, { data, loading, error }] = useCreateFormResponseMutation({
 *   variables: {
 *      formId: // value for 'formId'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useCreateFormResponseMutation(baseOptions?: Apollo.MutationHookOptions<CreateFormResponseMutation, CreateFormResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFormResponseMutation, CreateFormResponseMutationVariables>(CreateFormResponseDocument, options);
      }
export type CreateFormResponseMutationHookResult = ReturnType<typeof useCreateFormResponseMutation>;
export type CreateFormResponseMutationResult = Apollo.MutationResult<CreateFormResponseMutation>;
export type CreateFormResponseMutationOptions = Apollo.BaseMutationOptions<CreateFormResponseMutation, CreateFormResponseMutationVariables>;
export const UpsertFormFieldDocument = gql`
    mutation UpsertFormField($formResponseId: String!, $fieldPath: String!, $value: JSON!) {
  upsertFormField(
    formResponseId: $formResponseId
    fieldPath: $fieldPath
    value: $value
  )
}
    `;
export type UpsertFormFieldMutationFn = Apollo.MutationFunction<UpsertFormFieldMutation, UpsertFormFieldMutationVariables>;

/**
 * __useUpsertFormFieldMutation__
 *
 * To run a mutation, you first call `useUpsertFormFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertFormFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertFormFieldMutation, { data, loading, error }] = useUpsertFormFieldMutation({
 *   variables: {
 *      formResponseId: // value for 'formResponseId'
 *      fieldPath: // value for 'fieldPath'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpsertFormFieldMutation(baseOptions?: Apollo.MutationHookOptions<UpsertFormFieldMutation, UpsertFormFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertFormFieldMutation, UpsertFormFieldMutationVariables>(UpsertFormFieldDocument, options);
      }
export type UpsertFormFieldMutationHookResult = ReturnType<typeof useUpsertFormFieldMutation>;
export type UpsertFormFieldMutationResult = Apollo.MutationResult<UpsertFormFieldMutation>;
export type UpsertFormFieldMutationOptions = Apollo.BaseMutationOptions<UpsertFormFieldMutation, UpsertFormFieldMutationVariables>;
export const SubmitFormResponseDocument = gql`
    mutation SubmitFormResponse($formResponseId: String!) {
  submitFormResponse(formResponseId: $formResponseId)
}
    `;
export type SubmitFormResponseMutationFn = Apollo.MutationFunction<SubmitFormResponseMutation, SubmitFormResponseMutationVariables>;

/**
 * __useSubmitFormResponseMutation__
 *
 * To run a mutation, you first call `useSubmitFormResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFormResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFormResponseMutation, { data, loading, error }] = useSubmitFormResponseMutation({
 *   variables: {
 *      formResponseId: // value for 'formResponseId'
 *   },
 * });
 */
export function useSubmitFormResponseMutation(baseOptions?: Apollo.MutationHookOptions<SubmitFormResponseMutation, SubmitFormResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitFormResponseMutation, SubmitFormResponseMutationVariables>(SubmitFormResponseDocument, options);
      }
export type SubmitFormResponseMutationHookResult = ReturnType<typeof useSubmitFormResponseMutation>;
export type SubmitFormResponseMutationResult = Apollo.MutationResult<SubmitFormResponseMutation>;
export type SubmitFormResponseMutationOptions = Apollo.BaseMutationOptions<SubmitFormResponseMutation, SubmitFormResponseMutationVariables>;
export const SendTransactionalEventDocument = gql`
    mutation SendTransactionalEvent($docId: String!, $event: TransactionalEvents!) {
  sendTransactionalEvent(docId: $docId, event: $event)
}
    `;
export type SendTransactionalEventMutationFn = Apollo.MutationFunction<SendTransactionalEventMutation, SendTransactionalEventMutationVariables>;

/**
 * __useSendTransactionalEventMutation__
 *
 * To run a mutation, you first call `useSendTransactionalEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTransactionalEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTransactionalEventMutation, { data, loading, error }] = useSendTransactionalEventMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      event: // value for 'event'
 *   },
 * });
 */
export function useSendTransactionalEventMutation(baseOptions?: Apollo.MutationHookOptions<SendTransactionalEventMutation, SendTransactionalEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTransactionalEventMutation, SendTransactionalEventMutationVariables>(SendTransactionalEventDocument, options);
      }
export type SendTransactionalEventMutationHookResult = ReturnType<typeof useSendTransactionalEventMutation>;
export type SendTransactionalEventMutationResult = Apollo.MutationResult<SendTransactionalEventMutation>;
export type SendTransactionalEventMutationOptions = Apollo.BaseMutationOptions<SendTransactionalEventMutation, SendTransactionalEventMutationVariables>;
export const CreateFormResponseV2Document = gql`
    mutation CreateFormResponseV2($formId: String!, $metadata: JSON!) {
  createFormResponseV2(formId: $formId, metadata: $metadata)
}
    `;
export type CreateFormResponseV2MutationFn = Apollo.MutationFunction<CreateFormResponseV2Mutation, CreateFormResponseV2MutationVariables>;

/**
 * __useCreateFormResponseV2Mutation__
 *
 * To run a mutation, you first call `useCreateFormResponseV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormResponseV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormResponseV2Mutation, { data, loading, error }] = useCreateFormResponseV2Mutation({
 *   variables: {
 *      formId: // value for 'formId'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useCreateFormResponseV2Mutation(baseOptions?: Apollo.MutationHookOptions<CreateFormResponseV2Mutation, CreateFormResponseV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFormResponseV2Mutation, CreateFormResponseV2MutationVariables>(CreateFormResponseV2Document, options);
      }
export type CreateFormResponseV2MutationHookResult = ReturnType<typeof useCreateFormResponseV2Mutation>;
export type CreateFormResponseV2MutationResult = Apollo.MutationResult<CreateFormResponseV2Mutation>;
export type CreateFormResponseV2MutationOptions = Apollo.BaseMutationOptions<CreateFormResponseV2Mutation, CreateFormResponseV2MutationVariables>;
export const UpdateFormFieldV2Document = gql`
    mutation UpdateFormFieldV2($formResponseId: String!, $fieldPath: String!, $value: JSON) {
  updateFormFieldV2(
    formResponseId: $formResponseId
    fieldPath: $fieldPath
    value: $value
  ) {
    fieldPath
    value
    error
    required
    invisible
    label
    options
    domain
  }
}
    `;
export type UpdateFormFieldV2MutationFn = Apollo.MutationFunction<UpdateFormFieldV2Mutation, UpdateFormFieldV2MutationVariables>;

/**
 * __useUpdateFormFieldV2Mutation__
 *
 * To run a mutation, you first call `useUpdateFormFieldV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormFieldV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormFieldV2Mutation, { data, loading, error }] = useUpdateFormFieldV2Mutation({
 *   variables: {
 *      formResponseId: // value for 'formResponseId'
 *      fieldPath: // value for 'fieldPath'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateFormFieldV2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormFieldV2Mutation, UpdateFormFieldV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormFieldV2Mutation, UpdateFormFieldV2MutationVariables>(UpdateFormFieldV2Document, options);
      }
export type UpdateFormFieldV2MutationHookResult = ReturnType<typeof useUpdateFormFieldV2Mutation>;
export type UpdateFormFieldV2MutationResult = Apollo.MutationResult<UpdateFormFieldV2Mutation>;
export type UpdateFormFieldV2MutationOptions = Apollo.BaseMutationOptions<UpdateFormFieldV2Mutation, UpdateFormFieldV2MutationVariables>;
export const AddObjectListItemDocument = gql`
    mutation AddObjectListItem($formResponseId: String!, $fieldPath: String!) {
  addObjectListItem(formResponseId: $formResponseId, fieldPath: $fieldPath) {
    updates {
      fieldPath
      value
      error
      required
      invisible
      label
      options
      domain
    }
    newItem {
      ...FieldDetails
      fields {
        ...FieldDetails
        fields {
          ...FieldDetails
          fields {
            ...FieldDetails
          }
        }
      }
    }
  }
}
    ${FieldDetailsFragmentDoc}`;
export type AddObjectListItemMutationFn = Apollo.MutationFunction<AddObjectListItemMutation, AddObjectListItemMutationVariables>;

/**
 * __useAddObjectListItemMutation__
 *
 * To run a mutation, you first call `useAddObjectListItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddObjectListItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addObjectListItemMutation, { data, loading, error }] = useAddObjectListItemMutation({
 *   variables: {
 *      formResponseId: // value for 'formResponseId'
 *      fieldPath: // value for 'fieldPath'
 *   },
 * });
 */
export function useAddObjectListItemMutation(baseOptions?: Apollo.MutationHookOptions<AddObjectListItemMutation, AddObjectListItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddObjectListItemMutation, AddObjectListItemMutationVariables>(AddObjectListItemDocument, options);
      }
export type AddObjectListItemMutationHookResult = ReturnType<typeof useAddObjectListItemMutation>;
export type AddObjectListItemMutationResult = Apollo.MutationResult<AddObjectListItemMutation>;
export type AddObjectListItemMutationOptions = Apollo.BaseMutationOptions<AddObjectListItemMutation, AddObjectListItemMutationVariables>;
export const CopyObjectListItemDocument = gql`
    mutation CopyObjectListItem($formResponseId: String!, $fieldPath: String!) {
  copyObjectListItem(formResponseId: $formResponseId, fieldPath: $fieldPath) {
    updates {
      fieldPath
      value
      error
      required
      invisible
      label
      options
      domain
    }
    newItem {
      ...FieldDetails
      fields {
        ...FieldDetails
        fields {
          ...FieldDetails
          fields {
            ...FieldDetails
          }
        }
      }
    }
  }
}
    ${FieldDetailsFragmentDoc}`;
export type CopyObjectListItemMutationFn = Apollo.MutationFunction<CopyObjectListItemMutation, CopyObjectListItemMutationVariables>;

/**
 * __useCopyObjectListItemMutation__
 *
 * To run a mutation, you first call `useCopyObjectListItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyObjectListItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyObjectListItemMutation, { data, loading, error }] = useCopyObjectListItemMutation({
 *   variables: {
 *      formResponseId: // value for 'formResponseId'
 *      fieldPath: // value for 'fieldPath'
 *   },
 * });
 */
export function useCopyObjectListItemMutation(baseOptions?: Apollo.MutationHookOptions<CopyObjectListItemMutation, CopyObjectListItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyObjectListItemMutation, CopyObjectListItemMutationVariables>(CopyObjectListItemDocument, options);
      }
export type CopyObjectListItemMutationHookResult = ReturnType<typeof useCopyObjectListItemMutation>;
export type CopyObjectListItemMutationResult = Apollo.MutationResult<CopyObjectListItemMutation>;
export type CopyObjectListItemMutationOptions = Apollo.BaseMutationOptions<CopyObjectListItemMutation, CopyObjectListItemMutationVariables>;
export const DeleteObjectListItemDocument = gql`
    mutation DeleteObjectListItem($formResponseId: String!, $fieldPath: String!) {
  deleteObjectListItem(formResponseId: $formResponseId, fieldPath: $fieldPath) {
    fieldPath
    value
    error
    required
    invisible
    label
    options
    domain
  }
}
    `;
export type DeleteObjectListItemMutationFn = Apollo.MutationFunction<DeleteObjectListItemMutation, DeleteObjectListItemMutationVariables>;

/**
 * __useDeleteObjectListItemMutation__
 *
 * To run a mutation, you first call `useDeleteObjectListItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteObjectListItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteObjectListItemMutation, { data, loading, error }] = useDeleteObjectListItemMutation({
 *   variables: {
 *      formResponseId: // value for 'formResponseId'
 *      fieldPath: // value for 'fieldPath'
 *   },
 * });
 */
export function useDeleteObjectListItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteObjectListItemMutation, DeleteObjectListItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteObjectListItemMutation, DeleteObjectListItemMutationVariables>(DeleteObjectListItemDocument, options);
      }
export type DeleteObjectListItemMutationHookResult = ReturnType<typeof useDeleteObjectListItemMutation>;
export type DeleteObjectListItemMutationResult = Apollo.MutationResult<DeleteObjectListItemMutation>;
export type DeleteObjectListItemMutationOptions = Apollo.BaseMutationOptions<DeleteObjectListItemMutation, DeleteObjectListItemMutationVariables>;
export const SubmitFormResponseV2Document = gql`
    mutation SubmitFormResponseV2($formResponseId: String!) {
  submitFormResponseV2(formResponseId: $formResponseId)
}
    `;
export type SubmitFormResponseV2MutationFn = Apollo.MutationFunction<SubmitFormResponseV2Mutation, SubmitFormResponseV2MutationVariables>;

/**
 * __useSubmitFormResponseV2Mutation__
 *
 * To run a mutation, you first call `useSubmitFormResponseV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFormResponseV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFormResponseV2Mutation, { data, loading, error }] = useSubmitFormResponseV2Mutation({
 *   variables: {
 *      formResponseId: // value for 'formResponseId'
 *   },
 * });
 */
export function useSubmitFormResponseV2Mutation(baseOptions?: Apollo.MutationHookOptions<SubmitFormResponseV2Mutation, SubmitFormResponseV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitFormResponseV2Mutation, SubmitFormResponseV2MutationVariables>(SubmitFormResponseV2Document, options);
      }
export type SubmitFormResponseV2MutationHookResult = ReturnType<typeof useSubmitFormResponseV2Mutation>;
export type SubmitFormResponseV2MutationResult = Apollo.MutationResult<SubmitFormResponseV2Mutation>;
export type SubmitFormResponseV2MutationOptions = Apollo.BaseMutationOptions<SubmitFormResponseV2Mutation, SubmitFormResponseV2MutationVariables>;
export const AddCommercialResponsibleLeadDocument = gql`
    mutation addCommercialResponsibleLead($leadId: String!, $responsibleId: String!) {
  addCommercialResponsibleToLead(leadId: $leadId, responsibleId: $responsibleId)
}
    `;
export type AddCommercialResponsibleLeadMutationFn = Apollo.MutationFunction<AddCommercialResponsibleLeadMutation, AddCommercialResponsibleLeadMutationVariables>;

/**
 * __useAddCommercialResponsibleLeadMutation__
 *
 * To run a mutation, you first call `useAddCommercialResponsibleLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommercialResponsibleLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommercialResponsibleLeadMutation, { data, loading, error }] = useAddCommercialResponsibleLeadMutation({
 *   variables: {
 *      leadId: // value for 'leadId'
 *      responsibleId: // value for 'responsibleId'
 *   },
 * });
 */
export function useAddCommercialResponsibleLeadMutation(baseOptions?: Apollo.MutationHookOptions<AddCommercialResponsibleLeadMutation, AddCommercialResponsibleLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCommercialResponsibleLeadMutation, AddCommercialResponsibleLeadMutationVariables>(AddCommercialResponsibleLeadDocument, options);
      }
export type AddCommercialResponsibleLeadMutationHookResult = ReturnType<typeof useAddCommercialResponsibleLeadMutation>;
export type AddCommercialResponsibleLeadMutationResult = Apollo.MutationResult<AddCommercialResponsibleLeadMutation>;
export type AddCommercialResponsibleLeadMutationOptions = Apollo.BaseMutationOptions<AddCommercialResponsibleLeadMutation, AddCommercialResponsibleLeadMutationVariables>;
export const AddTechnicalResponsibleLeadDocument = gql`
    mutation addTechnicalResponsibleLead($leadId: String!, $responsibleId: String!) {
  addTechnicalResponsibleToLead(leadId: $leadId, responsibleId: $responsibleId)
}
    `;
export type AddTechnicalResponsibleLeadMutationFn = Apollo.MutationFunction<AddTechnicalResponsibleLeadMutation, AddTechnicalResponsibleLeadMutationVariables>;

/**
 * __useAddTechnicalResponsibleLeadMutation__
 *
 * To run a mutation, you first call `useAddTechnicalResponsibleLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTechnicalResponsibleLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTechnicalResponsibleLeadMutation, { data, loading, error }] = useAddTechnicalResponsibleLeadMutation({
 *   variables: {
 *      leadId: // value for 'leadId'
 *      responsibleId: // value for 'responsibleId'
 *   },
 * });
 */
export function useAddTechnicalResponsibleLeadMutation(baseOptions?: Apollo.MutationHookOptions<AddTechnicalResponsibleLeadMutation, AddTechnicalResponsibleLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTechnicalResponsibleLeadMutation, AddTechnicalResponsibleLeadMutationVariables>(AddTechnicalResponsibleLeadDocument, options);
      }
export type AddTechnicalResponsibleLeadMutationHookResult = ReturnType<typeof useAddTechnicalResponsibleLeadMutation>;
export type AddTechnicalResponsibleLeadMutationResult = Apollo.MutationResult<AddTechnicalResponsibleLeadMutation>;
export type AddTechnicalResponsibleLeadMutationOptions = Apollo.BaseMutationOptions<AddTechnicalResponsibleLeadMutation, AddTechnicalResponsibleLeadMutationVariables>;
export const ChangeLeadStatusDocument = gql`
    mutation changeLeadStatus($leadId: String!, $status: LeadStatus!) {
  changeLeadStatus(leadId: $leadId, status: $status)
}
    `;
export type ChangeLeadStatusMutationFn = Apollo.MutationFunction<ChangeLeadStatusMutation, ChangeLeadStatusMutationVariables>;

/**
 * __useChangeLeadStatusMutation__
 *
 * To run a mutation, you first call `useChangeLeadStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeLeadStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeLeadStatusMutation, { data, loading, error }] = useChangeLeadStatusMutation({
 *   variables: {
 *      leadId: // value for 'leadId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useChangeLeadStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeLeadStatusMutation, ChangeLeadStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeLeadStatusMutation, ChangeLeadStatusMutationVariables>(ChangeLeadStatusDocument, options);
      }
export type ChangeLeadStatusMutationHookResult = ReturnType<typeof useChangeLeadStatusMutation>;
export type ChangeLeadStatusMutationResult = Apollo.MutationResult<ChangeLeadStatusMutation>;
export type ChangeLeadStatusMutationOptions = Apollo.BaseMutationOptions<ChangeLeadStatusMutation, ChangeLeadStatusMutationVariables>;
export const RateLeadDocument = gql`
    mutation rateLead($leadId: String!, $rating: RatingScale!) {
  rateLead(leadId: $leadId, rating: $rating)
}
    `;
export type RateLeadMutationFn = Apollo.MutationFunction<RateLeadMutation, RateLeadMutationVariables>;

/**
 * __useRateLeadMutation__
 *
 * To run a mutation, you first call `useRateLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRateLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rateLeadMutation, { data, loading, error }] = useRateLeadMutation({
 *   variables: {
 *      leadId: // value for 'leadId'
 *      rating: // value for 'rating'
 *   },
 * });
 */
export function useRateLeadMutation(baseOptions?: Apollo.MutationHookOptions<RateLeadMutation, RateLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RateLeadMutation, RateLeadMutationVariables>(RateLeadDocument, options);
      }
export type RateLeadMutationHookResult = ReturnType<typeof useRateLeadMutation>;
export type RateLeadMutationResult = Apollo.MutationResult<RateLeadMutation>;
export type RateLeadMutationOptions = Apollo.BaseMutationOptions<RateLeadMutation, RateLeadMutationVariables>;
export const AddCommentToLeadDocument = gql`
    mutation addCommentToLead($leadId: String!, $comment: String!) {
  addCommentToLead(leadId: $leadId, comment: $comment)
}
    `;
export type AddCommentToLeadMutationFn = Apollo.MutationFunction<AddCommentToLeadMutation, AddCommentToLeadMutationVariables>;

/**
 * __useAddCommentToLeadMutation__
 *
 * To run a mutation, you first call `useAddCommentToLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommentToLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommentToLeadMutation, { data, loading, error }] = useAddCommentToLeadMutation({
 *   variables: {
 *      leadId: // value for 'leadId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useAddCommentToLeadMutation(baseOptions?: Apollo.MutationHookOptions<AddCommentToLeadMutation, AddCommentToLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCommentToLeadMutation, AddCommentToLeadMutationVariables>(AddCommentToLeadDocument, options);
      }
export type AddCommentToLeadMutationHookResult = ReturnType<typeof useAddCommentToLeadMutation>;
export type AddCommentToLeadMutationResult = Apollo.MutationResult<AddCommentToLeadMutation>;
export type AddCommentToLeadMutationOptions = Apollo.BaseMutationOptions<AddCommentToLeadMutation, AddCommentToLeadMutationVariables>;
export const CreateNoteDocument = gql`
    mutation CreateNote($docId: String!, $authorId: String!, $serviceName: Services!, $text: String!) {
  createNote(
    docId: $docId
    authorId: $authorId
    serviceName: $serviceName
    text: $text
  )
}
    `;
export type CreateNoteMutationFn = Apollo.MutationFunction<CreateNoteMutation, CreateNoteMutationVariables>;

/**
 * __useCreateNoteMutation__
 *
 * To run a mutation, you first call `useCreateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteMutation, { data, loading, error }] = useCreateNoteMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      authorId: // value for 'authorId'
 *      serviceName: // value for 'serviceName'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useCreateNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateNoteMutation, CreateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNoteMutation, CreateNoteMutationVariables>(CreateNoteDocument, options);
      }
export type CreateNoteMutationHookResult = ReturnType<typeof useCreateNoteMutation>;
export type CreateNoteMutationResult = Apollo.MutationResult<CreateNoteMutation>;
export type CreateNoteMutationOptions = Apollo.BaseMutationOptions<CreateNoteMutation, CreateNoteMutationVariables>;
export const RetrySimulationResultDocument = gql`
    mutation RetrySimulationResult($resultId: String!) {
  retrySimulationResult(resultId: $resultId)
}
    `;
export type RetrySimulationResultMutationFn = Apollo.MutationFunction<RetrySimulationResultMutation, RetrySimulationResultMutationVariables>;

/**
 * __useRetrySimulationResultMutation__
 *
 * To run a mutation, you first call `useRetrySimulationResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetrySimulationResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retrySimulationResultMutation, { data, loading, error }] = useRetrySimulationResultMutation({
 *   variables: {
 *      resultId: // value for 'resultId'
 *   },
 * });
 */
export function useRetrySimulationResultMutation(baseOptions?: Apollo.MutationHookOptions<RetrySimulationResultMutation, RetrySimulationResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetrySimulationResultMutation, RetrySimulationResultMutationVariables>(RetrySimulationResultDocument, options);
      }
export type RetrySimulationResultMutationHookResult = ReturnType<typeof useRetrySimulationResultMutation>;
export type RetrySimulationResultMutationResult = Apollo.MutationResult<RetrySimulationResultMutation>;
export type RetrySimulationResultMutationOptions = Apollo.BaseMutationOptions<RetrySimulationResultMutation, RetrySimulationResultMutationVariables>;
export const SendTwilioWaMessageDocument = gql`
    mutation SendTwilioWAMessage($contactId: String!, $content: String!, $files: [TwilioMediaInput!]!) {
  sendTwilioWAMessage(contactId: $contactId, content: $content, files: $files)
}
    `;
export type SendTwilioWaMessageMutationFn = Apollo.MutationFunction<SendTwilioWaMessageMutation, SendTwilioWaMessageMutationVariables>;

/**
 * __useSendTwilioWaMessageMutation__
 *
 * To run a mutation, you first call `useSendTwilioWaMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTwilioWaMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTwilioWaMessageMutation, { data, loading, error }] = useSendTwilioWaMessageMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      content: // value for 'content'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useSendTwilioWaMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendTwilioWaMessageMutation, SendTwilioWaMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTwilioWaMessageMutation, SendTwilioWaMessageMutationVariables>(SendTwilioWaMessageDocument, options);
      }
export type SendTwilioWaMessageMutationHookResult = ReturnType<typeof useSendTwilioWaMessageMutation>;
export type SendTwilioWaMessageMutationResult = Apollo.MutationResult<SendTwilioWaMessageMutation>;
export type SendTwilioWaMessageMutationOptions = Apollo.BaseMutationOptions<SendTwilioWaMessageMutation, SendTwilioWaMessageMutationVariables>;
export const ToggleUserConversationSubscriptionDocument = gql`
    mutation ToggleUserConversationSubscription($userId: String!, $contactId: String!, $shouldAdd: Boolean!) {
  toggleUserConversationSubscription(
    userId: $userId
    contactId: $contactId
    shouldAdd: $shouldAdd
  )
}
    `;
export type ToggleUserConversationSubscriptionMutationFn = Apollo.MutationFunction<ToggleUserConversationSubscriptionMutation, ToggleUserConversationSubscriptionMutationVariables>;

/**
 * __useToggleUserConversationSubscriptionMutation__
 *
 * To run a mutation, you first call `useToggleUserConversationSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleUserConversationSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleUserConversationSubscriptionMutation, { data, loading, error }] = useToggleUserConversationSubscriptionMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      contactId: // value for 'contactId'
 *      shouldAdd: // value for 'shouldAdd'
 *   },
 * });
 */
export function useToggleUserConversationSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<ToggleUserConversationSubscriptionMutation, ToggleUserConversationSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleUserConversationSubscriptionMutation, ToggleUserConversationSubscriptionMutationVariables>(ToggleUserConversationSubscriptionDocument, options);
      }
export type ToggleUserConversationSubscriptionMutationHookResult = ReturnType<typeof useToggleUserConversationSubscriptionMutation>;
export type ToggleUserConversationSubscriptionMutationResult = Apollo.MutationResult<ToggleUserConversationSubscriptionMutation>;
export type ToggleUserConversationSubscriptionMutationOptions = Apollo.BaseMutationOptions<ToggleUserConversationSubscriptionMutation, ToggleUserConversationSubscriptionMutationVariables>;
export const AddCourseToUserDocument = gql`
    mutation AddCourseToUser($userId: String!, $finishedCourse: Boolean!) {
  addCourseToUser(userId: $userId, finishedCourse: $finishedCourse)
}
    `;
export type AddCourseToUserMutationFn = Apollo.MutationFunction<AddCourseToUserMutation, AddCourseToUserMutationVariables>;

/**
 * __useAddCourseToUserMutation__
 *
 * To run a mutation, you first call `useAddCourseToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCourseToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCourseToUserMutation, { data, loading, error }] = useAddCourseToUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      finishedCourse: // value for 'finishedCourse'
 *   },
 * });
 */
export function useAddCourseToUserMutation(baseOptions?: Apollo.MutationHookOptions<AddCourseToUserMutation, AddCourseToUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCourseToUserMutation, AddCourseToUserMutationVariables>(AddCourseToUserDocument, options);
      }
export type AddCourseToUserMutationHookResult = ReturnType<typeof useAddCourseToUserMutation>;
export type AddCourseToUserMutationResult = Apollo.MutationResult<AddCourseToUserMutation>;
export type AddCourseToUserMutationOptions = Apollo.BaseMutationOptions<AddCourseToUserMutation, AddCourseToUserMutationVariables>;
export const RefreshLastAccessAtDocument = gql`
    mutation RefreshLastAccessAt($userId: String!) {
  refreshLastAccessAt(userId: $userId)
}
    `;
export type RefreshLastAccessAtMutationFn = Apollo.MutationFunction<RefreshLastAccessAtMutation, RefreshLastAccessAtMutationVariables>;

/**
 * __useRefreshLastAccessAtMutation__
 *
 * To run a mutation, you first call `useRefreshLastAccessAtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshLastAccessAtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshLastAccessAtMutation, { data, loading, error }] = useRefreshLastAccessAtMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRefreshLastAccessAtMutation(baseOptions?: Apollo.MutationHookOptions<RefreshLastAccessAtMutation, RefreshLastAccessAtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshLastAccessAtMutation, RefreshLastAccessAtMutationVariables>(RefreshLastAccessAtDocument, options);
      }
export type RefreshLastAccessAtMutationHookResult = ReturnType<typeof useRefreshLastAccessAtMutation>;
export type RefreshLastAccessAtMutationResult = Apollo.MutationResult<RefreshLastAccessAtMutation>;
export type RefreshLastAccessAtMutationOptions = Apollo.BaseMutationOptions<RefreshLastAccessAtMutation, RefreshLastAccessAtMutationVariables>;
export const SignUserTermsDocument = gql`
    mutation SignUserTerms {
  signUserTerms
}
    `;
export type SignUserTermsMutationFn = Apollo.MutationFunction<SignUserTermsMutation, SignUserTermsMutationVariables>;

/**
 * __useSignUserTermsMutation__
 *
 * To run a mutation, you first call `useSignUserTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUserTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUserTermsMutation, { data, loading, error }] = useSignUserTermsMutation({
 *   variables: {
 *   },
 * });
 */
export function useSignUserTermsMutation(baseOptions?: Apollo.MutationHookOptions<SignUserTermsMutation, SignUserTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUserTermsMutation, SignUserTermsMutationVariables>(SignUserTermsDocument, options);
      }
export type SignUserTermsMutationHookResult = ReturnType<typeof useSignUserTermsMutation>;
export type SignUserTermsMutationResult = Apollo.MutationResult<SignUserTermsMutation>;
export type SignUserTermsMutationOptions = Apollo.BaseMutationOptions<SignUserTermsMutation, SignUserTermsMutationVariables>;
export const EnableUserDocument = gql`
    mutation EnableUser($userId: String!) {
  enableUser(userId: $userId)
}
    `;
export type EnableUserMutationFn = Apollo.MutationFunction<EnableUserMutation, EnableUserMutationVariables>;

/**
 * __useEnableUserMutation__
 *
 * To run a mutation, you first call `useEnableUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableUserMutation, { data, loading, error }] = useEnableUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useEnableUserMutation(baseOptions?: Apollo.MutationHookOptions<EnableUserMutation, EnableUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableUserMutation, EnableUserMutationVariables>(EnableUserDocument, options);
      }
export type EnableUserMutationHookResult = ReturnType<typeof useEnableUserMutation>;
export type EnableUserMutationResult = Apollo.MutationResult<EnableUserMutation>;
export type EnableUserMutationOptions = Apollo.BaseMutationOptions<EnableUserMutation, EnableUserMutationVariables>;
export const DisableUserDocument = gql`
    mutation DisableUser($userId: String!) {
  disableUser(userId: $userId)
}
    `;
export type DisableUserMutationFn = Apollo.MutationFunction<DisableUserMutation, DisableUserMutationVariables>;

/**
 * __useDisableUserMutation__
 *
 * To run a mutation, you first call `useDisableUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableUserMutation, { data, loading, error }] = useDisableUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDisableUserMutation(baseOptions?: Apollo.MutationHookOptions<DisableUserMutation, DisableUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableUserMutation, DisableUserMutationVariables>(DisableUserDocument, options);
      }
export type DisableUserMutationHookResult = ReturnType<typeof useDisableUserMutation>;
export type DisableUserMutationResult = Apollo.MutationResult<DisableUserMutation>;
export type DisableUserMutationOptions = Apollo.BaseMutationOptions<DisableUserMutation, DisableUserMutationVariables>;
export const UpgradeUserToAdminDocument = gql`
    mutation UpgradeUserToAdmin($userId: String!) {
  upgradeUserToAdmin(userId: $userId)
}
    `;
export type UpgradeUserToAdminMutationFn = Apollo.MutationFunction<UpgradeUserToAdminMutation, UpgradeUserToAdminMutationVariables>;

/**
 * __useUpgradeUserToAdminMutation__
 *
 * To run a mutation, you first call `useUpgradeUserToAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeUserToAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeUserToAdminMutation, { data, loading, error }] = useUpgradeUserToAdminMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpgradeUserToAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpgradeUserToAdminMutation, UpgradeUserToAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpgradeUserToAdminMutation, UpgradeUserToAdminMutationVariables>(UpgradeUserToAdminDocument, options);
      }
export type UpgradeUserToAdminMutationHookResult = ReturnType<typeof useUpgradeUserToAdminMutation>;
export type UpgradeUserToAdminMutationResult = Apollo.MutationResult<UpgradeUserToAdminMutation>;
export type UpgradeUserToAdminMutationOptions = Apollo.BaseMutationOptions<UpgradeUserToAdminMutation, UpgradeUserToAdminMutationVariables>;
export const GetCreateClaimOnFormResponseDocument = gql`
    query GetCreateClaimOnFormResponse($documentId: String!) {
  getCreateClaimOnFormResponse(documentId: $documentId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetCreateClaimOnFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreateClaimOnFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateClaimOnFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateClaimOnFormResponseQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetCreateClaimOnFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreateClaimOnFormResponseQuery, GetCreateClaimOnFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateClaimOnFormResponseQuery, GetCreateClaimOnFormResponseQueryVariables>(GetCreateClaimOnFormResponseDocument, options);
      }
export function useGetCreateClaimOnFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateClaimOnFormResponseQuery, GetCreateClaimOnFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateClaimOnFormResponseQuery, GetCreateClaimOnFormResponseQueryVariables>(GetCreateClaimOnFormResponseDocument, options);
        }
export type GetCreateClaimOnFormResponseQueryHookResult = ReturnType<typeof useGetCreateClaimOnFormResponseQuery>;
export type GetCreateClaimOnFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreateClaimOnFormResponseLazyQuery>;
export type GetCreateClaimOnFormResponseQueryResult = Apollo.QueryResult<GetCreateClaimOnFormResponseQuery, GetCreateClaimOnFormResponseQueryVariables>;
export const GetEditClaimOnFormResponseDocument = gql`
    query GetEditClaimOnFormResponse($objectId: String!) {
  getEditClaimOnFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditClaimOnFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditClaimOnFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditClaimOnFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditClaimOnFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditClaimOnFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditClaimOnFormResponseQuery, GetEditClaimOnFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditClaimOnFormResponseQuery, GetEditClaimOnFormResponseQueryVariables>(GetEditClaimOnFormResponseDocument, options);
      }
export function useGetEditClaimOnFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditClaimOnFormResponseQuery, GetEditClaimOnFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditClaimOnFormResponseQuery, GetEditClaimOnFormResponseQueryVariables>(GetEditClaimOnFormResponseDocument, options);
        }
export type GetEditClaimOnFormResponseQueryHookResult = ReturnType<typeof useGetEditClaimOnFormResponseQuery>;
export type GetEditClaimOnFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditClaimOnFormResponseLazyQuery>;
export type GetEditClaimOnFormResponseQueryResult = Apollo.QueryResult<GetEditClaimOnFormResponseQuery, GetEditClaimOnFormResponseQueryVariables>;
export const GetEditConclusionLetterOnClaimDocument = gql`
    query GetEditConclusionLetterOnClaim($objectId: String!) {
  getEditConclusionLetterOnClaim(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditConclusionLetterOnClaimQuery__
 *
 * To run a query within a React component, call `useGetEditConclusionLetterOnClaimQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditConclusionLetterOnClaimQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditConclusionLetterOnClaimQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditConclusionLetterOnClaimQuery(baseOptions: Apollo.QueryHookOptions<GetEditConclusionLetterOnClaimQuery, GetEditConclusionLetterOnClaimQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditConclusionLetterOnClaimQuery, GetEditConclusionLetterOnClaimQueryVariables>(GetEditConclusionLetterOnClaimDocument, options);
      }
export function useGetEditConclusionLetterOnClaimLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditConclusionLetterOnClaimQuery, GetEditConclusionLetterOnClaimQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditConclusionLetterOnClaimQuery, GetEditConclusionLetterOnClaimQueryVariables>(GetEditConclusionLetterOnClaimDocument, options);
        }
export type GetEditConclusionLetterOnClaimQueryHookResult = ReturnType<typeof useGetEditConclusionLetterOnClaimQuery>;
export type GetEditConclusionLetterOnClaimLazyQueryHookResult = ReturnType<typeof useGetEditConclusionLetterOnClaimLazyQuery>;
export type GetEditConclusionLetterOnClaimQueryResult = Apollo.QueryResult<GetEditConclusionLetterOnClaimQuery, GetEditConclusionLetterOnClaimQueryVariables>;
export const GetEditEstimatedIndemnityOnClaimDocument = gql`
    query GetEditEstimatedIndemnityOnClaim($objectId: String!) {
  getEditEstimatedIndemnityOnClaim(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditEstimatedIndemnityOnClaimQuery__
 *
 * To run a query within a React component, call `useGetEditEstimatedIndemnityOnClaimQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditEstimatedIndemnityOnClaimQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditEstimatedIndemnityOnClaimQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditEstimatedIndemnityOnClaimQuery(baseOptions: Apollo.QueryHookOptions<GetEditEstimatedIndemnityOnClaimQuery, GetEditEstimatedIndemnityOnClaimQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditEstimatedIndemnityOnClaimQuery, GetEditEstimatedIndemnityOnClaimQueryVariables>(GetEditEstimatedIndemnityOnClaimDocument, options);
      }
export function useGetEditEstimatedIndemnityOnClaimLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditEstimatedIndemnityOnClaimQuery, GetEditEstimatedIndemnityOnClaimQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditEstimatedIndemnityOnClaimQuery, GetEditEstimatedIndemnityOnClaimQueryVariables>(GetEditEstimatedIndemnityOnClaimDocument, options);
        }
export type GetEditEstimatedIndemnityOnClaimQueryHookResult = ReturnType<typeof useGetEditEstimatedIndemnityOnClaimQuery>;
export type GetEditEstimatedIndemnityOnClaimLazyQueryHookResult = ReturnType<typeof useGetEditEstimatedIndemnityOnClaimLazyQuery>;
export type GetEditEstimatedIndemnityOnClaimQueryResult = Apollo.QueryResult<GetEditEstimatedIndemnityOnClaimQuery, GetEditEstimatedIndemnityOnClaimQueryVariables>;
export const GetEditContestationLetterOnClaimDocument = gql`
    query GetEditContestationLetterOnClaim($objectId: String!) {
  getEditContestationLetterOnClaim(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditContestationLetterOnClaimQuery__
 *
 * To run a query within a React component, call `useGetEditContestationLetterOnClaimQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditContestationLetterOnClaimQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditContestationLetterOnClaimQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditContestationLetterOnClaimQuery(baseOptions: Apollo.QueryHookOptions<GetEditContestationLetterOnClaimQuery, GetEditContestationLetterOnClaimQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditContestationLetterOnClaimQuery, GetEditContestationLetterOnClaimQueryVariables>(GetEditContestationLetterOnClaimDocument, options);
      }
export function useGetEditContestationLetterOnClaimLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditContestationLetterOnClaimQuery, GetEditContestationLetterOnClaimQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditContestationLetterOnClaimQuery, GetEditContestationLetterOnClaimQueryVariables>(GetEditContestationLetterOnClaimDocument, options);
        }
export type GetEditContestationLetterOnClaimQueryHookResult = ReturnType<typeof useGetEditContestationLetterOnClaimQuery>;
export type GetEditContestationLetterOnClaimLazyQueryHookResult = ReturnType<typeof useGetEditContestationLetterOnClaimLazyQuery>;
export type GetEditContestationLetterOnClaimQueryResult = Apollo.QueryResult<GetEditContestationLetterOnClaimQuery, GetEditContestationLetterOnClaimQueryVariables>;
export const GetEditHarvestDatesLettersOnClaimFormResponseDocument = gql`
    query GetEditHarvestDatesLettersOnClaimFormResponse($objectId: String!) {
  getEditHarvestDatesLettersOnClaimFormResponse(objectId: $objectId) {
    formResponseId
    formId
  }
}
    `;

/**
 * __useGetEditHarvestDatesLettersOnClaimFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditHarvestDatesLettersOnClaimFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditHarvestDatesLettersOnClaimFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditHarvestDatesLettersOnClaimFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditHarvestDatesLettersOnClaimFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditHarvestDatesLettersOnClaimFormResponseQuery, GetEditHarvestDatesLettersOnClaimFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditHarvestDatesLettersOnClaimFormResponseQuery, GetEditHarvestDatesLettersOnClaimFormResponseQueryVariables>(GetEditHarvestDatesLettersOnClaimFormResponseDocument, options);
      }
export function useGetEditHarvestDatesLettersOnClaimFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditHarvestDatesLettersOnClaimFormResponseQuery, GetEditHarvestDatesLettersOnClaimFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditHarvestDatesLettersOnClaimFormResponseQuery, GetEditHarvestDatesLettersOnClaimFormResponseQueryVariables>(GetEditHarvestDatesLettersOnClaimFormResponseDocument, options);
        }
export type GetEditHarvestDatesLettersOnClaimFormResponseQueryHookResult = ReturnType<typeof useGetEditHarvestDatesLettersOnClaimFormResponseQuery>;
export type GetEditHarvestDatesLettersOnClaimFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditHarvestDatesLettersOnClaimFormResponseLazyQuery>;
export type GetEditHarvestDatesLettersOnClaimFormResponseQueryResult = Apollo.QueryResult<GetEditHarvestDatesLettersOnClaimFormResponseQuery, GetEditHarvestDatesLettersOnClaimFormResponseQueryVariables>;
export const ListClaimsDocument = gql`
    query ListClaims($filter: ClaimsFiltersInput!) {
  claims(filter: $filter) {
    _id
    documentId
    externalId
    noticeDate
    events
    status
  }
}
    `;

/**
 * __useListClaimsQuery__
 *
 * To run a query within a React component, call `useListClaimsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListClaimsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListClaimsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListClaimsQuery(baseOptions: Apollo.QueryHookOptions<ListClaimsQuery, ListClaimsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListClaimsQuery, ListClaimsQueryVariables>(ListClaimsDocument, options);
      }
export function useListClaimsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListClaimsQuery, ListClaimsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListClaimsQuery, ListClaimsQueryVariables>(ListClaimsDocument, options);
        }
export type ListClaimsQueryHookResult = ReturnType<typeof useListClaimsQuery>;
export type ListClaimsLazyQueryHookResult = ReturnType<typeof useListClaimsLazyQuery>;
export type ListClaimsQueryResult = Apollo.QueryResult<ListClaimsQuery, ListClaimsQueryVariables>;
export const GetContactDocument = gql`
    query getContact($contactId: String!) {
  contact(contactId: $contactId) {
    ...BaseContactFields
    rg
    emissionInstitutionId
    expeditionDate
    civilState
    birthDate
    gender
    professionId
    comments
    cultureIds
    rating
    originatorId
    createdAt
    industry
    subsidiariesCount
    cities
    operationalArea
    membershipCount
    departmentRole
    orgId
    status
    responsibleId
    originatorId
    commission
    meetings {
      _id
      status
      responsibleId
      responsible {
        name
      }
      date
      topic
      comment
      attachment
    }
    address {
      city
      state
      street
      number
      complement
      cep
    }
    parent {
      _id
      name
      email
      cpfCnpj
      mobilePhone
      tags
    }
    responsible {
      _id
      name
    }
    user {
      _id
      role
      status
      signedDate
      createdAt
      disabled
      name
      email
      phone
      profession
      finishedCourse
      contactId
      lastAccessAt
    }
    members {
      ...BaseContactFields
      departmentRole
    }
  }
}
    ${BaseContactFieldsFragmentDoc}`;

/**
 * __useGetContactQuery__
 *
 * To run a query within a React component, call `useGetContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetContactQuery(baseOptions: Apollo.QueryHookOptions<GetContactQuery, GetContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactQuery, GetContactQueryVariables>(GetContactDocument, options);
      }
export function useGetContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactQuery, GetContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactQuery, GetContactQueryVariables>(GetContactDocument, options);
        }
export type GetContactQueryHookResult = ReturnType<typeof useGetContactQuery>;
export type GetContactLazyQueryHookResult = ReturnType<typeof useGetContactLazyQuery>;
export type GetContactQueryResult = Apollo.QueryResult<GetContactQuery, GetContactQueryVariables>;
export const GetContactBySlugDocument = gql`
    query getContactBySlug($slug: String!) {
  contactBySlug(slug: $slug) {
    _id
  }
}
    `;

/**
 * __useGetContactBySlugQuery__
 *
 * To run a query within a React component, call `useGetContactBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetContactBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetContactBySlugQuery, GetContactBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactBySlugQuery, GetContactBySlugQueryVariables>(GetContactBySlugDocument, options);
      }
export function useGetContactBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactBySlugQuery, GetContactBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactBySlugQuery, GetContactBySlugQueryVariables>(GetContactBySlugDocument, options);
        }
export type GetContactBySlugQueryHookResult = ReturnType<typeof useGetContactBySlugQuery>;
export type GetContactBySlugLazyQueryHookResult = ReturnType<typeof useGetContactBySlugLazyQuery>;
export type GetContactBySlugQueryResult = Apollo.QueryResult<GetContactBySlugQuery, GetContactBySlugQueryVariables>;
export const ListContactsDocument = gql`
    query listContacts($filter: [[ContactsFiltersInput!]!]!, $sort: MongoSortQuery, $skip: Int, $limit: Int) {
  contacts(filter: $filter, sort: $sort, skip: $skip, limit: $limit) {
    ...BaseContactFields
    createdAt
    status
    address {
      state
    }
    responsible {
      name
    }
    user {
      disabled
    }
  }
}
    ${BaseContactFieldsFragmentDoc}`;

/**
 * __useListContactsQuery__
 *
 * To run a query within a React component, call `useListContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListContactsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListContactsQuery(baseOptions: Apollo.QueryHookOptions<ListContactsQuery, ListContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListContactsQuery, ListContactsQueryVariables>(ListContactsDocument, options);
      }
export function useListContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListContactsQuery, ListContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListContactsQuery, ListContactsQueryVariables>(ListContactsDocument, options);
        }
export type ListContactsQueryHookResult = ReturnType<typeof useListContactsQuery>;
export type ListContactsLazyQueryHookResult = ReturnType<typeof useListContactsLazyQuery>;
export type ListContactsQueryResult = Apollo.QueryResult<ListContactsQuery, ListContactsQueryVariables>;
export const CountContactsDocument = gql`
    query CountContacts($filter: [[ContactsFiltersInput]]!) {
  countContacts(filter: $filter)
}
    `;

/**
 * __useCountContactsQuery__
 *
 * To run a query within a React component, call `useCountContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountContactsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCountContactsQuery(baseOptions: Apollo.QueryHookOptions<CountContactsQuery, CountContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountContactsQuery, CountContactsQueryVariables>(CountContactsDocument, options);
      }
export function useCountContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountContactsQuery, CountContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountContactsQuery, CountContactsQueryVariables>(CountContactsDocument, options);
        }
export type CountContactsQueryHookResult = ReturnType<typeof useCountContactsQuery>;
export type CountContactsLazyQueryHookResult = ReturnType<typeof useCountContactsLazyQuery>;
export type CountContactsQueryResult = Apollo.QueryResult<CountContactsQuery, CountContactsQueryVariables>;
export const GetEditFinancialResponsibleOnDocumentFormResponseDocument = gql`
    query getEditFinancialResponsibleOnDocumentFormResponse($objectId: String!, $documentId: String!) {
  getEditFinancialResponsibleOnDocumentFormResponse(
    objectId: $objectId
    documentId: $documentId
  ) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditFinancialResponsibleOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditFinancialResponsibleOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditFinancialResponsibleOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditFinancialResponsibleOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetEditFinancialResponsibleOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditFinancialResponsibleOnDocumentFormResponseQuery, GetEditFinancialResponsibleOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditFinancialResponsibleOnDocumentFormResponseQuery, GetEditFinancialResponsibleOnDocumentFormResponseQueryVariables>(GetEditFinancialResponsibleOnDocumentFormResponseDocument, options);
      }
export function useGetEditFinancialResponsibleOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditFinancialResponsibleOnDocumentFormResponseQuery, GetEditFinancialResponsibleOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditFinancialResponsibleOnDocumentFormResponseQuery, GetEditFinancialResponsibleOnDocumentFormResponseQueryVariables>(GetEditFinancialResponsibleOnDocumentFormResponseDocument, options);
        }
export type GetEditFinancialResponsibleOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetEditFinancialResponsibleOnDocumentFormResponseQuery>;
export type GetEditFinancialResponsibleOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditFinancialResponsibleOnDocumentFormResponseLazyQuery>;
export type GetEditFinancialResponsibleOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetEditFinancialResponsibleOnDocumentFormResponseQuery, GetEditFinancialResponsibleOnDocumentFormResponseQueryVariables>;
export const GetEditContactOnFormResponseDocument = gql`
    query GetEditContactOnFormResponse($objectId: String!) {
  getEditContactOnFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditContactOnFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditContactOnFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditContactOnFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditContactOnFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditContactOnFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditContactOnFormResponseQuery, GetEditContactOnFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditContactOnFormResponseQuery, GetEditContactOnFormResponseQueryVariables>(GetEditContactOnFormResponseDocument, options);
      }
export function useGetEditContactOnFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditContactOnFormResponseQuery, GetEditContactOnFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditContactOnFormResponseQuery, GetEditContactOnFormResponseQueryVariables>(GetEditContactOnFormResponseDocument, options);
        }
export type GetEditContactOnFormResponseQueryHookResult = ReturnType<typeof useGetEditContactOnFormResponseQuery>;
export type GetEditContactOnFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditContactOnFormResponseLazyQuery>;
export type GetEditContactOnFormResponseQueryResult = Apollo.QueryResult<GetEditContactOnFormResponseQuery, GetEditContactOnFormResponseQueryVariables>;
export const GetCreateOrgMembersFormResponseDocument = gql`
    query GetCreateOrgMembersFormResponse($orgId: String!) {
  getCreateOrgMembersFormResponse(orgId: $orgId) {
    formResponseId
    formId
  }
}
    `;

/**
 * __useGetCreateOrgMembersFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreateOrgMembersFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateOrgMembersFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateOrgMembersFormResponseQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetCreateOrgMembersFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreateOrgMembersFormResponseQuery, GetCreateOrgMembersFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateOrgMembersFormResponseQuery, GetCreateOrgMembersFormResponseQueryVariables>(GetCreateOrgMembersFormResponseDocument, options);
      }
export function useGetCreateOrgMembersFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateOrgMembersFormResponseQuery, GetCreateOrgMembersFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateOrgMembersFormResponseQuery, GetCreateOrgMembersFormResponseQueryVariables>(GetCreateOrgMembersFormResponseDocument, options);
        }
export type GetCreateOrgMembersFormResponseQueryHookResult = ReturnType<typeof useGetCreateOrgMembersFormResponseQuery>;
export type GetCreateOrgMembersFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreateOrgMembersFormResponseLazyQuery>;
export type GetCreateOrgMembersFormResponseQueryResult = Apollo.QueryResult<GetCreateOrgMembersFormResponseQuery, GetCreateOrgMembersFormResponseQueryVariables>;
export const GetOrgWithMembersDocument = gql`
    query GetOrgWithMembers($contactId: String!) {
  contact(contactId: $contactId) {
    name
    slug
    industry
    cities
    subsidiariesCount
    operationalArea
    membershipCount
    members {
      _id
      name
      email
      mobilePhone
      departmentRole
    }
  }
}
    `;

/**
 * __useGetOrgWithMembersQuery__
 *
 * To run a query within a React component, call `useGetOrgWithMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgWithMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgWithMembersQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetOrgWithMembersQuery(baseOptions: Apollo.QueryHookOptions<GetOrgWithMembersQuery, GetOrgWithMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrgWithMembersQuery, GetOrgWithMembersQueryVariables>(GetOrgWithMembersDocument, options);
      }
export function useGetOrgWithMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrgWithMembersQuery, GetOrgWithMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrgWithMembersQuery, GetOrgWithMembersQueryVariables>(GetOrgWithMembersDocument, options);
        }
export type GetOrgWithMembersQueryHookResult = ReturnType<typeof useGetOrgWithMembersQuery>;
export type GetOrgWithMembersLazyQueryHookResult = ReturnType<typeof useGetOrgWithMembersLazyQuery>;
export type GetOrgWithMembersQueryResult = Apollo.QueryResult<GetOrgWithMembersQuery, GetOrgWithMembersQueryVariables>;
export const GetPartnersDashboardDataDocument = gql`
    query GetPartnersDashboardData {
  getPartnersDashboardData {
    tag
    statusGroups {
      status
      count
    }
  }
}
    `;

/**
 * __useGetPartnersDashboardDataQuery__
 *
 * To run a query within a React component, call `useGetPartnersDashboardDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnersDashboardDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnersDashboardDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPartnersDashboardDataQuery(baseOptions?: Apollo.QueryHookOptions<GetPartnersDashboardDataQuery, GetPartnersDashboardDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnersDashboardDataQuery, GetPartnersDashboardDataQueryVariables>(GetPartnersDashboardDataDocument, options);
      }
export function useGetPartnersDashboardDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnersDashboardDataQuery, GetPartnersDashboardDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnersDashboardDataQuery, GetPartnersDashboardDataQueryVariables>(GetPartnersDashboardDataDocument, options);
        }
export type GetPartnersDashboardDataQueryHookResult = ReturnType<typeof useGetPartnersDashboardDataQuery>;
export type GetPartnersDashboardDataLazyQueryHookResult = ReturnType<typeof useGetPartnersDashboardDataLazyQuery>;
export type GetPartnersDashboardDataQueryResult = Apollo.QueryResult<GetPartnersDashboardDataQuery, GetPartnersDashboardDataQueryVariables>;
export const GetEditCropOnDocumentFormResponseDocument = gql`
    query GetEditCropOnDocumentFormResponse($objectId: String!, $documentId: String!) {
  getEditCropOnDocumentFormResponse(objectId: $objectId, documentId: $documentId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditCropOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditCropOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditCropOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditCropOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetEditCropOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditCropOnDocumentFormResponseQuery, GetEditCropOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditCropOnDocumentFormResponseQuery, GetEditCropOnDocumentFormResponseQueryVariables>(GetEditCropOnDocumentFormResponseDocument, options);
      }
export function useGetEditCropOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditCropOnDocumentFormResponseQuery, GetEditCropOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditCropOnDocumentFormResponseQuery, GetEditCropOnDocumentFormResponseQueryVariables>(GetEditCropOnDocumentFormResponseDocument, options);
        }
export type GetEditCropOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetEditCropOnDocumentFormResponseQuery>;
export type GetEditCropOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditCropOnDocumentFormResponseLazyQuery>;
export type GetEditCropOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetEditCropOnDocumentFormResponseQuery, GetEditCropOnDocumentFormResponseQueryVariables>;
export const GetCreateKmlFileUploadFormResponseDocument = gql`
    query GetCreateKmlFileUploadFormResponse($documentId: String!) {
  getCreateKmlFileUploadFormResponse(documentId: $documentId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetCreateKmlFileUploadFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreateKmlFileUploadFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateKmlFileUploadFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateKmlFileUploadFormResponseQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetCreateKmlFileUploadFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreateKmlFileUploadFormResponseQuery, GetCreateKmlFileUploadFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateKmlFileUploadFormResponseQuery, GetCreateKmlFileUploadFormResponseQueryVariables>(GetCreateKmlFileUploadFormResponseDocument, options);
      }
export function useGetCreateKmlFileUploadFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateKmlFileUploadFormResponseQuery, GetCreateKmlFileUploadFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateKmlFileUploadFormResponseQuery, GetCreateKmlFileUploadFormResponseQueryVariables>(GetCreateKmlFileUploadFormResponseDocument, options);
        }
export type GetCreateKmlFileUploadFormResponseQueryHookResult = ReturnType<typeof useGetCreateKmlFileUploadFormResponseQuery>;
export type GetCreateKmlFileUploadFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreateKmlFileUploadFormResponseLazyQuery>;
export type GetCreateKmlFileUploadFormResponseQueryResult = Apollo.QueryResult<GetCreateKmlFileUploadFormResponseQuery, GetCreateKmlFileUploadFormResponseQueryVariables>;
export const CulturesDocument = gql`
    query Cultures {
  cultures {
    _id
    name
    currentSackValue
    active
  }
}
    `;

/**
 * __useCulturesQuery__
 *
 * To run a query within a React component, call `useCulturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCulturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCulturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCulturesQuery(baseOptions?: Apollo.QueryHookOptions<CulturesQuery, CulturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CulturesQuery, CulturesQueryVariables>(CulturesDocument, options);
      }
export function useCulturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CulturesQuery, CulturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CulturesQuery, CulturesQueryVariables>(CulturesDocument, options);
        }
export type CulturesQueryHookResult = ReturnType<typeof useCulturesQuery>;
export type CulturesLazyQueryHookResult = ReturnType<typeof useCulturesLazyQuery>;
export type CulturesQueryResult = Apollo.QueryResult<CulturesQuery, CulturesQueryVariables>;
export const CultureDocument = gql`
    query Culture($cultureId: String!) {
  culture(cultureId: $cultureId) {
    _id
    name
    currentSackValue
    active
    allianzSettings {
      _id
      cultureId
      allianz {
        cultura {
          label
          value
        }
        culturaAnterior {
          label
          value
        }
        percentualComissao
        tipoProduto {
          label
          value
        }
        tecnicaPlantio {
          label
          value
        }
        custeioProvenienteCreditoRurual {
          label
          value
        }
        codigoNivelCobertura {
          label
          value
        }
        percentualProdutividadeEstimada {
          label
          value
        }
        valorSaca {
          label
          value
        }
        regulacaoSinistro {
          label
          value
        }
        texturaSolo {
          label
          value
        }
        realizadoControleFitosantitario {
          label
          value
        }
        grupoCultivar {
          label
          value
        }
        codigoCultivar {
          label
          value
        }
        custoEstimado
        percentualDesconto
        corte {
          label
          value
        }
        franquia {
          label
          value
        }
        coberturas {
          label
          value
        }
        formaPagamento {
          label
          value
        }
        quantidadeParcelas
      }
    }
  }
}
    `;

/**
 * __useCultureQuery__
 *
 * To run a query within a React component, call `useCultureQuery` and pass it any options that fit your needs.
 * When your component renders, `useCultureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCultureQuery({
 *   variables: {
 *      cultureId: // value for 'cultureId'
 *   },
 * });
 */
export function useCultureQuery(baseOptions: Apollo.QueryHookOptions<CultureQuery, CultureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CultureQuery, CultureQueryVariables>(CultureDocument, options);
      }
export function useCultureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CultureQuery, CultureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CultureQuery, CultureQueryVariables>(CultureDocument, options);
        }
export type CultureQueryHookResult = ReturnType<typeof useCultureQuery>;
export type CultureLazyQueryHookResult = ReturnType<typeof useCultureLazyQuery>;
export type CultureQueryResult = Apollo.QueryResult<CultureQuery, CultureQueryVariables>;
export const GetEditCultureFormResponseDocument = gql`
    query GetEditCultureFormResponse($objectId: String!) {
  getEditCultureFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditCultureFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditCultureFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditCultureFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditCultureFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditCultureFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditCultureFormResponseQuery, GetEditCultureFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditCultureFormResponseQuery, GetEditCultureFormResponseQueryVariables>(GetEditCultureFormResponseDocument, options);
      }
export function useGetEditCultureFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditCultureFormResponseQuery, GetEditCultureFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditCultureFormResponseQuery, GetEditCultureFormResponseQueryVariables>(GetEditCultureFormResponseDocument, options);
        }
export type GetEditCultureFormResponseQueryHookResult = ReturnType<typeof useGetEditCultureFormResponseQuery>;
export type GetEditCultureFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditCultureFormResponseLazyQuery>;
export type GetEditCultureFormResponseQueryResult = Apollo.QueryResult<GetEditCultureFormResponseQuery, GetEditCultureFormResponseQueryVariables>;
export const ListDocumentsDocument = gql`
    query listDocuments($filter: [[DocumentsFilterInput]]!, $sort: MongoSortQuery, $skip: Int, $limit: Int) {
  documents(filter: $filter, sort: $sort, skip: $skip, limit: $limit) {
    _id
    stage
    status
    updatedAt
    createdAt
    claimStatus
    premium
    commercialResponsibleId
    description
    provider
    forestItems {
      area
    }
    commercialResponsible {
      name
    }
    operationalResponsibleId
    operationalResponsible {
      name
    }
    claimResponsible {
      name
    }
    originatorId
    originator {
      name
    }
    farmer {
      name
    }
    crop {
      cultureName
      culture {
        name
      }
      area
    }
    properties {
      displayName
      address {
        city
        state
      }
    }
    insuranceTypeGroup
  }
}
    `;

/**
 * __useListDocumentsQuery__
 *
 * To run a query within a React component, call `useListDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDocumentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListDocumentsQuery(baseOptions: Apollo.QueryHookOptions<ListDocumentsQuery, ListDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDocumentsQuery, ListDocumentsQueryVariables>(ListDocumentsDocument, options);
      }
export function useListDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDocumentsQuery, ListDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDocumentsQuery, ListDocumentsQueryVariables>(ListDocumentsDocument, options);
        }
export type ListDocumentsQueryHookResult = ReturnType<typeof useListDocumentsQuery>;
export type ListDocumentsLazyQueryHookResult = ReturnType<typeof useListDocumentsLazyQuery>;
export type ListDocumentsQueryResult = Apollo.QueryResult<ListDocumentsQuery, ListDocumentsQueryVariables>;
export const CountDocumentsDocument = gql`
    query CountDocuments($filter: [[DocumentsFilterInput]]!) {
  countDocuments(filter: $filter)
}
    `;

/**
 * __useCountDocumentsQuery__
 *
 * To run a query within a React component, call `useCountDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountDocumentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCountDocumentsQuery(baseOptions: Apollo.QueryHookOptions<CountDocumentsQuery, CountDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountDocumentsQuery, CountDocumentsQueryVariables>(CountDocumentsDocument, options);
      }
export function useCountDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountDocumentsQuery, CountDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountDocumentsQuery, CountDocumentsQueryVariables>(CountDocumentsDocument, options);
        }
export type CountDocumentsQueryHookResult = ReturnType<typeof useCountDocumentsQuery>;
export type CountDocumentsLazyQueryHookResult = ReturnType<typeof useCountDocumentsLazyQuery>;
export type CountDocumentsQueryResult = Apollo.QueryResult<CountDocumentsQuery, CountDocumentsQueryVariables>;
export const GetComplementaryDataFormResponseDocument = gql`
    query GetComplementaryDataFormResponse($objectId: String!) {
  getComplementaryDataFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetComplementaryDataFormResponseQuery__
 *
 * To run a query within a React component, call `useGetComplementaryDataFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplementaryDataFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplementaryDataFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetComplementaryDataFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetComplementaryDataFormResponseQuery, GetComplementaryDataFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetComplementaryDataFormResponseQuery, GetComplementaryDataFormResponseQueryVariables>(GetComplementaryDataFormResponseDocument, options);
      }
export function useGetComplementaryDataFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetComplementaryDataFormResponseQuery, GetComplementaryDataFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetComplementaryDataFormResponseQuery, GetComplementaryDataFormResponseQueryVariables>(GetComplementaryDataFormResponseDocument, options);
        }
export type GetComplementaryDataFormResponseQueryHookResult = ReturnType<typeof useGetComplementaryDataFormResponseQuery>;
export type GetComplementaryDataFormResponseLazyQueryHookResult = ReturnType<typeof useGetComplementaryDataFormResponseLazyQuery>;
export type GetComplementaryDataFormResponseQueryResult = Apollo.QueryResult<GetComplementaryDataFormResponseQuery, GetComplementaryDataFormResponseQueryVariables>;
export const GetNfeUploadFormResponseDocument = gql`
    query GetNfeUploadFormResponse($objectId: String!) {
  getNfeUploadFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetNfeUploadFormResponseQuery__
 *
 * To run a query within a React component, call `useGetNfeUploadFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNfeUploadFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNfeUploadFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetNfeUploadFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetNfeUploadFormResponseQuery, GetNfeUploadFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNfeUploadFormResponseQuery, GetNfeUploadFormResponseQueryVariables>(GetNfeUploadFormResponseDocument, options);
      }
export function useGetNfeUploadFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNfeUploadFormResponseQuery, GetNfeUploadFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNfeUploadFormResponseQuery, GetNfeUploadFormResponseQueryVariables>(GetNfeUploadFormResponseDocument, options);
        }
export type GetNfeUploadFormResponseQueryHookResult = ReturnType<typeof useGetNfeUploadFormResponseQuery>;
export type GetNfeUploadFormResponseLazyQueryHookResult = ReturnType<typeof useGetNfeUploadFormResponseLazyQuery>;
export type GetNfeUploadFormResponseQueryResult = Apollo.QueryResult<GetNfeUploadFormResponseQuery, GetNfeUploadFormResponseQueryVariables>;
export const GetEditPaymentDataOnDocumentFormResponseDocument = gql`
    query getEditPaymentDataOnDocumentFormResponse($objectId: String!) {
  getEditPaymentDataOnDocumentFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditPaymentDataOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditPaymentDataOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditPaymentDataOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditPaymentDataOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditPaymentDataOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditPaymentDataOnDocumentFormResponseQuery, GetEditPaymentDataOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditPaymentDataOnDocumentFormResponseQuery, GetEditPaymentDataOnDocumentFormResponseQueryVariables>(GetEditPaymentDataOnDocumentFormResponseDocument, options);
      }
export function useGetEditPaymentDataOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditPaymentDataOnDocumentFormResponseQuery, GetEditPaymentDataOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditPaymentDataOnDocumentFormResponseQuery, GetEditPaymentDataOnDocumentFormResponseQueryVariables>(GetEditPaymentDataOnDocumentFormResponseDocument, options);
        }
export type GetEditPaymentDataOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetEditPaymentDataOnDocumentFormResponseQuery>;
export type GetEditPaymentDataOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditPaymentDataOnDocumentFormResponseLazyQuery>;
export type GetEditPaymentDataOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetEditPaymentDataOnDocumentFormResponseQuery, GetEditPaymentDataOnDocumentFormResponseQueryVariables>;
export const GetDocumentRejectionFormResponseDocument = gql`
    query GetDocumentRejectionFormResponse($documentId: String!) {
  getDocumentRejectionFormResponse(documentId: $documentId) {
    formResponseId
    formId
  }
}
    `;

/**
 * __useGetDocumentRejectionFormResponseQuery__
 *
 * To run a query within a React component, call `useGetDocumentRejectionFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentRejectionFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentRejectionFormResponseQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentRejectionFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentRejectionFormResponseQuery, GetDocumentRejectionFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentRejectionFormResponseQuery, GetDocumentRejectionFormResponseQueryVariables>(GetDocumentRejectionFormResponseDocument, options);
      }
export function useGetDocumentRejectionFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentRejectionFormResponseQuery, GetDocumentRejectionFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentRejectionFormResponseQuery, GetDocumentRejectionFormResponseQueryVariables>(GetDocumentRejectionFormResponseDocument, options);
        }
export type GetDocumentRejectionFormResponseQueryHookResult = ReturnType<typeof useGetDocumentRejectionFormResponseQuery>;
export type GetDocumentRejectionFormResponseLazyQueryHookResult = ReturnType<typeof useGetDocumentRejectionFormResponseLazyQuery>;
export type GetDocumentRejectionFormResponseQueryResult = Apollo.QueryResult<GetDocumentRejectionFormResponseQuery, GetDocumentRejectionFormResponseQueryVariables>;
export const GetDocumentsDashboardCountersDocument = gql`
    query GetDocumentsDashboardCounters($filter: [[DocumentsFilterInput]]!) {
  getDocumentsDashboardCounters(filter: $filter) {
    count
    value
    statuses {
      count
      value
    }
  }
}
    `;

/**
 * __useGetDocumentsDashboardCountersQuery__
 *
 * To run a query within a React component, call `useGetDocumentsDashboardCountersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentsDashboardCountersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentsDashboardCountersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetDocumentsDashboardCountersQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentsDashboardCountersQuery, GetDocumentsDashboardCountersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentsDashboardCountersQuery, GetDocumentsDashboardCountersQueryVariables>(GetDocumentsDashboardCountersDocument, options);
      }
export function useGetDocumentsDashboardCountersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentsDashboardCountersQuery, GetDocumentsDashboardCountersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentsDashboardCountersQuery, GetDocumentsDashboardCountersQueryVariables>(GetDocumentsDashboardCountersDocument, options);
        }
export type GetDocumentsDashboardCountersQueryHookResult = ReturnType<typeof useGetDocumentsDashboardCountersQuery>;
export type GetDocumentsDashboardCountersLazyQueryHookResult = ReturnType<typeof useGetDocumentsDashboardCountersLazyQuery>;
export type GetDocumentsDashboardCountersQueryResult = Apollo.QueryResult<GetDocumentsDashboardCountersQuery, GetDocumentsDashboardCountersQueryVariables>;
export const GetDocumentsDashboardFunnelDocument = gql`
    query GetDocumentsDashboardFunnel($startDate: Date!, $endDate: Date!, $filter: [[DocumentsFilterInput]]!) {
  getDocumentsDashboardFunnel(
    startDate: $startDate
    endDate: $endDate
    filter: $filter
  ) {
    category
    value
  }
}
    `;

/**
 * __useGetDocumentsDashboardFunnelQuery__
 *
 * To run a query within a React component, call `useGetDocumentsDashboardFunnelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentsDashboardFunnelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentsDashboardFunnelQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetDocumentsDashboardFunnelQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentsDashboardFunnelQuery, GetDocumentsDashboardFunnelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentsDashboardFunnelQuery, GetDocumentsDashboardFunnelQueryVariables>(GetDocumentsDashboardFunnelDocument, options);
      }
export function useGetDocumentsDashboardFunnelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentsDashboardFunnelQuery, GetDocumentsDashboardFunnelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentsDashboardFunnelQuery, GetDocumentsDashboardFunnelQueryVariables>(GetDocumentsDashboardFunnelDocument, options);
        }
export type GetDocumentsDashboardFunnelQueryHookResult = ReturnType<typeof useGetDocumentsDashboardFunnelQuery>;
export type GetDocumentsDashboardFunnelLazyQueryHookResult = ReturnType<typeof useGetDocumentsDashboardFunnelLazyQuery>;
export type GetDocumentsDashboardFunnelQueryResult = Apollo.QueryResult<GetDocumentsDashboardFunnelQuery, GetDocumentsDashboardFunnelQueryVariables>;
export const GetDocumentDetailsDocument = gql`
    query GetDocumentDetails($docId: String!) {
  document(docId: $docId) {
    _id
    createdAt
    updatedAt
    stage
    status
    provider
    rejectReason {
      other
      rejectReason
    }
    selectedResultIds
    recommendedSimulationResultId
    justificationMessage
    insuranceTypeGroup
    commercialResponsibleId
    operationalResponsibleId
    claimResponsibleId
    originatorId
    specialOperationId
    premium
    archived
    proposalResultId
    forestItems {
      ...ForestItemFields
    }
    visitPerson {
      name
    }
    costNFFiles {
      fileName
      fileKey
    }
    kmlFile {
      fileName
      fileKey
    }
    crop {
      _id
      area
      cultureName
      harvestStartDate
      harvestEndDate
      cultureId
      plantDate
      culture {
        name
      }
      cultureDetail {
        name
      }
      manualCulture
      kmlFile {
        fileName
        fileKey
      }
      compositionType
      cropYear
      plots {
        name
        cultureDetail {
          name
        }
        area
        plantDate
        plantMethod
        soilType
        irrigated
        cropYear
        plantSpacing
        lineSpacing
        seedType
        polygon
      }
    }
    contactId
    farmer {
      _id
      name
      cpfCnpj
      mobilePhone
      email
      rg
      emissionInstitution
      expeditionDate
      civilState
      gender
      birthDate
      profession
      documentFile {
        fileName
        fileKey
      }
      addressProofFile {
        fileName
        fileKey
      }
      address {
        city
        state
        street
        number
        complement
        cep
        neighborhood
      }
    }
    properties {
      _id
      accessInstructions
      address {
        city
        state
        street
        number
        complement
        cep
      }
      entranceLocation
      displayName
      name
      carRegistration
      plots {
        name
        cultureDetail {
          name
        }
        area
        plantDate
        plantMethod
        soilType
        irrigated
        cropYear
        plantSpacing
        lineSpacing
      }
    }
    description
    equipments {
      equipment {
        _id
        name
        property {
          displayName
        }
        type
        brand
        model
        manufactureYear
        marketValue
      }
      isRenewal
      previousProvider
      marketValue
      isNewEquipment
      isFinanced
      isLeased
      isNearWater
      serialNumberMatch
      hasTheftCoverage
    }
    failedSimulationResults {
      _id
      error
      provider
      basicCoverageType
    }
    validSimulationResults {
      _id
      status
      provider
      basicCoverageType
      guaranteedProductivity
      sackValue
      tags
      points {
        totalPremium
        sackValueDifference
        guaranteedProductivity
        totalPoints
      }
      itens {
        name
        coverages {
          name
          lmi
          premium
          coverageEvents {
            _id
            name
          }
        }
      }
      referenceLocation
      amounts {
        lmi
        totalPremium
        stateSubvention
        federalSubvention
        finalPremium
        maxPayments
      }
    }
    simulationResults {
      _id
      externalId
      status
      error
      name
      provider
      basicCoverageType
      guaranteedProductivity
      sackValue
      itens {
        name
        coverages {
          name
          lmi
          premium
          coverageEvents {
            _id
            name
          }
        }
      }
      referenceLocation
      amounts {
        lmi
        totalPremium
        stateSubvention
        federalSubvention
        finalPremium
        maxPayments
      }
    }
    selectedSimulationResults {
      _id
      name
      provider
      status
      basicCoverageType
      guaranteedProductivity
      sackValue
      tags
      amounts {
        lmi
        totalPremium
        maxPayments
        stateSubvention
        federalSubvention
        finalPremium
      }
      referenceLocation
      itens {
        name
        coverages {
          name
          lmi
          premium
          coverageEvents {
            _id
            name
          }
        }
      }
    }
    proposalResult {
      _id
      externalId
      name
      provider
      basicCoverageType
      guaranteedProductivity
      proposalFile {
        fileName
        fileKey
      }
      proposalSketchMap {
        _id
        fileName
        fileKey
      }
      signedProposalFile {
        _id
        fileName
        fileKey
      }
      amounts {
        lmi
        totalPremium
        maxPayments
        stateSubvention
        federalSubvention
        finalPremium
      }
      itens {
        name
        coverages {
          name
          lmi
          premium
          coverageEvents {
            _id
            name
          }
        }
      }
    }
    beneficiary {
      _id
      name
      cpfCnpj
      mobilePhone
      email
      rg
      emissionInstitution
      expeditionDate
      civilState
      gender
      birthDate
      profession
      documentFile {
        fileName
        fileKey
      }
      addressProofFile {
        fileName
        fileKey
      }
      address {
        city
        state
        street
        number
        complement
        cep
      }
    }
    allowedVisitPeople {
      name
      cpfCnpj
      mobilePhone
      email
    }
    policy {
      _id
      endDate
      startDate
      externalId
      billsFile {
        fileName
        fileKey
      }
      policyFile {
        fileName
        fileKey
      }
      cancellationReason {
        other
        cancellationReason
      }
    }
    paymentData {
      method
      responsibleId
      installments
      accountData {
        bank
        agency
        agencyDigit
        account
        accountDigit
      }
      responsible {
        _id
        name
        cpfCnpj
        mobilePhone
        email
        rg
        emissionInstitution
        expeditionDate
        civilState
        gender
        birthDate
        profession
        documentFile {
          fileName
          fileKey
        }
        addressProofFile {
          fileName
          fileKey
        }
        address {
          city
          state
          street
          number
          complement
          cep
        }
      }
    }
    payments {
      _id
      responsibleId
      provider
      name
      dateDue
      amount
      billFile {
        fileName
        fileKey
      }
      status
      subventionType
    }
    archivedProposals {
      _id
      externalId
      provider
      basicCoverageType
      type
      insuranceTypeGroup
      guaranteedProductivity
    }
    claims {
      _id
      name
      externalId
      status
      events
      plots
      coverages
      startDate
      endDate
      lossEstimate
      comment
      createdAt
      protocolNumber
      noticeDate
      indemnityAmount
      indemnityPaymentDate
      reportFile {
        fileName
        fileKey
      }
      indemnityAmount
      indemnityPaymentDate
      estimatedIndemnity
      contestationLetterFile {
        fileName
        fileKey
      }
      contestationProtocolNumber
      dateOfReanalysis
      harvestStartDateLetterFile {
        fileName
        fileKey
      }
      harvestEndDateLetterFile {
        fileName
        fileKey
      }
      harvestStartDateSignedLetterFile {
        fileName
        fileKey
      }
      harvestEndDateSignedLetterFile {
        fileName
        fileKey
      }
    }
    claimStatus
    inspections {
      _id
      documentId
      status
      type
      date
      regulatoryAgency
      observation
      claims {
        name
      }
      inspector {
        name
        mobilePhone
      }
      reportFile {
        fileName
        fileKey
      }
    }
    endorsements {
      _id
      documentId
      status
      reason
      otherReason
      description
      externalId
      consentFile {
        fileName
        fileKey
      }
      endorsementFile {
        fileName
        fileKey
      }
      rejectionFile {
        fileName
        fileKey
      }
      rejectionReason
      answerDate
    }
  }
}
    ${ForestItemFieldsFragmentDoc}`;

/**
 * __useGetDocumentDetailsQuery__
 *
 * To run a query within a React component, call `useGetDocumentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentDetailsQuery({
 *   variables: {
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useGetDocumentDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentDetailsQuery, GetDocumentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentDetailsQuery, GetDocumentDetailsQueryVariables>(GetDocumentDetailsDocument, options);
      }
export function useGetDocumentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentDetailsQuery, GetDocumentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentDetailsQuery, GetDocumentDetailsQueryVariables>(GetDocumentDetailsDocument, options);
        }
export type GetDocumentDetailsQueryHookResult = ReturnType<typeof useGetDocumentDetailsQuery>;
export type GetDocumentDetailsLazyQueryHookResult = ReturnType<typeof useGetDocumentDetailsLazyQuery>;
export type GetDocumentDetailsQueryResult = Apollo.QueryResult<GetDocumentDetailsQuery, GetDocumentDetailsQueryVariables>;
export const GetDirectDocumentDetailsDocument = gql`
    query GetDirectDocumentDetails($docId: String!) {
  document(docId: $docId) {
    _id
    stage
    status
    justificationMessage
    recommendedSimulationResultId
    insuranceTypeGroup
    premium
    createdAt
    description
    equipments {
      equipment {
        _id
      }
    }
    forestItemIds
    crop {
      area
      cultureName
      culture {
        name
      }
      cultureDetail {
        name
      }
      manualCulture
    }
    farmer {
      name
      cpfCnpj
    }
    properties {
      name
      plots {
        name
        cultureDetail {
          name
        }
        area
        plantDate
        plantMethod
        soilType
        irrigated
        cropYear
        plantSpacing
        lineSpacing
      }
      address {
        city
        state
      }
    }
    forestItems {
      ...ForestItemFields
    }
    specialOperationId
    selectedSimulationResults {
      _id
      name
      provider
      status
      basicCoverageType
      guaranteedProductivity
      sackValue
      tags
      points {
        totalPremium
        sackValueDifference
        guaranteedProductivity
        totalPoints
      }
      referenceLocation
      amounts {
        lmi
        totalPremium
        maxPayments
        stateSubvention
        federalSubvention
        finalPremium
      }
      itens {
        name
        coverages {
          name
          lmi
          premium
          coverageEvents {
            _id
            name
          }
        }
      }
    }
    simulationResults {
      _id
      name
      provider
      status
      basicCoverageType
      guaranteedProductivity
      referenceLocation
      amounts {
        lmi
        totalPremium
        maxPayments
        stateSubvention
        federalSubvention
        finalPremium
      }
      itens {
        name
        coverages {
          name
          lmi
          premium
          coverageEvents {
            _id
            name
          }
        }
      }
    }
  }
}
    ${ForestItemFieldsFragmentDoc}`;

/**
 * __useGetDirectDocumentDetailsQuery__
 *
 * To run a query within a React component, call `useGetDirectDocumentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDirectDocumentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDirectDocumentDetailsQuery({
 *   variables: {
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useGetDirectDocumentDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetDirectDocumentDetailsQuery, GetDirectDocumentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDirectDocumentDetailsQuery, GetDirectDocumentDetailsQueryVariables>(GetDirectDocumentDetailsDocument, options);
      }
export function useGetDirectDocumentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDirectDocumentDetailsQuery, GetDirectDocumentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDirectDocumentDetailsQuery, GetDirectDocumentDetailsQueryVariables>(GetDirectDocumentDetailsDocument, options);
        }
export type GetDirectDocumentDetailsQueryHookResult = ReturnType<typeof useGetDirectDocumentDetailsQuery>;
export type GetDirectDocumentDetailsLazyQueryHookResult = ReturnType<typeof useGetDirectDocumentDetailsLazyQuery>;
export type GetDirectDocumentDetailsQueryResult = Apollo.QueryResult<GetDirectDocumentDetailsQuery, GetDirectDocumentDetailsQueryVariables>;
export const ListContactDocumentsDocument = gql`
    query listContactDocuments($filter: [[DocumentsFilterInput]]!, $sort: MongoSortQuery) {
  documents(filter: $filter, sort: $sort) {
    _id
    farmerId
    updatedAt
    contactId
    beneficiaryId
    visitPersonId
    allowedVisitPeopleIds
    paymentData {
      responsibleId
    }
    description
    crop {
      cultureName
      area
    }
    properties {
      displayName
    }
    forestItems {
      area
    }
  }
}
    `;

/**
 * __useListContactDocumentsQuery__
 *
 * To run a query within a React component, call `useListContactDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListContactDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListContactDocumentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useListContactDocumentsQuery(baseOptions: Apollo.QueryHookOptions<ListContactDocumentsQuery, ListContactDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListContactDocumentsQuery, ListContactDocumentsQueryVariables>(ListContactDocumentsDocument, options);
      }
export function useListContactDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListContactDocumentsQuery, ListContactDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListContactDocumentsQuery, ListContactDocumentsQueryVariables>(ListContactDocumentsDocument, options);
        }
export type ListContactDocumentsQueryHookResult = ReturnType<typeof useListContactDocumentsQuery>;
export type ListContactDocumentsLazyQueryHookResult = ReturnType<typeof useListContactDocumentsLazyQuery>;
export type ListContactDocumentsQueryResult = Apollo.QueryResult<ListContactDocumentsQuery, ListContactDocumentsQueryVariables>;
export const GetCreateEndorsementOnDocumentFormResponseDocument = gql`
    query GetCreateEndorsementOnDocumentFormResponse($documentId: String!) {
  getCreateEndorsementOnDocumentFormResponse(documentId: $documentId) {
    formResponseId
    formId
  }
}
    `;

/**
 * __useGetCreateEndorsementOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreateEndorsementOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateEndorsementOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateEndorsementOnDocumentFormResponseQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetCreateEndorsementOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreateEndorsementOnDocumentFormResponseQuery, GetCreateEndorsementOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateEndorsementOnDocumentFormResponseQuery, GetCreateEndorsementOnDocumentFormResponseQueryVariables>(GetCreateEndorsementOnDocumentFormResponseDocument, options);
      }
export function useGetCreateEndorsementOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateEndorsementOnDocumentFormResponseQuery, GetCreateEndorsementOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateEndorsementOnDocumentFormResponseQuery, GetCreateEndorsementOnDocumentFormResponseQueryVariables>(GetCreateEndorsementOnDocumentFormResponseDocument, options);
        }
export type GetCreateEndorsementOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetCreateEndorsementOnDocumentFormResponseQuery>;
export type GetCreateEndorsementOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreateEndorsementOnDocumentFormResponseLazyQuery>;
export type GetCreateEndorsementOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetCreateEndorsementOnDocumentFormResponseQuery, GetCreateEndorsementOnDocumentFormResponseQueryVariables>;
export const GetEditEndorsementOnDocumentFormResponseDocument = gql`
    query GetEditEndorsementOnDocumentFormResponse($objectId: String!) {
  getEditEndorsementOnDocumentFormResponse(objectId: $objectId) {
    formResponseId
    formId
  }
}
    `;

/**
 * __useGetEditEndorsementOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditEndorsementOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditEndorsementOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditEndorsementOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditEndorsementOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditEndorsementOnDocumentFormResponseQuery, GetEditEndorsementOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditEndorsementOnDocumentFormResponseQuery, GetEditEndorsementOnDocumentFormResponseQueryVariables>(GetEditEndorsementOnDocumentFormResponseDocument, options);
      }
export function useGetEditEndorsementOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditEndorsementOnDocumentFormResponseQuery, GetEditEndorsementOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditEndorsementOnDocumentFormResponseQuery, GetEditEndorsementOnDocumentFormResponseQueryVariables>(GetEditEndorsementOnDocumentFormResponseDocument, options);
        }
export type GetEditEndorsementOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetEditEndorsementOnDocumentFormResponseQuery>;
export type GetEditEndorsementOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditEndorsementOnDocumentFormResponseLazyQuery>;
export type GetEditEndorsementOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetEditEndorsementOnDocumentFormResponseQuery, GetEditEndorsementOnDocumentFormResponseQueryVariables>;
export const GetCreateEndorsementAnswerOnDocumentFormResponseDocument = gql`
    query GetCreateEndorsementAnswerOnDocumentFormResponse($objectId: String!) {
  getCreateEndorsementAnswerOnDocumentFormResponse(objectId: $objectId) {
    formResponseId
    formId
  }
}
    `;

/**
 * __useGetCreateEndorsementAnswerOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreateEndorsementAnswerOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateEndorsementAnswerOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateEndorsementAnswerOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetCreateEndorsementAnswerOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreateEndorsementAnswerOnDocumentFormResponseQuery, GetCreateEndorsementAnswerOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateEndorsementAnswerOnDocumentFormResponseQuery, GetCreateEndorsementAnswerOnDocumentFormResponseQueryVariables>(GetCreateEndorsementAnswerOnDocumentFormResponseDocument, options);
      }
export function useGetCreateEndorsementAnswerOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateEndorsementAnswerOnDocumentFormResponseQuery, GetCreateEndorsementAnswerOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateEndorsementAnswerOnDocumentFormResponseQuery, GetCreateEndorsementAnswerOnDocumentFormResponseQueryVariables>(GetCreateEndorsementAnswerOnDocumentFormResponseDocument, options);
        }
export type GetCreateEndorsementAnswerOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetCreateEndorsementAnswerOnDocumentFormResponseQuery>;
export type GetCreateEndorsementAnswerOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreateEndorsementAnswerOnDocumentFormResponseLazyQuery>;
export type GetCreateEndorsementAnswerOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetCreateEndorsementAnswerOnDocumentFormResponseQuery, GetCreateEndorsementAnswerOnDocumentFormResponseQueryVariables>;
export const GetEditEndorsementAnswerOnDocumentFormResponseDocument = gql`
    query GetEditEndorsementAnswerOnDocumentFormResponse($objectId: String!) {
  getEditEndorsementAnswerOnDocumentFormResponse(objectId: $objectId) {
    formResponseId
    formId
  }
}
    `;

/**
 * __useGetEditEndorsementAnswerOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditEndorsementAnswerOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditEndorsementAnswerOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditEndorsementAnswerOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditEndorsementAnswerOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditEndorsementAnswerOnDocumentFormResponseQuery, GetEditEndorsementAnswerOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditEndorsementAnswerOnDocumentFormResponseQuery, GetEditEndorsementAnswerOnDocumentFormResponseQueryVariables>(GetEditEndorsementAnswerOnDocumentFormResponseDocument, options);
      }
export function useGetEditEndorsementAnswerOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditEndorsementAnswerOnDocumentFormResponseQuery, GetEditEndorsementAnswerOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditEndorsementAnswerOnDocumentFormResponseQuery, GetEditEndorsementAnswerOnDocumentFormResponseQueryVariables>(GetEditEndorsementAnswerOnDocumentFormResponseDocument, options);
        }
export type GetEditEndorsementAnswerOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetEditEndorsementAnswerOnDocumentFormResponseQuery>;
export type GetEditEndorsementAnswerOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditEndorsementAnswerOnDocumentFormResponseLazyQuery>;
export type GetEditEndorsementAnswerOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetEditEndorsementAnswerOnDocumentFormResponseQuery, GetEditEndorsementAnswerOnDocumentFormResponseQueryVariables>;
export const GetFormResponseDocument = gql`
    query GetFormResponse($formResponseId: String!) {
  getFormResponse(formResponseId: $formResponseId) {
    formData
    formState
    errors
  }
}
    `;

/**
 * __useGetFormResponseQuery__
 *
 * To run a query within a React component, call `useGetFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormResponseQuery({
 *   variables: {
 *      formResponseId: // value for 'formResponseId'
 *   },
 * });
 */
export function useGetFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetFormResponseQuery, GetFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormResponseQuery, GetFormResponseQueryVariables>(GetFormResponseDocument, options);
      }
export function useGetFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormResponseQuery, GetFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormResponseQuery, GetFormResponseQueryVariables>(GetFormResponseDocument, options);
        }
export type GetFormResponseQueryHookResult = ReturnType<typeof useGetFormResponseQuery>;
export type GetFormResponseLazyQueryHookResult = ReturnType<typeof useGetFormResponseLazyQuery>;
export type GetFormResponseQueryResult = Apollo.QueryResult<GetFormResponseQuery, GetFormResponseQueryVariables>;
export const GetCreateObjectFormResponseDocument = gql`
    query GetCreateObjectFormResponse($service: Services!, $formId: String!, $payload: JSON!) {
  getCreateObjectFormResponse(
    service: $service
    formId: $formId
    payload: $payload
  )
}
    `;

/**
 * __useGetCreateObjectFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreateObjectFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateObjectFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateObjectFormResponseQuery({
 *   variables: {
 *      service: // value for 'service'
 *      formId: // value for 'formId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useGetCreateObjectFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreateObjectFormResponseQuery, GetCreateObjectFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateObjectFormResponseQuery, GetCreateObjectFormResponseQueryVariables>(GetCreateObjectFormResponseDocument, options);
      }
export function useGetCreateObjectFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateObjectFormResponseQuery, GetCreateObjectFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateObjectFormResponseQuery, GetCreateObjectFormResponseQueryVariables>(GetCreateObjectFormResponseDocument, options);
        }
export type GetCreateObjectFormResponseQueryHookResult = ReturnType<typeof useGetCreateObjectFormResponseQuery>;
export type GetCreateObjectFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreateObjectFormResponseLazyQuery>;
export type GetCreateObjectFormResponseQueryResult = Apollo.QueryResult<GetCreateObjectFormResponseQuery, GetCreateObjectFormResponseQueryVariables>;
export const GetEditObjectFormResponseDocument = gql`
    query GetEditObjectFormResponse($service: Services!, $formId: String!, $objectId: String!, $metadata: JSON) {
  getEditObjectFormResponse(
    service: $service
    formId: $formId
    objectId: $objectId
    metadata: $metadata
  )
}
    `;

/**
 * __useGetEditObjectFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditObjectFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditObjectFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditObjectFormResponseQuery({
 *   variables: {
 *      service: // value for 'service'
 *      formId: // value for 'formId'
 *      objectId: // value for 'objectId'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useGetEditObjectFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditObjectFormResponseQuery, GetEditObjectFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditObjectFormResponseQuery, GetEditObjectFormResponseQueryVariables>(GetEditObjectFormResponseDocument, options);
      }
export function useGetEditObjectFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditObjectFormResponseQuery, GetEditObjectFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditObjectFormResponseQuery, GetEditObjectFormResponseQueryVariables>(GetEditObjectFormResponseDocument, options);
        }
export type GetEditObjectFormResponseQueryHookResult = ReturnType<typeof useGetEditObjectFormResponseQuery>;
export type GetEditObjectFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditObjectFormResponseLazyQuery>;
export type GetEditObjectFormResponseQueryResult = Apollo.QueryResult<GetEditObjectFormResponseQuery, GetEditObjectFormResponseQueryVariables>;
export const GetShareTokenDocument = gql`
    query GetShareToken($service: Services!, $objectId: String!) {
  getShareToken(service: $service, objectId: $objectId)
}
    `;

/**
 * __useGetShareTokenQuery__
 *
 * To run a query within a React component, call `useGetShareTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareTokenQuery({
 *   variables: {
 *      service: // value for 'service'
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetShareTokenQuery(baseOptions: Apollo.QueryHookOptions<GetShareTokenQuery, GetShareTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShareTokenQuery, GetShareTokenQueryVariables>(GetShareTokenDocument, options);
      }
export function useGetShareTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShareTokenQuery, GetShareTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShareTokenQuery, GetShareTokenQueryVariables>(GetShareTokenDocument, options);
        }
export type GetShareTokenQueryHookResult = ReturnType<typeof useGetShareTokenQuery>;
export type GetShareTokenLazyQueryHookResult = ReturnType<typeof useGetShareTokenLazyQuery>;
export type GetShareTokenQueryResult = Apollo.QueryResult<GetShareTokenQuery, GetShareTokenQueryVariables>;
export const GetMany2XOptionsDocument = gql`
    query GetMany2XOptions($serviceName: Services!, $domain: JSON!, $searchTerm: String!, $currentValue: [String]) {
  getMany2XOptions(
    serviceName: $serviceName
    domain: $domain
    searchTerm: $searchTerm
    currentValue: $currentValue
  ) {
    label
    value
  }
}
    `;

/**
 * __useGetMany2XOptionsQuery__
 *
 * To run a query within a React component, call `useGetMany2XOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMany2XOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMany2XOptionsQuery({
 *   variables: {
 *      serviceName: // value for 'serviceName'
 *      domain: // value for 'domain'
 *      searchTerm: // value for 'searchTerm'
 *      currentValue: // value for 'currentValue'
 *   },
 * });
 */
export function useGetMany2XOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetMany2XOptionsQuery, GetMany2XOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMany2XOptionsQuery, GetMany2XOptionsQueryVariables>(GetMany2XOptionsDocument, options);
      }
export function useGetMany2XOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMany2XOptionsQuery, GetMany2XOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMany2XOptionsQuery, GetMany2XOptionsQueryVariables>(GetMany2XOptionsDocument, options);
        }
export type GetMany2XOptionsQueryHookResult = ReturnType<typeof useGetMany2XOptionsQuery>;
export type GetMany2XOptionsLazyQueryHookResult = ReturnType<typeof useGetMany2XOptionsLazyQuery>;
export type GetMany2XOptionsQueryResult = Apollo.QueryResult<GetMany2XOptionsQuery, GetMany2XOptionsQueryVariables>;
export const GetFormResponseV2Document = gql`
    query getFormResponseV2($formResponseId: String!) {
  getFormResponseV2(formResponseId: $formResponseId) {
    id
    title
    sections {
      id
      title
      subtitle
      description
      submitText
      fields {
        ...FieldDetails
        fields {
          ...FieldDetails
          fields {
            ...FieldDetails
            fields {
              ...FieldDetails
              fields {
                ...FieldDetails
              }
            }
          }
        }
      }
    }
  }
}
    ${FieldDetailsFragmentDoc}`;

/**
 * __useGetFormResponseV2Query__
 *
 * To run a query within a React component, call `useGetFormResponseV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetFormResponseV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormResponseV2Query({
 *   variables: {
 *      formResponseId: // value for 'formResponseId'
 *   },
 * });
 */
export function useGetFormResponseV2Query(baseOptions: Apollo.QueryHookOptions<GetFormResponseV2Query, GetFormResponseV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormResponseV2Query, GetFormResponseV2QueryVariables>(GetFormResponseV2Document, options);
      }
export function useGetFormResponseV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormResponseV2Query, GetFormResponseV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormResponseV2Query, GetFormResponseV2QueryVariables>(GetFormResponseV2Document, options);
        }
export type GetFormResponseV2QueryHookResult = ReturnType<typeof useGetFormResponseV2Query>;
export type GetFormResponseV2LazyQueryHookResult = ReturnType<typeof useGetFormResponseV2LazyQuery>;
export type GetFormResponseV2QueryResult = Apollo.QueryResult<GetFormResponseV2Query, GetFormResponseV2QueryVariables>;
export const GetCreateInspectionOnFormResponseDocument = gql`
    query GetCreateInspectionOnFormResponse($documentId: String!) {
  getCreateInspectionOnFormResponse(documentId: $documentId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetCreateInspectionOnFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreateInspectionOnFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateInspectionOnFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateInspectionOnFormResponseQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetCreateInspectionOnFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreateInspectionOnFormResponseQuery, GetCreateInspectionOnFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateInspectionOnFormResponseQuery, GetCreateInspectionOnFormResponseQueryVariables>(GetCreateInspectionOnFormResponseDocument, options);
      }
export function useGetCreateInspectionOnFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateInspectionOnFormResponseQuery, GetCreateInspectionOnFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateInspectionOnFormResponseQuery, GetCreateInspectionOnFormResponseQueryVariables>(GetCreateInspectionOnFormResponseDocument, options);
        }
export type GetCreateInspectionOnFormResponseQueryHookResult = ReturnType<typeof useGetCreateInspectionOnFormResponseQuery>;
export type GetCreateInspectionOnFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreateInspectionOnFormResponseLazyQuery>;
export type GetCreateInspectionOnFormResponseQueryResult = Apollo.QueryResult<GetCreateInspectionOnFormResponseQuery, GetCreateInspectionOnFormResponseQueryVariables>;
export const GetEditInspectionOnFormResponseDocument = gql`
    query GetEditInspectionOnFormResponse($objectId: String!, $documentId: String!) {
  getEditInspectionOnFormResponse(objectId: $objectId, documentId: $documentId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditInspectionOnFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditInspectionOnFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditInspectionOnFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditInspectionOnFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetEditInspectionOnFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditInspectionOnFormResponseQuery, GetEditInspectionOnFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditInspectionOnFormResponseQuery, GetEditInspectionOnFormResponseQueryVariables>(GetEditInspectionOnFormResponseDocument, options);
      }
export function useGetEditInspectionOnFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditInspectionOnFormResponseQuery, GetEditInspectionOnFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditInspectionOnFormResponseQuery, GetEditInspectionOnFormResponseQueryVariables>(GetEditInspectionOnFormResponseDocument, options);
        }
export type GetEditInspectionOnFormResponseQueryHookResult = ReturnType<typeof useGetEditInspectionOnFormResponseQuery>;
export type GetEditInspectionOnFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditInspectionOnFormResponseLazyQuery>;
export type GetEditInspectionOnFormResponseQueryResult = Apollo.QueryResult<GetEditInspectionOnFormResponseQuery, GetEditInspectionOnFormResponseQueryVariables>;
export const GetEditReportFileOnInspectionDocument = gql`
    query GetEditReportFileOnInspection($objectId: String!) {
  getEditReportFileOnInspection(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditReportFileOnInspectionQuery__
 *
 * To run a query within a React component, call `useGetEditReportFileOnInspectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditReportFileOnInspectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditReportFileOnInspectionQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditReportFileOnInspectionQuery(baseOptions: Apollo.QueryHookOptions<GetEditReportFileOnInspectionQuery, GetEditReportFileOnInspectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditReportFileOnInspectionQuery, GetEditReportFileOnInspectionQueryVariables>(GetEditReportFileOnInspectionDocument, options);
      }
export function useGetEditReportFileOnInspectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditReportFileOnInspectionQuery, GetEditReportFileOnInspectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditReportFileOnInspectionQuery, GetEditReportFileOnInspectionQueryVariables>(GetEditReportFileOnInspectionDocument, options);
        }
export type GetEditReportFileOnInspectionQueryHookResult = ReturnType<typeof useGetEditReportFileOnInspectionQuery>;
export type GetEditReportFileOnInspectionLazyQueryHookResult = ReturnType<typeof useGetEditReportFileOnInspectionLazyQuery>;
export type GetEditReportFileOnInspectionQueryResult = Apollo.QueryResult<GetEditReportFileOnInspectionQuery, GetEditReportFileOnInspectionQueryVariables>;
export const GetSwissIntegrationSettingsDocument = gql`
    query GetSwissIntegrationSettings($provider: PropostaProviders!) {
  integrationSettings(provider: $provider) {
    _id
    culture {
      name
    }
    swiss {
      productCode
      systemCode
      soilTypeCode
      valRiscoNomeado
      valSaca
      plantDate
    }
  }
}
    `;

/**
 * __useGetSwissIntegrationSettingsQuery__
 *
 * To run a query within a React component, call `useGetSwissIntegrationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSwissIntegrationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSwissIntegrationSettingsQuery({
 *   variables: {
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useGetSwissIntegrationSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetSwissIntegrationSettingsQuery, GetSwissIntegrationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSwissIntegrationSettingsQuery, GetSwissIntegrationSettingsQueryVariables>(GetSwissIntegrationSettingsDocument, options);
      }
export function useGetSwissIntegrationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSwissIntegrationSettingsQuery, GetSwissIntegrationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSwissIntegrationSettingsQuery, GetSwissIntegrationSettingsQueryVariables>(GetSwissIntegrationSettingsDocument, options);
        }
export type GetSwissIntegrationSettingsQueryHookResult = ReturnType<typeof useGetSwissIntegrationSettingsQuery>;
export type GetSwissIntegrationSettingsLazyQueryHookResult = ReturnType<typeof useGetSwissIntegrationSettingsLazyQuery>;
export type GetSwissIntegrationSettingsQueryResult = Apollo.QueryResult<GetSwissIntegrationSettingsQuery, GetSwissIntegrationSettingsQueryVariables>;
export const GetSwissStateIntegrationSettingsDocument = gql`
    query GetSwissStateIntegrationSettings($settingId: String!) {
  integrationSetting(settingId: $settingId) {
    _id
    swiss {
      stateSettings {
        states
        valCusteio
      }
    }
  }
}
    `;

/**
 * __useGetSwissStateIntegrationSettingsQuery__
 *
 * To run a query within a React component, call `useGetSwissStateIntegrationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSwissStateIntegrationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSwissStateIntegrationSettingsQuery({
 *   variables: {
 *      settingId: // value for 'settingId'
 *   },
 * });
 */
export function useGetSwissStateIntegrationSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetSwissStateIntegrationSettingsQuery, GetSwissStateIntegrationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSwissStateIntegrationSettingsQuery, GetSwissStateIntegrationSettingsQueryVariables>(GetSwissStateIntegrationSettingsDocument, options);
      }
export function useGetSwissStateIntegrationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSwissStateIntegrationSettingsQuery, GetSwissStateIntegrationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSwissStateIntegrationSettingsQuery, GetSwissStateIntegrationSettingsQueryVariables>(GetSwissStateIntegrationSettingsDocument, options);
        }
export type GetSwissStateIntegrationSettingsQueryHookResult = ReturnType<typeof useGetSwissStateIntegrationSettingsQuery>;
export type GetSwissStateIntegrationSettingsLazyQueryHookResult = ReturnType<typeof useGetSwissStateIntegrationSettingsLazyQuery>;
export type GetSwissStateIntegrationSettingsQueryResult = Apollo.QueryResult<GetSwissStateIntegrationSettingsQuery, GetSwissStateIntegrationSettingsQueryVariables>;
export const GetCreateIntegrationSettingsFormResponseDocument = gql`
    query GetCreateIntegrationSettingsFormResponse($formId: String!, $cultureId: String) {
  getCreateIntegrationSettingsFormResponse(formId: $formId, cultureId: $cultureId) {
    formResponseId
    formId
  }
}
    `;

/**
 * __useGetCreateIntegrationSettingsFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreateIntegrationSettingsFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateIntegrationSettingsFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateIntegrationSettingsFormResponseQuery({
 *   variables: {
 *      formId: // value for 'formId'
 *      cultureId: // value for 'cultureId'
 *   },
 * });
 */
export function useGetCreateIntegrationSettingsFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreateIntegrationSettingsFormResponseQuery, GetCreateIntegrationSettingsFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateIntegrationSettingsFormResponseQuery, GetCreateIntegrationSettingsFormResponseQueryVariables>(GetCreateIntegrationSettingsFormResponseDocument, options);
      }
export function useGetCreateIntegrationSettingsFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateIntegrationSettingsFormResponseQuery, GetCreateIntegrationSettingsFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateIntegrationSettingsFormResponseQuery, GetCreateIntegrationSettingsFormResponseQueryVariables>(GetCreateIntegrationSettingsFormResponseDocument, options);
        }
export type GetCreateIntegrationSettingsFormResponseQueryHookResult = ReturnType<typeof useGetCreateIntegrationSettingsFormResponseQuery>;
export type GetCreateIntegrationSettingsFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreateIntegrationSettingsFormResponseLazyQuery>;
export type GetCreateIntegrationSettingsFormResponseQueryResult = Apollo.QueryResult<GetCreateIntegrationSettingsFormResponseQuery, GetCreateIntegrationSettingsFormResponseQueryVariables>;
export const GetEditIntegrationSettingsFormResponseDocument = gql`
    query GetEditIntegrationSettingsFormResponse($formId: String!, $objectId: String!, $listIndex: Float) {
  getEditIntegrationSettingsFormResponse(
    formId: $formId
    objectId: $objectId
    listIndex: $listIndex
  ) {
    formResponseId
    formId
  }
}
    `;

/**
 * __useGetEditIntegrationSettingsFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditIntegrationSettingsFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditIntegrationSettingsFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditIntegrationSettingsFormResponseQuery({
 *   variables: {
 *      formId: // value for 'formId'
 *      objectId: // value for 'objectId'
 *      listIndex: // value for 'listIndex'
 *   },
 * });
 */
export function useGetEditIntegrationSettingsFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditIntegrationSettingsFormResponseQuery, GetEditIntegrationSettingsFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditIntegrationSettingsFormResponseQuery, GetEditIntegrationSettingsFormResponseQueryVariables>(GetEditIntegrationSettingsFormResponseDocument, options);
      }
export function useGetEditIntegrationSettingsFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditIntegrationSettingsFormResponseQuery, GetEditIntegrationSettingsFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditIntegrationSettingsFormResponseQuery, GetEditIntegrationSettingsFormResponseQueryVariables>(GetEditIntegrationSettingsFormResponseDocument, options);
        }
export type GetEditIntegrationSettingsFormResponseQueryHookResult = ReturnType<typeof useGetEditIntegrationSettingsFormResponseQuery>;
export type GetEditIntegrationSettingsFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditIntegrationSettingsFormResponseLazyQuery>;
export type GetEditIntegrationSettingsFormResponseQueryResult = Apollo.QueryResult<GetEditIntegrationSettingsFormResponseQuery, GetEditIntegrationSettingsFormResponseQueryVariables>;
export const ListLeadsDocument = gql`
    query listLeads($filter: [[LeadFiltersInput]]!, $skip: Int, $limit: Int) {
  leads(filter: $filter, skip: $skip, limit: $limit) {
    _id
    area
    address {
      city
      state
      cep
    }
    type
    status
    name
    createdAt
    rating
    cultures {
      _id
      name
    }
  }
}
    `;

/**
 * __useListLeadsQuery__
 *
 * To run a query within a React component, call `useListLeadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLeadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLeadsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListLeadsQuery(baseOptions: Apollo.QueryHookOptions<ListLeadsQuery, ListLeadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListLeadsQuery, ListLeadsQueryVariables>(ListLeadsDocument, options);
      }
export function useListLeadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLeadsQuery, ListLeadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListLeadsQuery, ListLeadsQueryVariables>(ListLeadsDocument, options);
        }
export type ListLeadsQueryHookResult = ReturnType<typeof useListLeadsQuery>;
export type ListLeadsLazyQueryHookResult = ReturnType<typeof useListLeadsLazyQuery>;
export type ListLeadsQueryResult = Apollo.QueryResult<ListLeadsQuery, ListLeadsQueryVariables>;
export const CountLeadsDocument = gql`
    query CountLeads($filter: [[LeadFiltersInput]]!) {
  countLeads(filter: $filter)
}
    `;

/**
 * __useCountLeadsQuery__
 *
 * To run a query within a React component, call `useCountLeadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountLeadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountLeadsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCountLeadsQuery(baseOptions: Apollo.QueryHookOptions<CountLeadsQuery, CountLeadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountLeadsQuery, CountLeadsQueryVariables>(CountLeadsDocument, options);
      }
export function useCountLeadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountLeadsQuery, CountLeadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountLeadsQuery, CountLeadsQueryVariables>(CountLeadsDocument, options);
        }
export type CountLeadsQueryHookResult = ReturnType<typeof useCountLeadsQuery>;
export type CountLeadsLazyQueryHookResult = ReturnType<typeof useCountLeadsLazyQuery>;
export type CountLeadsQueryResult = Apollo.QueryResult<CountLeadsQuery, CountLeadsQueryVariables>;
export const GetLeadDetailsDocument = gql`
    query GetLeadDetails($leadId: String!) {
  lead(leadId: $leadId) {
    _id
    type
    status
    name
    area
    address {
      city
      state
      street
    }
    comments
    createdAt
    email
    linkedin
    phone
    rating
    commercialResponsibleId
    technicalResponsibleId
    cultures {
      _id
      name
    }
    meetings {
      _id
      status
      responsible {
        contact {
          name
        }
      }
      date
      topic
      comment
      attachment
    }
  }
}
    `;

/**
 * __useGetLeadDetailsQuery__
 *
 * To run a query within a React component, call `useGetLeadDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadDetailsQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */
export function useGetLeadDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetLeadDetailsQuery, GetLeadDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeadDetailsQuery, GetLeadDetailsQueryVariables>(GetLeadDetailsDocument, options);
      }
export function useGetLeadDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeadDetailsQuery, GetLeadDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeadDetailsQuery, GetLeadDetailsQueryVariables>(GetLeadDetailsDocument, options);
        }
export type GetLeadDetailsQueryHookResult = ReturnType<typeof useGetLeadDetailsQuery>;
export type GetLeadDetailsLazyQueryHookResult = ReturnType<typeof useGetLeadDetailsLazyQuery>;
export type GetLeadDetailsQueryResult = Apollo.QueryResult<GetLeadDetailsQuery, GetLeadDetailsQueryVariables>;
export const GetEditLeadOnFormResponseDocument = gql`
    query GetEditLeadOnFormResponse($objectId: String!) {
  getEditLeadOnFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditLeadOnFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditLeadOnFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditLeadOnFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditLeadOnFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditLeadOnFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditLeadOnFormResponseQuery, GetEditLeadOnFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditLeadOnFormResponseQuery, GetEditLeadOnFormResponseQueryVariables>(GetEditLeadOnFormResponseDocument, options);
      }
export function useGetEditLeadOnFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditLeadOnFormResponseQuery, GetEditLeadOnFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditLeadOnFormResponseQuery, GetEditLeadOnFormResponseQueryVariables>(GetEditLeadOnFormResponseDocument, options);
        }
export type GetEditLeadOnFormResponseQueryHookResult = ReturnType<typeof useGetEditLeadOnFormResponseQuery>;
export type GetEditLeadOnFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditLeadOnFormResponseLazyQuery>;
export type GetEditLeadOnFormResponseQueryResult = Apollo.QueryResult<GetEditLeadOnFormResponseQuery, GetEditLeadOnFormResponseQueryVariables>;
export const GetCreateMeetingOnObjectFormResponseDocument = gql`
    query GetCreateMeetingOnObjectFormResponse($parentId: String!, $serviceName: Services!) {
  getCreateMeetingOnObjectFormResponse(
    parentId: $parentId
    serviceName: $serviceName
  ) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetCreateMeetingOnObjectFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreateMeetingOnObjectFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateMeetingOnObjectFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateMeetingOnObjectFormResponseQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *      serviceName: // value for 'serviceName'
 *   },
 * });
 */
export function useGetCreateMeetingOnObjectFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreateMeetingOnObjectFormResponseQuery, GetCreateMeetingOnObjectFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateMeetingOnObjectFormResponseQuery, GetCreateMeetingOnObjectFormResponseQueryVariables>(GetCreateMeetingOnObjectFormResponseDocument, options);
      }
export function useGetCreateMeetingOnObjectFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateMeetingOnObjectFormResponseQuery, GetCreateMeetingOnObjectFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateMeetingOnObjectFormResponseQuery, GetCreateMeetingOnObjectFormResponseQueryVariables>(GetCreateMeetingOnObjectFormResponseDocument, options);
        }
export type GetCreateMeetingOnObjectFormResponseQueryHookResult = ReturnType<typeof useGetCreateMeetingOnObjectFormResponseQuery>;
export type GetCreateMeetingOnObjectFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreateMeetingOnObjectFormResponseLazyQuery>;
export type GetCreateMeetingOnObjectFormResponseQueryResult = Apollo.QueryResult<GetCreateMeetingOnObjectFormResponseQuery, GetCreateMeetingOnObjectFormResponseQueryVariables>;
export const GetEditMeetingOnObjectFormResponseDocument = gql`
    query GetEditMeetingOnObjectFormResponse($objectId: String!) {
  getEditMeetingOnObjectFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditMeetingOnObjectFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditMeetingOnObjectFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditMeetingOnObjectFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditMeetingOnObjectFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditMeetingOnObjectFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditMeetingOnObjectFormResponseQuery, GetEditMeetingOnObjectFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditMeetingOnObjectFormResponseQuery, GetEditMeetingOnObjectFormResponseQueryVariables>(GetEditMeetingOnObjectFormResponseDocument, options);
      }
export function useGetEditMeetingOnObjectFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditMeetingOnObjectFormResponseQuery, GetEditMeetingOnObjectFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditMeetingOnObjectFormResponseQuery, GetEditMeetingOnObjectFormResponseQueryVariables>(GetEditMeetingOnObjectFormResponseDocument, options);
        }
export type GetEditMeetingOnObjectFormResponseQueryHookResult = ReturnType<typeof useGetEditMeetingOnObjectFormResponseQuery>;
export type GetEditMeetingOnObjectFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditMeetingOnObjectFormResponseLazyQuery>;
export type GetEditMeetingOnObjectFormResponseQueryResult = Apollo.QueryResult<GetEditMeetingOnObjectFormResponseQuery, GetEditMeetingOnObjectFormResponseQueryVariables>;
export const NotesDocument = gql`
    query Notes($docId: String!, $serviceName: Services!) {
  notes(docId: $docId, serviceName: $serviceName) {
    text
    createdAt
    serviceName
    authorId {
      name
    }
  }
}
    `;

/**
 * __useNotesQuery__
 *
 * To run a query within a React component, call `useNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotesQuery({
 *   variables: {
 *      docId: // value for 'docId'
 *      serviceName: // value for 'serviceName'
 *   },
 * });
 */
export function useNotesQuery(baseOptions: Apollo.QueryHookOptions<NotesQuery, NotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotesQuery, NotesQueryVariables>(NotesDocument, options);
      }
export function useNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotesQuery, NotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotesQuery, NotesQueryVariables>(NotesDocument, options);
        }
export type NotesQueryHookResult = ReturnType<typeof useNotesQuery>;
export type NotesLazyQueryHookResult = ReturnType<typeof useNotesLazyQuery>;
export type NotesQueryResult = Apollo.QueryResult<NotesQuery, NotesQueryVariables>;
export const NotificationsDocument = gql`
    query Notifications($serviceName: Services!) {
  notifications(serviceName: $serviceName) {
    notificationDate
    dateNotifications {
      notificationGroup
      groupNotifications {
        objectId
        serviceName
        createdAt
        text
        originInfo
        author {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *      serviceName: // value for 'serviceName'
 *   },
 * });
 */
export function useNotificationsQuery(baseOptions: Apollo.QueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
      }
export function useNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export type NotificationsQueryHookResult = ReturnType<typeof useNotificationsQuery>;
export type NotificationsLazyQueryHookResult = ReturnType<typeof useNotificationsLazyQuery>;
export type NotificationsQueryResult = Apollo.QueryResult<NotificationsQuery, NotificationsQueryVariables>;
export const GetCreatePaymentOnDocumentFormResponseDocument = gql`
    query GetCreatePaymentOnDocumentFormResponse($documentId: String!) {
  getCreatePaymentOnDocumentFormResponse(documentId: $documentId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetCreatePaymentOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreatePaymentOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatePaymentOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatePaymentOnDocumentFormResponseQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetCreatePaymentOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreatePaymentOnDocumentFormResponseQuery, GetCreatePaymentOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreatePaymentOnDocumentFormResponseQuery, GetCreatePaymentOnDocumentFormResponseQueryVariables>(GetCreatePaymentOnDocumentFormResponseDocument, options);
      }
export function useGetCreatePaymentOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreatePaymentOnDocumentFormResponseQuery, GetCreatePaymentOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreatePaymentOnDocumentFormResponseQuery, GetCreatePaymentOnDocumentFormResponseQueryVariables>(GetCreatePaymentOnDocumentFormResponseDocument, options);
        }
export type GetCreatePaymentOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetCreatePaymentOnDocumentFormResponseQuery>;
export type GetCreatePaymentOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreatePaymentOnDocumentFormResponseLazyQuery>;
export type GetCreatePaymentOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetCreatePaymentOnDocumentFormResponseQuery, GetCreatePaymentOnDocumentFormResponseQueryVariables>;
export const GetEditPaymentOnDocumentFormResponseDocument = gql`
    query GetEditPaymentOnDocumentFormResponse($objectId: String!) {
  getEditPaymentOnDocumentFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditPaymentOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditPaymentOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditPaymentOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditPaymentOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditPaymentOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditPaymentOnDocumentFormResponseQuery, GetEditPaymentOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditPaymentOnDocumentFormResponseQuery, GetEditPaymentOnDocumentFormResponseQueryVariables>(GetEditPaymentOnDocumentFormResponseDocument, options);
      }
export function useGetEditPaymentOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditPaymentOnDocumentFormResponseQuery, GetEditPaymentOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditPaymentOnDocumentFormResponseQuery, GetEditPaymentOnDocumentFormResponseQueryVariables>(GetEditPaymentOnDocumentFormResponseDocument, options);
        }
export type GetEditPaymentOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetEditPaymentOnDocumentFormResponseQuery>;
export type GetEditPaymentOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditPaymentOnDocumentFormResponseLazyQuery>;
export type GetEditPaymentOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetEditPaymentOnDocumentFormResponseQuery, GetEditPaymentOnDocumentFormResponseQueryVariables>;
export const ListPaymentsDocument = gql`
    query ListPayments($filter: PaymentsFiltersInput!) {
  payments(filter: $filter) {
    _id
    documentId
    name
    amount
    dateDue
    status
  }
}
    `;

/**
 * __useListPaymentsQuery__
 *
 * To run a query within a React component, call `useListPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPaymentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListPaymentsQuery(baseOptions: Apollo.QueryHookOptions<ListPaymentsQuery, ListPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPaymentsQuery, ListPaymentsQueryVariables>(ListPaymentsDocument, options);
      }
export function useListPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPaymentsQuery, ListPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPaymentsQuery, ListPaymentsQueryVariables>(ListPaymentsDocument, options);
        }
export type ListPaymentsQueryHookResult = ReturnType<typeof useListPaymentsQuery>;
export type ListPaymentsLazyQueryHookResult = ReturnType<typeof useListPaymentsLazyQuery>;
export type ListPaymentsQueryResult = Apollo.QueryResult<ListPaymentsQuery, ListPaymentsQueryVariables>;
export const GetCreatePolicyOnDocumentFormResponseDocument = gql`
    query GetCreatePolicyOnDocumentFormResponse($documentId: String!) {
  getCreatePolicyOnDocumentFormResponse(documentId: $documentId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetCreatePolicyOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreatePolicyOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatePolicyOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatePolicyOnDocumentFormResponseQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetCreatePolicyOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreatePolicyOnDocumentFormResponseQuery, GetCreatePolicyOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreatePolicyOnDocumentFormResponseQuery, GetCreatePolicyOnDocumentFormResponseQueryVariables>(GetCreatePolicyOnDocumentFormResponseDocument, options);
      }
export function useGetCreatePolicyOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreatePolicyOnDocumentFormResponseQuery, GetCreatePolicyOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreatePolicyOnDocumentFormResponseQuery, GetCreatePolicyOnDocumentFormResponseQueryVariables>(GetCreatePolicyOnDocumentFormResponseDocument, options);
        }
export type GetCreatePolicyOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetCreatePolicyOnDocumentFormResponseQuery>;
export type GetCreatePolicyOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreatePolicyOnDocumentFormResponseLazyQuery>;
export type GetCreatePolicyOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetCreatePolicyOnDocumentFormResponseQuery, GetCreatePolicyOnDocumentFormResponseQueryVariables>;
export const GetEditPolicyOnDocumentFormResponseDocument = gql`
    query GetEditPolicyOnDocumentFormResponse($objectId: String!) {
  getEditPolicyOnDocumentFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditPolicyOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditPolicyOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditPolicyOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditPolicyOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditPolicyOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditPolicyOnDocumentFormResponseQuery, GetEditPolicyOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditPolicyOnDocumentFormResponseQuery, GetEditPolicyOnDocumentFormResponseQueryVariables>(GetEditPolicyOnDocumentFormResponseDocument, options);
      }
export function useGetEditPolicyOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditPolicyOnDocumentFormResponseQuery, GetEditPolicyOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditPolicyOnDocumentFormResponseQuery, GetEditPolicyOnDocumentFormResponseQueryVariables>(GetEditPolicyOnDocumentFormResponseDocument, options);
        }
export type GetEditPolicyOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetEditPolicyOnDocumentFormResponseQuery>;
export type GetEditPolicyOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditPolicyOnDocumentFormResponseLazyQuery>;
export type GetEditPolicyOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetEditPolicyOnDocumentFormResponseQuery, GetEditPolicyOnDocumentFormResponseQueryVariables>;
export const GetEditBillsOnDocumentFormResponseDocument = gql`
    query GetEditBillsOnDocumentFormResponse($objectId: String!) {
  getEditBillsOnDocumentFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditBillsOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditBillsOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditBillsOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditBillsOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditBillsOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditBillsOnDocumentFormResponseQuery, GetEditBillsOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditBillsOnDocumentFormResponseQuery, GetEditBillsOnDocumentFormResponseQueryVariables>(GetEditBillsOnDocumentFormResponseDocument, options);
      }
export function useGetEditBillsOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditBillsOnDocumentFormResponseQuery, GetEditBillsOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditBillsOnDocumentFormResponseQuery, GetEditBillsOnDocumentFormResponseQueryVariables>(GetEditBillsOnDocumentFormResponseDocument, options);
        }
export type GetEditBillsOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetEditBillsOnDocumentFormResponseQuery>;
export type GetEditBillsOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditBillsOnDocumentFormResponseLazyQuery>;
export type GetEditBillsOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetEditBillsOnDocumentFormResponseQuery, GetEditBillsOnDocumentFormResponseQueryVariables>;
export const GetCancelPolicyOnDocumentFormResponseDocument = gql`
    query GetCancelPolicyOnDocumentFormResponse($objectId: String!, $documentId: String!) {
  getCancelPolicyOnDocumentFormResponse(
    objectId: $objectId
    documentId: $documentId
  ) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetCancelPolicyOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCancelPolicyOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCancelPolicyOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCancelPolicyOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetCancelPolicyOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCancelPolicyOnDocumentFormResponseQuery, GetCancelPolicyOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCancelPolicyOnDocumentFormResponseQuery, GetCancelPolicyOnDocumentFormResponseQueryVariables>(GetCancelPolicyOnDocumentFormResponseDocument, options);
      }
export function useGetCancelPolicyOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCancelPolicyOnDocumentFormResponseQuery, GetCancelPolicyOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCancelPolicyOnDocumentFormResponseQuery, GetCancelPolicyOnDocumentFormResponseQueryVariables>(GetCancelPolicyOnDocumentFormResponseDocument, options);
        }
export type GetCancelPolicyOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetCancelPolicyOnDocumentFormResponseQuery>;
export type GetCancelPolicyOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetCancelPolicyOnDocumentFormResponseLazyQuery>;
export type GetCancelPolicyOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetCancelPolicyOnDocumentFormResponseQuery, GetCancelPolicyOnDocumentFormResponseQueryVariables>;
export const GetEditPropertyOnDocumentFormResponseDocument = gql`
    query GetEditPropertyOnDocumentFormResponse($objectId: String!, $documentId: String!) {
  getEditPropertyOnDocumentFormResponse(
    objectId: $objectId
    documentId: $documentId
  ) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditPropertyOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditPropertyOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditPropertyOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditPropertyOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetEditPropertyOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditPropertyOnDocumentFormResponseQuery, GetEditPropertyOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditPropertyOnDocumentFormResponseQuery, GetEditPropertyOnDocumentFormResponseQueryVariables>(GetEditPropertyOnDocumentFormResponseDocument, options);
      }
export function useGetEditPropertyOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditPropertyOnDocumentFormResponseQuery, GetEditPropertyOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditPropertyOnDocumentFormResponseQuery, GetEditPropertyOnDocumentFormResponseQueryVariables>(GetEditPropertyOnDocumentFormResponseDocument, options);
        }
export type GetEditPropertyOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetEditPropertyOnDocumentFormResponseQuery>;
export type GetEditPropertyOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditPropertyOnDocumentFormResponseLazyQuery>;
export type GetEditPropertyOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetEditPropertyOnDocumentFormResponseQuery, GetEditPropertyOnDocumentFormResponseQueryVariables>;
export const GetCreateProposalOnDocumentFormResponseDocument = gql`
    query GetCreateProposalOnDocumentFormResponse($documentId: String!) {
  getCreateProposalOnDocumentFormResponse(documentId: $documentId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetCreateProposalOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreateProposalOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateProposalOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateProposalOnDocumentFormResponseQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetCreateProposalOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreateProposalOnDocumentFormResponseQuery, GetCreateProposalOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateProposalOnDocumentFormResponseQuery, GetCreateProposalOnDocumentFormResponseQueryVariables>(GetCreateProposalOnDocumentFormResponseDocument, options);
      }
export function useGetCreateProposalOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateProposalOnDocumentFormResponseQuery, GetCreateProposalOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateProposalOnDocumentFormResponseQuery, GetCreateProposalOnDocumentFormResponseQueryVariables>(GetCreateProposalOnDocumentFormResponseDocument, options);
        }
export type GetCreateProposalOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetCreateProposalOnDocumentFormResponseQuery>;
export type GetCreateProposalOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreateProposalOnDocumentFormResponseLazyQuery>;
export type GetCreateProposalOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetCreateProposalOnDocumentFormResponseQuery, GetCreateProposalOnDocumentFormResponseQueryVariables>;
export const GetCreateResultOnDocumentFormResponseDocument = gql`
    query GetCreateResultOnDocumentFormResponse($documentId: String!) {
  getCreateResultOnDocumentFormResponse(documentId: $documentId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetCreateResultOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreateResultOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateResultOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateResultOnDocumentFormResponseQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetCreateResultOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreateResultOnDocumentFormResponseQuery, GetCreateResultOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateResultOnDocumentFormResponseQuery, GetCreateResultOnDocumentFormResponseQueryVariables>(GetCreateResultOnDocumentFormResponseDocument, options);
      }
export function useGetCreateResultOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateResultOnDocumentFormResponseQuery, GetCreateResultOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateResultOnDocumentFormResponseQuery, GetCreateResultOnDocumentFormResponseQueryVariables>(GetCreateResultOnDocumentFormResponseDocument, options);
        }
export type GetCreateResultOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetCreateResultOnDocumentFormResponseQuery>;
export type GetCreateResultOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreateResultOnDocumentFormResponseLazyQuery>;
export type GetCreateResultOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetCreateResultOnDocumentFormResponseQuery, GetCreateResultOnDocumentFormResponseQueryVariables>;
export const GetEditProposalOnDocumentFormResponseDocument = gql`
    query GetEditProposalOnDocumentFormResponse($objectId: String!) {
  getEditProposalOnDocumentFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditProposalOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditProposalOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditProposalOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditProposalOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditProposalOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditProposalOnDocumentFormResponseQuery, GetEditProposalOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditProposalOnDocumentFormResponseQuery, GetEditProposalOnDocumentFormResponseQueryVariables>(GetEditProposalOnDocumentFormResponseDocument, options);
      }
export function useGetEditProposalOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditProposalOnDocumentFormResponseQuery, GetEditProposalOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditProposalOnDocumentFormResponseQuery, GetEditProposalOnDocumentFormResponseQueryVariables>(GetEditProposalOnDocumentFormResponseDocument, options);
        }
export type GetEditProposalOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetEditProposalOnDocumentFormResponseQuery>;
export type GetEditProposalOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditProposalOnDocumentFormResponseLazyQuery>;
export type GetEditProposalOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetEditProposalOnDocumentFormResponseQuery, GetEditProposalOnDocumentFormResponseQueryVariables>;
export const GetEditResultOnDocumentFormResponseDocument = gql`
    query GetEditResultOnDocumentFormResponse($objectId: String!) {
  getEditResultOnDocumentFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditResultOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditResultOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditResultOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditResultOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditResultOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditResultOnDocumentFormResponseQuery, GetEditResultOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditResultOnDocumentFormResponseQuery, GetEditResultOnDocumentFormResponseQueryVariables>(GetEditResultOnDocumentFormResponseDocument, options);
      }
export function useGetEditResultOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditResultOnDocumentFormResponseQuery, GetEditResultOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditResultOnDocumentFormResponseQuery, GetEditResultOnDocumentFormResponseQueryVariables>(GetEditResultOnDocumentFormResponseDocument, options);
        }
export type GetEditResultOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetEditResultOnDocumentFormResponseQuery>;
export type GetEditResultOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditResultOnDocumentFormResponseLazyQuery>;
export type GetEditResultOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetEditResultOnDocumentFormResponseQuery, GetEditResultOnDocumentFormResponseQueryVariables>;
export const GetCreateSignedProposalOnFormResponseDocument = gql`
    query getCreateSignedProposalOnFormResponse($proposalResultId: String!) {
  getCreateSignedProposalOnFormResponse(proposalResultId: $proposalResultId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetCreateSignedProposalOnFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreateSignedProposalOnFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateSignedProposalOnFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateSignedProposalOnFormResponseQuery({
 *   variables: {
 *      proposalResultId: // value for 'proposalResultId'
 *   },
 * });
 */
export function useGetCreateSignedProposalOnFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreateSignedProposalOnFormResponseQuery, GetCreateSignedProposalOnFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateSignedProposalOnFormResponseQuery, GetCreateSignedProposalOnFormResponseQueryVariables>(GetCreateSignedProposalOnFormResponseDocument, options);
      }
export function useGetCreateSignedProposalOnFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateSignedProposalOnFormResponseQuery, GetCreateSignedProposalOnFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateSignedProposalOnFormResponseQuery, GetCreateSignedProposalOnFormResponseQueryVariables>(GetCreateSignedProposalOnFormResponseDocument, options);
        }
export type GetCreateSignedProposalOnFormResponseQueryHookResult = ReturnType<typeof useGetCreateSignedProposalOnFormResponseQuery>;
export type GetCreateSignedProposalOnFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreateSignedProposalOnFormResponseLazyQuery>;
export type GetCreateSignedProposalOnFormResponseQueryResult = Apollo.QueryResult<GetCreateSignedProposalOnFormResponseQuery, GetCreateSignedProposalOnFormResponseQueryVariables>;
export const GetEditSignedProposalOnFormResponseDocument = gql`
    query GetEditSignedProposalOnFormResponse($objectId: String!) {
  getEditSignedProposalOnFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditSignedProposalOnFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditSignedProposalOnFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditSignedProposalOnFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditSignedProposalOnFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditSignedProposalOnFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditSignedProposalOnFormResponseQuery, GetEditSignedProposalOnFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditSignedProposalOnFormResponseQuery, GetEditSignedProposalOnFormResponseQueryVariables>(GetEditSignedProposalOnFormResponseDocument, options);
      }
export function useGetEditSignedProposalOnFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditSignedProposalOnFormResponseQuery, GetEditSignedProposalOnFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditSignedProposalOnFormResponseQuery, GetEditSignedProposalOnFormResponseQueryVariables>(GetEditSignedProposalOnFormResponseDocument, options);
        }
export type GetEditSignedProposalOnFormResponseQueryHookResult = ReturnType<typeof useGetEditSignedProposalOnFormResponseQuery>;
export type GetEditSignedProposalOnFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditSignedProposalOnFormResponseLazyQuery>;
export type GetEditSignedProposalOnFormResponseQueryResult = Apollo.QueryResult<GetEditSignedProposalOnFormResponseQuery, GetEditSignedProposalOnFormResponseQueryVariables>;
export const ModelTasksDocument = gql`
    query ModelTasks($serviceName: Services!, $objectId: String) {
  modelTasks(serviceName: $serviceName, objectId: $objectId) {
    modelName
    message
    docId
    dateDue
    responsible {
      name
    }
    originInfo
  }
}
    `;

/**
 * __useModelTasksQuery__
 *
 * To run a query within a React component, call `useModelTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelTasksQuery({
 *   variables: {
 *      serviceName: // value for 'serviceName'
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useModelTasksQuery(baseOptions: Apollo.QueryHookOptions<ModelTasksQuery, ModelTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelTasksQuery, ModelTasksQueryVariables>(ModelTasksDocument, options);
      }
export function useModelTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelTasksQuery, ModelTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelTasksQuery, ModelTasksQueryVariables>(ModelTasksDocument, options);
        }
export type ModelTasksQueryHookResult = ReturnType<typeof useModelTasksQuery>;
export type ModelTasksLazyQueryHookResult = ReturnType<typeof useModelTasksLazyQuery>;
export type ModelTasksQueryResult = Apollo.QueryResult<ModelTasksQuery, ModelTasksQueryVariables>;
export const GetTwilioWaMessagesDocument = gql`
    query GetTwilioWAMessages($contactId: String!) {
  getTwilioWAMessages(contactId: $contactId) {
    messages {
      content
      sentAt
      createdAt
      type
      conversationId
      templateName
      _id
      status
      medias {
        fileName
        fileKey
        externalId
      }
    }
    contact {
      _id
      name
      mobilePhone
      twilioConversationId
      tags
    }
    isSubscribed
  }
}
    `;

/**
 * __useGetTwilioWaMessagesQuery__
 *
 * To run a query within a React component, call `useGetTwilioWaMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTwilioWaMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTwilioWaMessagesQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetTwilioWaMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetTwilioWaMessagesQuery, GetTwilioWaMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTwilioWaMessagesQuery, GetTwilioWaMessagesQueryVariables>(GetTwilioWaMessagesDocument, options);
      }
export function useGetTwilioWaMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTwilioWaMessagesQuery, GetTwilioWaMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTwilioWaMessagesQuery, GetTwilioWaMessagesQueryVariables>(GetTwilioWaMessagesDocument, options);
        }
export type GetTwilioWaMessagesQueryHookResult = ReturnType<typeof useGetTwilioWaMessagesQuery>;
export type GetTwilioWaMessagesLazyQueryHookResult = ReturnType<typeof useGetTwilioWaMessagesLazyQuery>;
export type GetTwilioWaMessagesQueryResult = Apollo.QueryResult<GetTwilioWaMessagesQuery, GetTwilioWaMessagesQueryVariables>;
export const GetTwilioMediaUrlDocument = gql`
    query GetTwilioMediaUrl($fileKey: String!) {
  getTwilioMediaUrl(fileKey: $fileKey)
}
    `;

/**
 * __useGetTwilioMediaUrlQuery__
 *
 * To run a query within a React component, call `useGetTwilioMediaUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTwilioMediaUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTwilioMediaUrlQuery({
 *   variables: {
 *      fileKey: // value for 'fileKey'
 *   },
 * });
 */
export function useGetTwilioMediaUrlQuery(baseOptions: Apollo.QueryHookOptions<GetTwilioMediaUrlQuery, GetTwilioMediaUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTwilioMediaUrlQuery, GetTwilioMediaUrlQueryVariables>(GetTwilioMediaUrlDocument, options);
      }
export function useGetTwilioMediaUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTwilioMediaUrlQuery, GetTwilioMediaUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTwilioMediaUrlQuery, GetTwilioMediaUrlQueryVariables>(GetTwilioMediaUrlDocument, options);
        }
export type GetTwilioMediaUrlQueryHookResult = ReturnType<typeof useGetTwilioMediaUrlQuery>;
export type GetTwilioMediaUrlLazyQueryHookResult = ReturnType<typeof useGetTwilioMediaUrlLazyQuery>;
export type GetTwilioMediaUrlQueryResult = Apollo.QueryResult<GetTwilioMediaUrlQuery, GetTwilioMediaUrlQueryVariables>;
export const GetTwilioConversationsDocument = gql`
    query GetTwilioConversations($filter: ConversationsFilterInput!) {
  getTwilioConversations(filter: $filter) {
    lastMsg {
      content
      sentAt
      medias {
        externalId
        fileName
      }
    }
    contact {
      _id
      name
      mobilePhone
    }
    notSeenCount
  }
}
    `;

/**
 * __useGetTwilioConversationsQuery__
 *
 * To run a query within a React component, call `useGetTwilioConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTwilioConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTwilioConversationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetTwilioConversationsQuery(baseOptions: Apollo.QueryHookOptions<GetTwilioConversationsQuery, GetTwilioConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTwilioConversationsQuery, GetTwilioConversationsQueryVariables>(GetTwilioConversationsDocument, options);
      }
export function useGetTwilioConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTwilioConversationsQuery, GetTwilioConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTwilioConversationsQuery, GetTwilioConversationsQueryVariables>(GetTwilioConversationsDocument, options);
        }
export type GetTwilioConversationsQueryHookResult = ReturnType<typeof useGetTwilioConversationsQuery>;
export type GetTwilioConversationsLazyQueryHookResult = ReturnType<typeof useGetTwilioConversationsLazyQuery>;
export type GetTwilioConversationsQueryResult = Apollo.QueryResult<GetTwilioConversationsQuery, GetTwilioConversationsQueryVariables>;
export const CountUsersDocument = gql`
    query CountUsers($filter: [[PartnersFiltersInput]]!) {
  countUsers(filter: $filter)
}
    `;

/**
 * __useCountUsersQuery__
 *
 * To run a query within a React component, call `useCountUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCountUsersQuery(baseOptions: Apollo.QueryHookOptions<CountUsersQuery, CountUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountUsersQuery, CountUsersQueryVariables>(CountUsersDocument, options);
      }
export function useCountUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountUsersQuery, CountUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountUsersQuery, CountUsersQueryVariables>(CountUsersDocument, options);
        }
export type CountUsersQueryHookResult = ReturnType<typeof useCountUsersQuery>;
export type CountUsersLazyQueryHookResult = ReturnType<typeof useCountUsersLazyQuery>;
export type CountUsersQueryResult = Apollo.QueryResult<CountUsersQuery, CountUsersQueryVariables>;
export const GetUserIndicatorsDocument = gql`
    query GetUserIndicators($userId: String!) {
  user(userId: $userId) {
    indicators {
      _id
      totalArea
      totalPremium
      totalCommission
    }
  }
}
    `;

/**
 * __useGetUserIndicatorsQuery__
 *
 * To run a query within a React component, call `useGetUserIndicatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserIndicatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserIndicatorsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserIndicatorsQuery(baseOptions: Apollo.QueryHookOptions<GetUserIndicatorsQuery, GetUserIndicatorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserIndicatorsQuery, GetUserIndicatorsQueryVariables>(GetUserIndicatorsDocument, options);
      }
export function useGetUserIndicatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserIndicatorsQuery, GetUserIndicatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserIndicatorsQuery, GetUserIndicatorsQueryVariables>(GetUserIndicatorsDocument, options);
        }
export type GetUserIndicatorsQueryHookResult = ReturnType<typeof useGetUserIndicatorsQuery>;
export type GetUserIndicatorsLazyQueryHookResult = ReturnType<typeof useGetUserIndicatorsLazyQuery>;
export type GetUserIndicatorsQueryResult = Apollo.QueryResult<GetUserIndicatorsQuery, GetUserIndicatorsQueryVariables>;
export const OnConversationUpdatedDocument = gql`
    subscription OnConversationUpdated {
  conversationUpdated {
    conversationId
    newMsg
  }
}
    `;

/**
 * __useOnConversationUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnConversationUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnConversationUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnConversationUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnConversationUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnConversationUpdatedSubscription, OnConversationUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnConversationUpdatedSubscription, OnConversationUpdatedSubscriptionVariables>(OnConversationUpdatedDocument, options);
      }
export type OnConversationUpdatedSubscriptionHookResult = ReturnType<typeof useOnConversationUpdatedSubscription>;
export type OnConversationUpdatedSubscriptionResult = Apollo.SubscriptionResult<OnConversationUpdatedSubscription>;
export const OnMsgSeenUpdatedDocument = gql`
    subscription OnMsgSeenUpdated {
  msgSeenUpdated {
    userId
  }
}
    `;

/**
 * __useOnMsgSeenUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnMsgSeenUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnMsgSeenUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnMsgSeenUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnMsgSeenUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnMsgSeenUpdatedSubscription, OnMsgSeenUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnMsgSeenUpdatedSubscription, OnMsgSeenUpdatedSubscriptionVariables>(OnMsgSeenUpdatedDocument, options);
      }
export type OnMsgSeenUpdatedSubscriptionHookResult = ReturnType<typeof useOnMsgSeenUpdatedSubscription>;
export type OnMsgSeenUpdatedSubscriptionResult = Apollo.SubscriptionResult<OnMsgSeenUpdatedSubscription>;